/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-ts 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { Method, RequestBodyType, ResponseBodyType, RequestConfig, RequestFunctionRestArgs, FileData, prepare } from '@bigo/yapi-to-ts'
// @ts-ignore
import request from './request';
// @ts-ignore
import makeRequestHook from './makeRequestHook';

// makeRequest
function makeRequest<TReqeustData, TResponseData>(requestConfig) {
  const req = function (
    requestData?: TReqeustData,
    ...args: RequestFunctionRestArgs<typeof request>
  ) {
    return request<TResponseData>(prepare(requestConfig, requestData));
  };
  req.requestConfig = requestConfig;
  return req;
}

const mockUrl_0_0_0_0 = 'http://yapi.ppx520.com/mock/8015' as any;
const dataKey_0_0_0_0 = 'data' as any;

export interface LiveAgentServiceEditAnchorPolicyRequest {
  /**
   * 12345
   */
  seq_id: number;
  /**
   * [{"uid":1600016506,"proxy_uid":10001,"country":"US","support_time":"2024-12","grading_label":"0","service_percent":15.5},{"uid":1600016507,"proxy_uid":0,"country":"SG","support_time":"","grading_label":"T1","service_percent":20.11}]
   */
  items: {
    /**
     * 1600016506
     */
    uid: number;
    /**
     * 10001
     */
    proxy_uid: number;
    /**
     * "US"
     */
    country: string;
    /**
     * "2024-12"
     */
    support_time: string;
    /**
     * "0"
     */
    grading_label: string;
    /**
     * 15.5
     */
    service_percent: number;
  }[];
  /**
   * 123456789
   */
  policy_id: number;
  /**
   * "POLICY-2024-001"
   */
  policy_code: string;
  /**
   * "2024年度政策"
   */
  policy_name: string;
  /**
   * 1
   */
  policy_show: number;
  /**
   * "admin"
   */
  username: string;
}

export interface LiveAgentServiceEditAnchorPolicyResponse {
  seq_id: number;
  code: number;
  message: string;
}
type LiveAgentServiceEditAnchorPolicyRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/EditAnchorPolicy',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServiceEditAnchorPolicyRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  path: '/bigolive/live_agent_service/EditAnchorPolicy',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceEditAnchorPolicy',
};

export const liveAgentServiceEditAnchorPolicy = makeRequest<
  LiveAgentServiceEditAnchorPolicyRequest,
  LiveAgentServiceEditAnchorPolicyResponse
>(liveAgentServiceEditAnchorPolicyRequestConfig);
export const useLiveAgentServiceEditAnchorPolicy = makeRequestHook<
  LiveAgentServiceEditAnchorPolicyRequest,
  LiveAgentServiceEditAnchorPolicyRequestConfig,
  ReturnType<typeof liveAgentServiceEditAnchorPolicy>
>(liveAgentServiceEditAnchorPolicy);

export interface LiveAgentServiceReplaceAnchorPolicyRequest {
  /**
   * 1232432
   */
  seq_id: number;
  /**
   * 1001
   */
  old_policy_id: number;
  /**
   * 1002
   */
  new_policy_id: number;
  /**
   * "admin"
   */
  username: string;
}

export interface LiveAgentServiceReplaceAnchorPolicyResponse {
  seq_id: number;
  code: number;
  message: string;
}
type LiveAgentServiceReplaceAnchorPolicyRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/ReplaceAnchorPolicy',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServiceReplaceAnchorPolicyRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  path: '/bigolive/live_agent_service/ReplaceAnchorPolicy',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceReplaceAnchorPolicy',
};

export const liveAgentServiceReplaceAnchorPolicy = makeRequest<
  LiveAgentServiceReplaceAnchorPolicyRequest,
  LiveAgentServiceReplaceAnchorPolicyResponse
>(liveAgentServiceReplaceAnchorPolicyRequestConfig);
export const useLiveAgentServiceReplaceAnchorPolicy = makeRequestHook<
  LiveAgentServiceReplaceAnchorPolicyRequest,
  LiveAgentServiceReplaceAnchorPolicyRequestConfig,
  ReturnType<typeof liveAgentServiceReplaceAnchorPolicy>
>(liveAgentServiceReplaceAnchorPolicy);

export interface LiveAgentServiceEditProxyPolicyRequest {
  /**
   * 12345
   */
  seq_id: number;
  /**
   * [{"uid":1600016506,"proxy_uid":10001,"country":"US","support_time":"2024-12","grading_label":"0","service_percent":15.5},{"uid":1600016507,"proxy_uid":0,"country":"SG","support_time":"","grading_label":"T1","service_percent":20.11}]
   */
  items: {
    /**
     * 1600016506
     */
    uid: number;
    /**
     * 10001
     */
    proxy_uid: number;
    /**
     * "US"
     */
    country: string;
    /**
     * "2024-12"
     */
    support_time: string;
    /**
     * "0"
     */
    grading_label: string;
    /**
     * 15.5
     */
    service_percent: number;
  }[];
  /**
   * 123456789
   */
  policy_id: number;
  /**
   * "POLICY-2024-001"
   */
  policy_code: string;
  /**
   * "2024年度政策"
   */
  policy_name: string;
  /**
   * 1
   */
  policy_show: number;
  /**
   * "admin"
   */
  username: string;
}

export interface LiveAgentServiceEditProxyPolicyResponse {
  seq_id: number;
  code: number;
  message: string;
}
type LiveAgentServiceEditProxyPolicyRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/EditProxyPolicy',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServiceEditProxyPolicyRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  path: '/bigolive/live_agent_service/EditProxyPolicy',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceEditProxyPolicy',
};

export const liveAgentServiceEditProxyPolicy = makeRequest<
  LiveAgentServiceEditProxyPolicyRequest,
  LiveAgentServiceEditProxyPolicyResponse
>(liveAgentServiceEditProxyPolicyRequestConfig);
export const useLiveAgentServiceEditProxyPolicy = makeRequestHook<
  LiveAgentServiceEditProxyPolicyRequest,
  LiveAgentServiceEditProxyPolicyRequestConfig,
  ReturnType<typeof liveAgentServiceEditProxyPolicy>
>(liveAgentServiceEditProxyPolicy);

export interface LiveAgentServiceReplaceProxyPolicyRequest {
  /**
   * 1232432
   */
  seq_id: number;
  /**
   * 1001
   */
  old_policy_id: number;
  /**
   * 1002
   */
  new_policy_id: number;
  /**
   * "admin"
   */
  username: string;
}

export interface LiveAgentServiceReplaceProxyPolicyResponse {
  seq_id: number;
  code: number;
  message: string;
}
type LiveAgentServiceReplaceProxyPolicyRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/ReplaceProxyPolicy',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServiceReplaceProxyPolicyRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  path: '/bigolive/live_agent_service/ReplaceProxyPolicy',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceReplaceProxyPolicy',
};

export const liveAgentServiceReplaceProxyPolicy = makeRequest<
  LiveAgentServiceReplaceProxyPolicyRequest,
  LiveAgentServiceReplaceProxyPolicyResponse
>(liveAgentServiceReplaceProxyPolicyRequestConfig);
export const useLiveAgentServiceReplaceProxyPolicy = makeRequestHook<
  LiveAgentServiceReplaceProxyPolicyRequest,
  LiveAgentServiceReplaceProxyPolicyRequestConfig,
  ReturnType<typeof liveAgentServiceReplaceProxyPolicy>
>(liveAgentServiceReplaceProxyPolicy);

const mockUrl_0_0_0_1 = 'http://yapi.ppx520.com/mock/8015' as any;
const dataKey_0_0_0_1 = 'data' as any;

export interface LiveAgentUnionOssSendVerifyCodeRequest {
  type: number;
  scene: number;
  /**
   * "111111111"
   */
  phone: string;
  /**
   * "xxxx"
   */
  bigo_id: string;
}

export interface LiveAgentUnionOssSendVerifyCodeResponse {
  seq_id: string;
  code: number;
  message: string;
}
type LiveAgentUnionOssSendVerifyCodeRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/sendVerifyCode',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentUnionOssSendVerifyCodeRequestConfig = {
  mockUrl: mockUrl_0_0_0_1,
  path: '/bigolive/live_agent_union_oss/sendVerifyCode',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssSendVerifyCode',
};

export const liveAgentUnionOssSendVerifyCode = makeRequest<
  LiveAgentUnionOssSendVerifyCodeRequest,
  LiveAgentUnionOssSendVerifyCodeResponse
>(liveAgentUnionOssSendVerifyCodeRequestConfig);
export const useLiveAgentUnionOssSendVerifyCode = makeRequestHook<
  LiveAgentUnionOssSendVerifyCodeRequest,
  LiveAgentUnionOssSendVerifyCodeRequestConfig,
  ReturnType<typeof liveAgentUnionOssSendVerifyCode>
>(liveAgentUnionOssSendVerifyCode);

export interface LiveAgentUnionOssCheckVerifyCodeRequest {
  type: number;
  /**
   * 1121233
   */
  uid: number;
  scene: number;
  /**
   * "111111111"
   */
  phone: string;
  /**
   * "483921"
   */
  code: string;
}

export interface LiveAgentUnionOssCheckVerifyCodeResponse {
  seq_id: string;
  code: number;
  message: string;
}
type LiveAgentUnionOssCheckVerifyCodeRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/checkVerifyCode',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentUnionOssCheckVerifyCodeRequestConfig = {
  mockUrl: mockUrl_0_0_0_1,
  path: '/bigolive/live_agent_union_oss/checkVerifyCode',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssCheckVerifyCode',
};

export const liveAgentUnionOssCheckVerifyCode = makeRequest<
  LiveAgentUnionOssCheckVerifyCodeRequest,
  LiveAgentUnionOssCheckVerifyCodeResponse
>(liveAgentUnionOssCheckVerifyCodeRequestConfig);
export const useLiveAgentUnionOssCheckVerifyCode = makeRequestHook<
  LiveAgentUnionOssCheckVerifyCodeRequest,
  LiveAgentUnionOssCheckVerifyCodeRequestConfig,
  ReturnType<typeof liveAgentUnionOssCheckVerifyCode>
>(liveAgentUnionOssCheckVerifyCode);

export interface LiveAgentUnionOssSetUidHasPhoneRequest {
  /**
   * "123123123"
   */
  phone: string;
  /**
   * "483921"
   */
  code: string;
}

export interface LiveAgentUnionOssSetUidHasPhoneResponse {
  seq_id: string;
  code: number;
  message: string;
}
type LiveAgentUnionOssSetUidHasPhoneRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/setUidHasPhone',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentUnionOssSetUidHasPhoneRequestConfig = {
  mockUrl: mockUrl_0_0_0_1,
  path: '/bigolive/live_agent_union_oss/setUidHasPhone',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssSetUidHasPhone',
};

export const liveAgentUnionOssSetUidHasPhone = makeRequest<
  LiveAgentUnionOssSetUidHasPhoneRequest,
  LiveAgentUnionOssSetUidHasPhoneResponse
>(liveAgentUnionOssSetUidHasPhoneRequestConfig);
export const useLiveAgentUnionOssSetUidHasPhone = makeRequestHook<
  LiveAgentUnionOssSetUidHasPhoneRequest,
  LiveAgentUnionOssSetUidHasPhoneRequestConfig,
  ReturnType<typeof liveAgentUnionOssSetUidHasPhone>
>(liveAgentUnionOssSetUidHasPhone);

export interface LiveAgentUnionOssCheckIfUidHasPhoneRequest {}

export interface LiveAgentUnionOssCheckIfUidHasPhoneResponse {
  phone: string;
  prefix: string;
}
type LiveAgentUnionOssCheckIfUidHasPhoneRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/checkIfUidHasPhone',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentUnionOssCheckIfUidHasPhoneRequestConfig = {
  mockUrl: mockUrl_0_0_0_1,
  path: '/bigolive/live_agent_union_oss/checkIfUidHasPhone',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssCheckIfUidHasPhone',
};

export const liveAgentUnionOssCheckIfUidHasPhone = makeRequest<
  LiveAgentUnionOssCheckIfUidHasPhoneRequest,
  LiveAgentUnionOssCheckIfUidHasPhoneResponse
>(liveAgentUnionOssCheckIfUidHasPhoneRequestConfig);
export const useLiveAgentUnionOssCheckIfUidHasPhone = makeRequestHook<
  LiveAgentUnionOssCheckIfUidHasPhoneRequest,
  LiveAgentUnionOssCheckIfUidHasPhoneRequestConfig,
  ReturnType<typeof liveAgentUnionOssCheckIfUidHasPhone>
>(liveAgentUnionOssCheckIfUidHasPhone);

export interface LiveShowFollowStoreAddFollowUserRequest {
  /**
   * 60
   */
  app_id: number;
  /**
   * 请求序列号，尽量不重复
   */
  seq_id: number;
  /**
   * 被关注的uid,不超过10个
   */
  peer_uids: number[];
  /**
   * web前端填10
   */
  from_source: string;
  ext?: {
    /**
     * 禅道需求id
     */
    requirement: string;
  };
}

export interface LiveShowFollowStoreAddFollowUserResponse {
  /**
   * 同请求里的app_id
   */
  app_id: number;
  /**
   * 同请求里的seq_id
   */
  seq_id: number;
  /**
   * 同请求里的my_uid
   */
  my_uid: number;
  /**
   * 0-成功 其他-失败
   */
  res: number;
}
type LiveShowFollowStoreAddFollowUserRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_show_follow_store/AddFollowUser',
    'data',
    string,
    string,
    false
  >
>;

const liveShowFollowStoreAddFollowUserRequestConfig = {
  mockUrl: mockUrl_0_0_0_1,
  path: '/bigolive/live_show_follow_store/AddFollowUser',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveShowFollowStoreAddFollowUser',
};

export const liveShowFollowStoreAddFollowUser = makeRequest<
  LiveShowFollowStoreAddFollowUserRequest,
  LiveShowFollowStoreAddFollowUserResponse
>(liveShowFollowStoreAddFollowUserRequestConfig);
export const useLiveShowFollowStoreAddFollowUser = makeRequestHook<
  LiveShowFollowStoreAddFollowUserRequest,
  LiveShowFollowStoreAddFollowUserRequestConfig,
  ReturnType<typeof liveShowFollowStoreAddFollowUser>
>(liveShowFollowStoreAddFollowUser);

export interface LiveShowFollowStoreDelFollowInfoRequest {
  /**
   * 60
   */
  app_id: number;
  /**
   * 请求序列号，尽量不重复
   */
  seq_id: number;
  /**
   * 被取关的uid,不超过10个
   */
  peer_uids: number[];
  /**
   * web前端填10
   */
  from_source: string;
  ext?: {
    /**
     * 禅道需求id
     */
    requirement: string;
  };
}

export interface LiveShowFollowStoreDelFollowInfoResponse {
  /**
   * 同请求里的app_id
   */
  app_id: number;
  /**
   * 同请求里的seq_id
   */
  seq_id: number;
  /**
   * 同请求里的my_uid
   */
  my_uid: number;
  /**
   * 0-成功 其他-失败
   */
  res: number;
}
type LiveShowFollowStoreDelFollowInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_show_follow_store/DelFollowInfo',
    'data',
    string,
    string,
    false
  >
>;

const liveShowFollowStoreDelFollowInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_1,
  path: '/bigolive/live_show_follow_store/DelFollowInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveShowFollowStoreDelFollowInfo',
};

export const liveShowFollowStoreDelFollowInfo = makeRequest<
  LiveShowFollowStoreDelFollowInfoRequest,
  LiveShowFollowStoreDelFollowInfoResponse
>(liveShowFollowStoreDelFollowInfoRequestConfig);
export const useLiveShowFollowStoreDelFollowInfo = makeRequestHook<
  LiveShowFollowStoreDelFollowInfoRequest,
  LiveShowFollowStoreDelFollowInfoRequestConfig,
  ReturnType<typeof liveShowFollowStoreDelFollowInfo>
>(liveShowFollowStoreDelFollowInfo);

export interface LiveAgentServiceGetPermissionsRequest {
  /**
   * 1
   */
  permission_query_entry_type: number;
}

export interface LiveAgentServiceGetPermissionsResponse {
  permissions: number[];
}
type LiveAgentServiceGetPermissionsRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/GetPermissions',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServiceGetPermissionsRequestConfig = {
  mockUrl: mockUrl_0_0_0_1,
  path: '/bigolive/live_agent_service/GetPermissions',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceGetPermissions',
};

export const liveAgentServiceGetPermissions = makeRequest<
  LiveAgentServiceGetPermissionsRequest,
  LiveAgentServiceGetPermissionsResponse
>(liveAgentServiceGetPermissionsRequestConfig);
export const useLiveAgentServiceGetPermissions = makeRequestHook<
  LiveAgentServiceGetPermissionsRequest,
  LiveAgentServiceGetPermissionsRequestConfig,
  ReturnType<typeof liveAgentServiceGetPermissions>
>(liveAgentServiceGetPermissions);

const mockUrl_0_0_0_2 = 'http://yapi.ppx520.com/mock/8015' as any;
const dataKey_0_0_0_2 = 'data' as any;

export interface LiveAgentUnionOssAddAgencyMemberRequest {
  /**
   * "123123"
   */
  bigo_id: string;
  /**
   * "hello"
   */
  name: string;
  /**
   * "234567"
   */
  verification_code: string;
  /**
   * 1
   */
  role: number;
  /**
   * 123123
   */
  recruit_id: number;
}

export interface LiveAgentUnionOssAddAgencyMemberResponse {
  seq_id: string;
  code: number;
  message: string;
}
type LiveAgentUnionOssAddAgencyMemberRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/addAgencyMember',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentUnionOssAddAgencyMemberRequestConfig = {
  mockUrl: mockUrl_0_0_0_2,
  path: '/bigolive/live_agent_union_oss/addAgencyMember',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssAddAgencyMember',
};

export const liveAgentUnionOssAddAgencyMember = makeRequest<
  LiveAgentUnionOssAddAgencyMemberRequest,
  LiveAgentUnionOssAddAgencyMemberResponse
>(liveAgentUnionOssAddAgencyMemberRequestConfig);
export const useLiveAgentUnionOssAddAgencyMember = makeRequestHook<
  LiveAgentUnionOssAddAgencyMemberRequest,
  LiveAgentUnionOssAddAgencyMemberRequestConfig,
  ReturnType<typeof liveAgentUnionOssAddAgencyMember>
>(liveAgentUnionOssAddAgencyMember);

export interface LiveAgentUnionOssAssignAgencyRoleRequest {
  /**
   * 123123
   */
  uid: number;
  /**
   * 1
   */
  role: number;
}

export interface LiveAgentUnionOssAssignAgencyRoleResponse {
  seq_id: string;
  code: number;
  message: string;
}
type LiveAgentUnionOssAssignAgencyRoleRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/assignAgencyRole',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentUnionOssAssignAgencyRoleRequestConfig = {
  mockUrl: mockUrl_0_0_0_2,
  path: '/bigolive/live_agent_union_oss/assignAgencyRole',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssAssignAgencyRole',
};

export const liveAgentUnionOssAssignAgencyRole = makeRequest<
  LiveAgentUnionOssAssignAgencyRoleRequest,
  LiveAgentUnionOssAssignAgencyRoleResponse
>(liveAgentUnionOssAssignAgencyRoleRequestConfig);
export const useLiveAgentUnionOssAssignAgencyRole = makeRequestHook<
  LiveAgentUnionOssAssignAgencyRoleRequest,
  LiveAgentUnionOssAssignAgencyRoleRequestConfig,
  ReturnType<typeof liveAgentUnionOssAssignAgencyRole>
>(liveAgentUnionOssAssignAgencyRole);

export interface LiveAgentUnionOssDeleteAgencyMemberRequest {
  /**
   * 10000
   */
  uid: number;
}

export interface LiveAgentUnionOssDeleteAgencyMemberResponse {
  seq_id: string;
  code: number;
  message: string;
}
type LiveAgentUnionOssDeleteAgencyMemberRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/deleteAgencyMember',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentUnionOssDeleteAgencyMemberRequestConfig = {
  mockUrl: mockUrl_0_0_0_2,
  path: '/bigolive/live_agent_union_oss/deleteAgencyMember',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssDeleteAgencyMember',
};

export const liveAgentUnionOssDeleteAgencyMember = makeRequest<
  LiveAgentUnionOssDeleteAgencyMemberRequest,
  LiveAgentUnionOssDeleteAgencyMemberResponse
>(liveAgentUnionOssDeleteAgencyMemberRequestConfig);
export const useLiveAgentUnionOssDeleteAgencyMember = makeRequestHook<
  LiveAgentUnionOssDeleteAgencyMemberRequest,
  LiveAgentUnionOssDeleteAgencyMemberRequestConfig,
  ReturnType<typeof liveAgentUnionOssDeleteAgencyMember>
>(liveAgentUnionOssDeleteAgencyMember);

export interface LiveAgentUnionOssGetAgencyMemberListRequest {
  page: number;
  /**
   * 10
   */
  size: number;
  /**
   * "xxxxx"
   */
  query_field: string;
}

export interface LiveAgentUnionOssGetAgencyMemberListResponse {
  total_row: number;
  member_list: {
    name: string;
    uid: number;
    belong_admin: number;
    bigo_id: string;
    anchor_count: number;
    role: number;
    recruit_permission: boolean;
    join_time: number;
  }[];
}
type LiveAgentUnionOssGetAgencyMemberListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/getAgencyMemberList',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentUnionOssGetAgencyMemberListRequestConfig = {
  mockUrl: mockUrl_0_0_0_2,
  path: '/bigolive/live_agent_union_oss/getAgencyMemberList',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssGetAgencyMemberList',
};

export const liveAgentUnionOssGetAgencyMemberList = makeRequest<
  LiveAgentUnionOssGetAgencyMemberListRequest,
  LiveAgentUnionOssGetAgencyMemberListResponse
>(liveAgentUnionOssGetAgencyMemberListRequestConfig);
export const useLiveAgentUnionOssGetAgencyMemberList = makeRequestHook<
  LiveAgentUnionOssGetAgencyMemberListRequest,
  LiveAgentUnionOssGetAgencyMemberListRequestConfig,
  ReturnType<typeof liveAgentUnionOssGetAgencyMemberList>
>(liveAgentUnionOssGetAgencyMemberList);

export interface LiveAgentUnionOssModifyAgencyRecruitmentRequest {
  /**
   * 10000
   */
  uid: number;
  /**
   * true
   */
  recruit_permission: boolean;
}

export interface LiveAgentUnionOssModifyAgencyRecruitmentResponse {
  seq_id: string;
  code: number;
  message: string;
}
type LiveAgentUnionOssModifyAgencyRecruitmentRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/modifyAgencyRecruitment',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentUnionOssModifyAgencyRecruitmentRequestConfig = {
  mockUrl: mockUrl_0_0_0_2,
  path: '/bigolive/live_agent_union_oss/modifyAgencyRecruitment',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssModifyAgencyRecruitment',
};

export const liveAgentUnionOssModifyAgencyRecruitment = makeRequest<
  LiveAgentUnionOssModifyAgencyRecruitmentRequest,
  LiveAgentUnionOssModifyAgencyRecruitmentResponse
>(liveAgentUnionOssModifyAgencyRecruitmentRequestConfig);
export const useLiveAgentUnionOssModifyAgencyRecruitment = makeRequestHook<
  LiveAgentUnionOssModifyAgencyRecruitmentRequest,
  LiveAgentUnionOssModifyAgencyRecruitmentRequestConfig,
  ReturnType<typeof liveAgentUnionOssModifyAgencyRecruitment>
>(liveAgentUnionOssModifyAgencyRecruitment);

export interface LiveAgentUnionOssGetAgencyOperationRecordRequest {
  /**
   * 10123123
   */
  cursor: number;
  /**
   * 10
   */
  size: number;
  query_name: string;
  query_oper: string;
  /**
   * 3
   */
  query_op: number;
}

export interface LiveAgentUnionOssGetAgencyOperationRecordResponse {
  cursor: number;
  total_row: number;
  record_list: {
    bigo_id: string;
    name: string;
    oper_type: number;
    role: number;
    oper_name: string;
    oper_time: number;
  }[];
}
type LiveAgentUnionOssGetAgencyOperationRecordRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/getAgencyOperationRecord',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentUnionOssGetAgencyOperationRecordRequestConfig = {
  mockUrl: mockUrl_0_0_0_2,
  path: '/bigolive/live_agent_union_oss/getAgencyOperationRecord',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssGetAgencyOperationRecord',
};

export const liveAgentUnionOssGetAgencyOperationRecord = makeRequest<
  LiveAgentUnionOssGetAgencyOperationRecordRequest,
  LiveAgentUnionOssGetAgencyOperationRecordResponse
>(liveAgentUnionOssGetAgencyOperationRecordRequestConfig);
export const useLiveAgentUnionOssGetAgencyOperationRecord = makeRequestHook<
  LiveAgentUnionOssGetAgencyOperationRecordRequest,
  LiveAgentUnionOssGetAgencyOperationRecordRequestConfig,
  ReturnType<typeof liveAgentUnionOssGetAgencyOperationRecord>
>(liveAgentUnionOssGetAgencyOperationRecord);

export interface LiveAgentUnionOssGetAgencyMemberRoleRequest {}

export interface LiveAgentUnionOssGetAgencyMemberRoleResponse {
  member_list: {
    name: string;
    uid: number;
  }[];
}
type LiveAgentUnionOssGetAgencyMemberRoleRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/getAgencyMemberRole',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentUnionOssGetAgencyMemberRoleRequestConfig = {
  mockUrl: mockUrl_0_0_0_2,
  path: '/bigolive/live_agent_union_oss/getAgencyMemberRole',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssGetAgencyMemberRole',
};

export const liveAgentUnionOssGetAgencyMemberRole = makeRequest<
  LiveAgentUnionOssGetAgencyMemberRoleRequest,
  LiveAgentUnionOssGetAgencyMemberRoleResponse
>(liveAgentUnionOssGetAgencyMemberRoleRequestConfig);
export const useLiveAgentUnionOssGetAgencyMemberRole = makeRequestHook<
  LiveAgentUnionOssGetAgencyMemberRoleRequest,
  LiveAgentUnionOssGetAgencyMemberRoleRequestConfig,
  ReturnType<typeof liveAgentUnionOssGetAgencyMemberRole>
>(liveAgentUnionOssGetAgencyMemberRole);

export interface LiveAgentUnionOssGetSelfInfoRequest {}

export interface LiveAgentUnionOssGetSelfInfoResponse {
  member_info: {
    role: number;
  };
}
type LiveAgentUnionOssGetSelfInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/getSelfInfo',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentUnionOssGetSelfInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_2,
  path: '/bigolive/live_agent_union_oss/getSelfInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssGetSelfInfo',
};

export const liveAgentUnionOssGetSelfInfo = makeRequest<
  LiveAgentUnionOssGetSelfInfoRequest,
  LiveAgentUnionOssGetSelfInfoResponse
>(liveAgentUnionOssGetSelfInfoRequestConfig);
export const useLiveAgentUnionOssGetSelfInfo = makeRequestHook<
  LiveAgentUnionOssGetSelfInfoRequest,
  LiveAgentUnionOssGetSelfInfoRequestConfig,
  ReturnType<typeof liveAgentUnionOssGetSelfInfo>
>(liveAgentUnionOssGetSelfInfo);

export interface LiveAgentUnionOssModifyAgentRecruitCfgRequest {
  recruit_state: number;
  /**
   * 100
   */
  require_level: number;
}

export interface LiveAgentUnionOssModifyAgentRecruitCfgResponse {
  seq_id: string;
  code: number;
  message: string;
}
type LiveAgentUnionOssModifyAgentRecruitCfgRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/modifyAgentRecruitCfg',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentUnionOssModifyAgentRecruitCfgRequestConfig = {
  mockUrl: mockUrl_0_0_0_2,
  path: '/bigolive/live_agent_union_oss/modifyAgentRecruitCfg',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssModifyAgentRecruitCfg',
};

export const liveAgentUnionOssModifyAgentRecruitCfg = makeRequest<
  LiveAgentUnionOssModifyAgentRecruitCfgRequest,
  LiveAgentUnionOssModifyAgentRecruitCfgResponse
>(liveAgentUnionOssModifyAgentRecruitCfgRequestConfig);
export const useLiveAgentUnionOssModifyAgentRecruitCfg = makeRequestHook<
  LiveAgentUnionOssModifyAgentRecruitCfgRequest,
  LiveAgentUnionOssModifyAgentRecruitCfgRequestConfig,
  ReturnType<typeof liveAgentUnionOssModifyAgentRecruitCfg>
>(liveAgentUnionOssModifyAgentRecruitCfg);

export interface LiveAgentUnionOssGetAgentRecruitCfgRequest {}

export interface LiveAgentUnionOssGetAgentRecruitCfgResponse {
  recruit_state: number;
  require_level: number;
}
type LiveAgentUnionOssGetAgentRecruitCfgRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/getAgentRecruitCfg',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentUnionOssGetAgentRecruitCfgRequestConfig = {
  mockUrl: mockUrl_0_0_0_2,
  path: '/bigolive/live_agent_union_oss/getAgentRecruitCfg',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssGetAgentRecruitCfg',
};

export const liveAgentUnionOssGetAgentRecruitCfg = makeRequest<
  LiveAgentUnionOssGetAgentRecruitCfgRequest,
  LiveAgentUnionOssGetAgentRecruitCfgResponse
>(liveAgentUnionOssGetAgentRecruitCfgRequestConfig);
export const useLiveAgentUnionOssGetAgentRecruitCfg = makeRequestHook<
  LiveAgentUnionOssGetAgentRecruitCfgRequest,
  LiveAgentUnionOssGetAgentRecruitCfgRequestConfig,
  ReturnType<typeof liveAgentUnionOssGetAgentRecruitCfg>
>(liveAgentUnionOssGetAgentRecruitCfg);

export interface LiveAgentUnionOssUserGetApplicationRecordRequest {
  /**
   * "xxxx"
   */
  query_field: string;
  cursor: number;
  /**
   * 10
   */
  size: number;
}

export interface LiveAgentUnionOssUserGetApplicationRecordResponse {
  cursor: number;
  total: number;
  list: {
    recruit_id: string;
    uid: number;
    avatar: string;
    name: string;
    bigoid: string;
    status: number;
  }[];
}
type LiveAgentUnionOssUserGetApplicationRecordRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/userGetApplicationRecord',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentUnionOssUserGetApplicationRecordRequestConfig = {
  mockUrl: mockUrl_0_0_0_2,
  path: '/bigolive/live_agent_union_oss/userGetApplicationRecord',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssUserGetApplicationRecord',
};

export const liveAgentUnionOssUserGetApplicationRecord = makeRequest<
  LiveAgentUnionOssUserGetApplicationRecordRequest,
  LiveAgentUnionOssUserGetApplicationRecordResponse
>(liveAgentUnionOssUserGetApplicationRecordRequestConfig);
export const useLiveAgentUnionOssUserGetApplicationRecord = makeRequestHook<
  LiveAgentUnionOssUserGetApplicationRecordRequest,
  LiveAgentUnionOssUserGetApplicationRecordRequestConfig,
  ReturnType<typeof liveAgentUnionOssUserGetApplicationRecord>
>(liveAgentUnionOssUserGetApplicationRecord);

export interface LiveAgentUnionOssUserGetApplicationStateRequest {
  /**
   * "10213123"
   */
  recruit_id: string;
}

export interface LiveAgentUnionOssUserGetApplicationStateResponse {
  avatar: string;
  name: string;
  bigo_id: string;
  proxy_uid: number;
  apply_time: string;
  oper_time: string;
  status: number;
}
type LiveAgentUnionOssUserGetApplicationStateRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/userGetApplicationState',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentUnionOssUserGetApplicationStateRequestConfig = {
  mockUrl: mockUrl_0_0_0_2,
  path: '/bigolive/live_agent_union_oss/userGetApplicationState',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssUserGetApplicationState',
};

export const liveAgentUnionOssUserGetApplicationState = makeRequest<
  LiveAgentUnionOssUserGetApplicationStateRequest,
  LiveAgentUnionOssUserGetApplicationStateResponse
>(liveAgentUnionOssUserGetApplicationStateRequestConfig);
export const useLiveAgentUnionOssUserGetApplicationState = makeRequestHook<
  LiveAgentUnionOssUserGetApplicationStateRequest,
  LiveAgentUnionOssUserGetApplicationStateRequestConfig,
  ReturnType<typeof liveAgentUnionOssUserGetApplicationState>
>(liveAgentUnionOssUserGetApplicationState);

export interface LiveAgentUnionOssUserCreateApplyRequest {
  /**
   * 1600000025
   */
  proxy_uid: number;
  /**
   * "+86123456789"
   */
  phone: string;
}

export interface LiveAgentUnionOssUserCreateApplyResponse {}
type LiveAgentUnionOssUserCreateApplyRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/userCreateApply',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentUnionOssUserCreateApplyRequestConfig = {
  mockUrl: mockUrl_0_0_0_2,
  path: '/bigolive/live_agent_union_oss/userCreateApply',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssUserCreateApply',
};

export const liveAgentUnionOssUserCreateApply = makeRequest<
  LiveAgentUnionOssUserCreateApplyRequest,
  LiveAgentUnionOssUserCreateApplyResponse
>(liveAgentUnionOssUserCreateApplyRequestConfig);
export const useLiveAgentUnionOssUserCreateApply = makeRequestHook<
  LiveAgentUnionOssUserCreateApplyRequest,
  LiveAgentUnionOssUserCreateApplyRequestConfig,
  ReturnType<typeof liveAgentUnionOssUserCreateApply>
>(liveAgentUnionOssUserCreateApply);

export interface LiveAgentUnionOssAgentPullApplyListRequest {
  /**
   * "bigoid1111"
   */
  query_id: string;
  /**
   * 100
   */
  query_level: number;
  query_result: number;
  /**
   * 12312323
   */
  cursor: number;
  type: number;
  /**
   * 10
   */
  size: number;
}

export interface LiveAgentUnionOssAgentPullApplyListResponse {
  count_pending: number;
  count_processed: number;
  cursor: number;
  list: {
    recruit_id: number;
    uid: number;
    avatar: string;
    nick: string;
    bigoid: string;
    level: number;
    phone: string;
    apply_time: number;
    status: number;
  }[];
}
type LiveAgentUnionOssAgentPullApplyListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/agentPullApplyList',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentUnionOssAgentPullApplyListRequestConfig = {
  mockUrl: mockUrl_0_0_0_2,
  path: '/bigolive/live_agent_union_oss/agentPullApplyList',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssAgentPullApplyList',
};

export const liveAgentUnionOssAgentPullApplyList = makeRequest<
  LiveAgentUnionOssAgentPullApplyListRequest,
  LiveAgentUnionOssAgentPullApplyListResponse
>(liveAgentUnionOssAgentPullApplyListRequestConfig);
export const useLiveAgentUnionOssAgentPullApplyList = makeRequestHook<
  LiveAgentUnionOssAgentPullApplyListRequest,
  LiveAgentUnionOssAgentPullApplyListRequestConfig,
  ReturnType<typeof liveAgentUnionOssAgentPullApplyList>
>(liveAgentUnionOssAgentPullApplyList);

export interface LiveAgentUnionOssAgentDenyApplyRequest {
  /**
   * 1600000012
   */
  user_uid: number;
  /**
   * 12312312312
   */
  recruit_id: number;
}

export interface LiveAgentUnionOssAgentDenyApplyResponse {}
type LiveAgentUnionOssAgentDenyApplyRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/agentDenyApply',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentUnionOssAgentDenyApplyRequestConfig = {
  mockUrl: mockUrl_0_0_0_2,
  path: '/bigolive/live_agent_union_oss/agentDenyApply',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssAgentDenyApply',
};

export const liveAgentUnionOssAgentDenyApply = makeRequest<
  LiveAgentUnionOssAgentDenyApplyRequest,
  LiveAgentUnionOssAgentDenyApplyResponse
>(liveAgentUnionOssAgentDenyApplyRequestConfig);
export const useLiveAgentUnionOssAgentDenyApply = makeRequestHook<
  LiveAgentUnionOssAgentDenyApplyRequest,
  LiveAgentUnionOssAgentDenyApplyRequestConfig,
  ReturnType<typeof liveAgentUnionOssAgentDenyApply>
>(liveAgentUnionOssAgentDenyApply);

export interface LiveAgentUnionOssAgentGetIfHasDotRequest {}

export interface LiveAgentUnionOssAgentGetIfHasDotResponse {
  status: number;
}
type LiveAgentUnionOssAgentGetIfHasDotRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/agentGetIfHasDot',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentUnionOssAgentGetIfHasDotRequestConfig = {
  mockUrl: mockUrl_0_0_0_2,
  path: '/bigolive/live_agent_union_oss/agentGetIfHasDot',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssAgentGetIfHasDot',
};

export const liveAgentUnionOssAgentGetIfHasDot = makeRequest<
  LiveAgentUnionOssAgentGetIfHasDotRequest,
  LiveAgentUnionOssAgentGetIfHasDotResponse
>(liveAgentUnionOssAgentGetIfHasDotRequestConfig);
export const useLiveAgentUnionOssAgentGetIfHasDot = makeRequestHook<
  LiveAgentUnionOssAgentGetIfHasDotRequest,
  LiveAgentUnionOssAgentGetIfHasDotRequestConfig,
  ReturnType<typeof liveAgentUnionOssAgentGetIfHasDot>
>(liveAgentUnionOssAgentGetIfHasDot);

export interface LiveAgentUnionOssAgentClickDotRequest {}

export interface LiveAgentUnionOssAgentClickDotResponse {}
type LiveAgentUnionOssAgentClickDotRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/agentClickDot',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentUnionOssAgentClickDotRequestConfig = {
  mockUrl: mockUrl_0_0_0_2,
  path: '/bigolive/live_agent_union_oss/agentClickDot',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssAgentClickDot',
};

export const liveAgentUnionOssAgentClickDot = makeRequest<
  LiveAgentUnionOssAgentClickDotRequest,
  LiveAgentUnionOssAgentClickDotResponse
>(liveAgentUnionOssAgentClickDotRequestConfig);
export const useLiveAgentUnionOssAgentClickDot = makeRequestHook<
  LiveAgentUnionOssAgentClickDotRequest,
  LiveAgentUnionOssAgentClickDotRequestConfig,
  ReturnType<typeof liveAgentUnionOssAgentClickDot>
>(liveAgentUnionOssAgentClickDot);

export interface LiveAgentFrontGetAgentListForOssApplyRequest {
  /**
   * "xxxx"
   */
  query_field: string;
  /**
   * 10
   */
  count: number;
  context: string;
}

export interface LiveAgentFrontGetAgentListForOssApplyResponse {
  total_cnt: number;
  is_end: boolean;
  context: string;
  agent_list: {
    uid: number;
    avatar: string;
    name: string;
    bigoid: string;
    status: number;
    recruit_id: string;
  }[];
}
type LiveAgentFrontGetAgentListForOssApplyRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetAgentListForOssApply',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontGetAgentListForOssApplyRequestConfig = {
  mockUrl: mockUrl_0_0_0_2,
  path: '/bigolive/live_agent_front/GetAgentListForOssApply',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetAgentListForOssApply',
};

export const liveAgentFrontGetAgentListForOssApply = makeRequest<
  LiveAgentFrontGetAgentListForOssApplyRequest,
  LiveAgentFrontGetAgentListForOssApplyResponse
>(liveAgentFrontGetAgentListForOssApplyRequestConfig);
export const useLiveAgentFrontGetAgentListForOssApply = makeRequestHook<
  LiveAgentFrontGetAgentListForOssApplyRequest,
  LiveAgentFrontGetAgentListForOssApplyRequestConfig,
  ReturnType<typeof liveAgentFrontGetAgentListForOssApply>
>(liveAgentFrontGetAgentListForOssApply);

export interface LiveAgentUnionOssAgentPullGuideSecRequest {}

export interface LiveAgentUnionOssAgentPullGuideSecResponse {
  guide_sec: number;
}
type LiveAgentUnionOssAgentPullGuideSecRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/agentPullGuideSec',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentUnionOssAgentPullGuideSecRequestConfig = {
  mockUrl: mockUrl_0_0_0_2,
  path: '/bigolive/live_agent_union_oss/agentPullGuideSec',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssAgentPullGuideSec',
};

export const liveAgentUnionOssAgentPullGuideSec = makeRequest<
  LiveAgentUnionOssAgentPullGuideSecRequest,
  LiveAgentUnionOssAgentPullGuideSecResponse
>(liveAgentUnionOssAgentPullGuideSecRequestConfig);
export const useLiveAgentUnionOssAgentPullGuideSec = makeRequestHook<
  LiveAgentUnionOssAgentPullGuideSecRequest,
  LiveAgentUnionOssAgentPullGuideSecRequestConfig,
  ReturnType<typeof liveAgentUnionOssAgentPullGuideSec>
>(liveAgentUnionOssAgentPullGuideSec);

const mockUrl_0_0_0_3 = 'http://yapi.ppx520.com/mock/8015' as any;
const dataKey_0_0_0_3 = 'data' as any;

export interface LiveAgentFrontGetInviteLinkRequest {
  /**
   * 1
   */
  source: number;
  /**
   * "xx"
   */
  lang: string;
}

export interface LiveAgentFrontGetInviteLinkResponse {
  link_id: string;
  url: string;
  is_official: boolean;
  long_url: string;
  anti_ban_url: string;
  anti_ban_long_url: string;
  region: string;
}
type LiveAgentFrontGetInviteLinkRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetInviteLink',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontGetInviteLinkRequestConfig = {
  mockUrl: mockUrl_0_0_0_3,
  path: '/bigolive/live_agent_front/GetInviteLink',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetInviteLink',
};

export const liveAgentFrontGetInviteLink = makeRequest<
  LiveAgentFrontGetInviteLinkRequest,
  LiveAgentFrontGetInviteLinkResponse
>(liveAgentFrontGetInviteLinkRequestConfig);
export const useLiveAgentFrontGetInviteLink = makeRequestHook<
  LiveAgentFrontGetInviteLinkRequest,
  LiveAgentFrontGetInviteLinkRequestConfig,
  ReturnType<typeof liveAgentFrontGetInviteLink>
>(liveAgentFrontGetInviteLink);

export interface LiveAgentFrontShareInviteLinkRequest {
  /**
   * ["xxx","yyy"]
   */
  bigoid_list: string[];
  im_msg: {
    /**
     * "xxx"
     */
    im_image_url: string;
    /**
     * "xxx"
     */
    im_title: string;
    /**
     * "xxx"
     */
    im_content: string;
    /**
     * "xxx"
     */
    im_image_ratio: string;
    /**
     * "xxx"
     */
    im_link: string;
    /**
     * "xx"
     */
    is_from_agent_oss: string;
  };
}

export interface LiveAgentFrontShareInviteLinkResponse {
  is_all_success: boolean;
  fail_bigoids: {
    xxx: number;
    yyy: number;
    zzz: number;
  };
  resp_user_extra: {
    zzz: {
      user_extensions: {
        reject_cooling: number;
      };
    };
  };
}
type LiveAgentFrontShareInviteLinkRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/ShareInviteLink',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontShareInviteLinkRequestConfig = {
  mockUrl: mockUrl_0_0_0_3,
  path: '/bigolive/live_agent_front/ShareInviteLink',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontShareInviteLink',
};

export const liveAgentFrontShareInviteLink = makeRequest<
  LiveAgentFrontShareInviteLinkRequest,
  LiveAgentFrontShareInviteLinkResponse
>(liveAgentFrontShareInviteLinkRequestConfig);
export const useLiveAgentFrontShareInviteLink = makeRequestHook<
  LiveAgentFrontShareInviteLinkRequest,
  LiveAgentFrontShareInviteLinkRequestConfig,
  ReturnType<typeof liveAgentFrontShareInviteLink>
>(liveAgentFrontShareInviteLink);

export interface LiveAgentFrontCheckInviteEntranceRequest {}

export interface LiveAgentFrontCheckInviteEntranceResponse {
  is_open: boolean;
}
type LiveAgentFrontCheckInviteEntranceRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/CheckInviteEntrance',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentFrontCheckInviteEntranceRequestConfig = {
  mockUrl: mockUrl_0_0_0_3,
  path: '/bigolive/live_agent_front/CheckInviteEntrance',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontCheckInviteEntrance',
};

export const liveAgentFrontCheckInviteEntrance = makeRequest<
  LiveAgentFrontCheckInviteEntranceRequest,
  LiveAgentFrontCheckInviteEntranceResponse
>(liveAgentFrontCheckInviteEntranceRequestConfig);
export const useLiveAgentFrontCheckInviteEntrance = makeRequestHook<
  LiveAgentFrontCheckInviteEntranceRequest,
  LiveAgentFrontCheckInviteEntranceRequestConfig,
  ReturnType<typeof liveAgentFrontCheckInviteEntrance>
>(liveAgentFrontCheckInviteEntrance);

export interface LiveAgentFrontAgreeInviteRequest {
  /**
   * 123456
   */
  invite_uid: number;
  /**
   * "456782112331122"
   */
  link_id: string;
  security_packet: string;
  /**
   * 1
   */
  platform: number;
  /**
   * "1.0.0"
   */
  client_ver: string;
}

export interface LiveAgentFrontAgreeInviteResponse {
  ex_agent_bigoid: string;
  logic_code: number;
  live_hours_limit: number;
  user_level_limit: number;
  beans_limit: string;
}
type LiveAgentFrontAgreeInviteRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/AgreeInvite',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontAgreeInviteRequestConfig = {
  mockUrl: mockUrl_0_0_0_3,
  path: '/bigolive/live_agent_front/AgreeInvite',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontAgreeInvite',
};

export const liveAgentFrontAgreeInvite = makeRequest<
  LiveAgentFrontAgreeInviteRequest,
  LiveAgentFrontAgreeInviteResponse
>(liveAgentFrontAgreeInviteRequestConfig);
export const useLiveAgentFrontAgreeInvite = makeRequestHook<
  LiveAgentFrontAgreeInviteRequest,
  LiveAgentFrontAgreeInviteRequestConfig,
  ReturnType<typeof liveAgentFrontAgreeInvite>
>(liveAgentFrontAgreeInvite);

export interface LiveAgentFrontAnchorApplyRequest {
  /**
   * 1233
   */
  agent_uid: number;
}

export interface LiveAgentFrontAnchorApplyResponse {
  url: string;
  long_url: string;
}
type LiveAgentFrontAnchorApplyRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/AnchorApply',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontAnchorApplyRequestConfig = {
  mockUrl: mockUrl_0_0_0_3,
  path: '/bigolive/live_agent_front/AnchorApply',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontAnchorApply',
};

export const liveAgentFrontAnchorApply = makeRequest<
  LiveAgentFrontAnchorApplyRequest,
  LiveAgentFrontAnchorApplyResponse
>(liveAgentFrontAnchorApplyRequestConfig);
export const useLiveAgentFrontAnchorApply = makeRequestHook<
  LiveAgentFrontAnchorApplyRequest,
  LiveAgentFrontAnchorApplyRequestConfig,
  ReturnType<typeof liveAgentFrontAnchorApply>
>(liveAgentFrontAnchorApply);

export interface LiveAgentFrontGetInviteListRequest {
  /**
   * 1
   */
  type: number;
  /**
   * 20
   */
  count: number;
  context: string;
  /**
   * "SG"
   */
  virtual_region: string;
}

export interface LiveAgentFrontGetInviteListResponse {
  agent_list: {
    url: string;
    long_url: string;
    agent_uid: number;
    agent_name: string;
    agent_avatar: string;
    anchor_num: number;
    is_official: boolean;
    hide_anchor_num: boolean;
  }[];
  context: string;
  is_end: boolean;
}
type LiveAgentFrontGetInviteListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetInviteList',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontGetInviteListRequestConfig = {
  mockUrl: mockUrl_0_0_0_3,
  path: '/bigolive/live_agent_front/GetInviteList',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetInviteList',
};

export const liveAgentFrontGetInviteList = makeRequest<
  LiveAgentFrontGetInviteListRequest,
  LiveAgentFrontGetInviteListResponse
>(liveAgentFrontGetInviteListRequestConfig);
export const useLiveAgentFrontGetInviteList = makeRequestHook<
  LiveAgentFrontGetInviteListRequest,
  LiveAgentFrontGetInviteListRequestConfig,
  ReturnType<typeof liveAgentFrontGetInviteList>
>(liveAgentFrontGetInviteList);

export interface LiveAgentFrontGetInviteLinkDetailRequest {
  /**
   * "456782112331122"
   */
  link_id: string;
}

export interface LiveAgentFrontGetInviteLinkDetailResponse {
  agency_name: string;
  is_official: boolean;
  agent_region: string;
  agent_name: string;
  regret_days: number;
}
type LiveAgentFrontGetInviteLinkDetailRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetInviteLinkDetail',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontGetInviteLinkDetailRequestConfig = {
  mockUrl: mockUrl_0_0_0_3,
  path: '/bigolive/live_agent_front/GetInviteLinkDetail',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetInviteLinkDetail',
};

export const liveAgentFrontGetInviteLinkDetail = makeRequest<
  LiveAgentFrontGetInviteLinkDetailRequest,
  LiveAgentFrontGetInviteLinkDetailResponse
>(liveAgentFrontGetInviteLinkDetailRequestConfig);
export const useLiveAgentFrontGetInviteLinkDetail = makeRequestHook<
  LiveAgentFrontGetInviteLinkDetailRequest,
  LiveAgentFrontGetInviteLinkDetailRequestConfig,
  ReturnType<typeof liveAgentFrontGetInviteLinkDetail>
>(liveAgentFrontGetInviteLinkDetail);

export interface LiveAgentFrontGetLocatedCountryRequest {}

export interface LiveAgentFrontGetLocatedCountryResponse {
  country_code: string;
}
type LiveAgentFrontGetLocatedCountryRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetLocatedCountry',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentFrontGetLocatedCountryRequestConfig = {
  mockUrl: mockUrl_0_0_0_3,
  path: '/bigolive/live_agent_front/GetLocatedCountry',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetLocatedCountry',
};

export const liveAgentFrontGetLocatedCountry = makeRequest<
  LiveAgentFrontGetLocatedCountryRequest,
  LiveAgentFrontGetLocatedCountryResponse
>(liveAgentFrontGetLocatedCountryRequestConfig);
export const useLiveAgentFrontGetLocatedCountry = makeRequestHook<
  LiveAgentFrontGetLocatedCountryRequest,
  LiveAgentFrontGetLocatedCountryRequestConfig,
  ReturnType<typeof liveAgentFrontGetLocatedCountry>
>(liveAgentFrontGetLocatedCountry);

export interface LiveAgentFrontSearchAgentForAnchorApplyRequest {
  /**
   * "xxxx"
   */
  query_field: string;
  /**
   * "xxxx"
   */
  virtual_region: string;
}

export interface LiveAgentFrontSearchAgentForAnchorApplyResponse {
  agent_list: {
    url: string;
    long_url: string;
    agent_uid: number;
    agent_name: string;
    agent_avatar: string;
    anchor_num: number;
    is_official: boolean;
    hide_anchor_num: boolean;
    type: number;
  }[];
}
type LiveAgentFrontSearchAgentForAnchorApplyRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/SearchAgentForAnchorApply',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontSearchAgentForAnchorApplyRequestConfig = {
  mockUrl: mockUrl_0_0_0_3,
  path: '/bigolive/live_agent_front/SearchAgentForAnchorApply',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontSearchAgentForAnchorApply',
};

export const liveAgentFrontSearchAgentForAnchorApply = makeRequest<
  LiveAgentFrontSearchAgentForAnchorApplyRequest,
  LiveAgentFrontSearchAgentForAnchorApplyResponse
>(liveAgentFrontSearchAgentForAnchorApplyRequestConfig);
export const useLiveAgentFrontSearchAgentForAnchorApply = makeRequestHook<
  LiveAgentFrontSearchAgentForAnchorApplyRequest,
  LiveAgentFrontSearchAgentForAnchorApplyRequestConfig,
  ReturnType<typeof liveAgentFrontSearchAgentForAnchorApply>
>(liveAgentFrontSearchAgentForAnchorApply);

export interface LiveAgentFrontGetInvitePageDetailRequest {
  /**
   * "456782112331122"
   */
  link_id: string;
  /**
   * 123
   */
  seq_id: number;
}

export interface LiveAgentFrontGetInvitePageDetailResponse {
  agency_name: string;
  is_official: boolean;
  agent_region: string;
  agent_name: string;
  match_ugc_wl: boolean;
  link_status: number;
  inviter_nickname: string;
  regret_days: number;
}
type LiveAgentFrontGetInvitePageDetailRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetInvitePageDetail',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontGetInvitePageDetailRequestConfig = {
  mockUrl: mockUrl_0_0_0_3,
  path: '/bigolive/live_agent_front/GetInvitePageDetail',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetInvitePageDetail',
};

export const liveAgentFrontGetInvitePageDetail = makeRequest<
  LiveAgentFrontGetInvitePageDetailRequest,
  LiveAgentFrontGetInvitePageDetailResponse
>(liveAgentFrontGetInvitePageDetailRequestConfig);
export const useLiveAgentFrontGetInvitePageDetail = makeRequestHook<
  LiveAgentFrontGetInvitePageDetailRequest,
  LiveAgentFrontGetInvitePageDetailRequestConfig,
  ReturnType<typeof liveAgentFrontGetInvitePageDetail>
>(liveAgentFrontGetInvitePageDetail);

export interface LiveAgentFrontGetRecomAnchorRequest {
  /**
   * 10
   */
  page_size: number;
  /**
   * "20"
   */
  cursor: string;
  /**
   * "**"
   */
  bigo_id: string;
}

export interface LiveAgentFrontGetRecomAnchorResponse {
  anchor_list: {
    uid: number;
    bigoid: string;
    nickname: string;
    image: string;
    fans_cnt: number;
    live_duration_30: number;
    live_duration_60: number;
  }[];
  cursor: string;
  agent_uid: number;
  total_cnt: number;
}
type LiveAgentFrontGetRecomAnchorRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetRecomAnchor',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontGetRecomAnchorRequestConfig = {
  mockUrl: mockUrl_0_0_0_3,
  path: '/bigolive/live_agent_front/GetRecomAnchor',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetRecomAnchor',
};

export const liveAgentFrontGetRecomAnchor = makeRequest<
  LiveAgentFrontGetRecomAnchorRequest,
  LiveAgentFrontGetRecomAnchorResponse
>(liveAgentFrontGetRecomAnchorRequestConfig);
export const useLiveAgentFrontGetRecomAnchor = makeRequestHook<
  LiveAgentFrontGetRecomAnchorRequest,
  LiveAgentFrontGetRecomAnchorRequestConfig,
  ReturnType<typeof liveAgentFrontGetRecomAnchor>
>(liveAgentFrontGetRecomAnchor);

export interface LiveAgentFrontGetRecomAnchorEntryRequest {}

export interface LiveAgentFrontGetRecomAnchorEntryResponse {
  entry: boolean;
}
type LiveAgentFrontGetRecomAnchorEntryRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetRecomAnchorEntry',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentFrontGetRecomAnchorEntryRequestConfig = {
  mockUrl: mockUrl_0_0_0_3,
  path: '/bigolive/live_agent_front/GetRecomAnchorEntry',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetRecomAnchorEntry',
};

export const liveAgentFrontGetRecomAnchorEntry = makeRequest<
  LiveAgentFrontGetRecomAnchorEntryRequest,
  LiveAgentFrontGetRecomAnchorEntryResponse
>(liveAgentFrontGetRecomAnchorEntryRequestConfig);
export const useLiveAgentFrontGetRecomAnchorEntry = makeRequestHook<
  LiveAgentFrontGetRecomAnchorEntryRequest,
  LiveAgentFrontGetRecomAnchorEntryRequestConfig,
  ReturnType<typeof liveAgentFrontGetRecomAnchorEntry>
>(liveAgentFrontGetRecomAnchorEntry);

export interface LiveAgentFrontAnchorRejectInviteRequest {
  /**
   * 123
   */
  seq_id: number;
  /**
   * "123"
   */
  link_id: string;
}

export interface LiveAgentFrontAnchorRejectInviteResponse {
  seq_id: number;
  code: number;
}
type LiveAgentFrontAnchorRejectInviteRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/AnchorRejectInvite',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontAnchorRejectInviteRequestConfig = {
  mockUrl: mockUrl_0_0_0_3,
  path: '/bigolive/live_agent_front/AnchorRejectInvite',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontAnchorRejectInvite',
};

export const liveAgentFrontAnchorRejectInvite = makeRequest<
  LiveAgentFrontAnchorRejectInviteRequest,
  LiveAgentFrontAnchorRejectInviteResponse
>(liveAgentFrontAnchorRejectInviteRequestConfig);
export const useLiveAgentFrontAnchorRejectInvite = makeRequestHook<
  LiveAgentFrontAnchorRejectInviteRequest,
  LiveAgentFrontAnchorRejectInviteRequestConfig,
  ReturnType<typeof liveAgentFrontAnchorRejectInvite>
>(liveAgentFrontAnchorRejectInvite);

const mockUrl_0_0_0_4 = 'http://yapi.ppx520.com/mock/8015' as any;
const dataKey_0_0_0_4 = 'data' as any;

export interface LiveAgentFrontGetKycConfigRequest {
  /**
   * 1
   */
  type: number;
}

export type LiveAgentFrontGetKycConfigResponse = any;
type LiveAgentFrontGetKycConfigRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetKycConfig',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontGetKycConfigRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_agent_front/GetKycConfig',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetKycConfig',
};

export const liveAgentFrontGetKycConfig = makeRequest<
  LiveAgentFrontGetKycConfigRequest,
  LiveAgentFrontGetKycConfigResponse
>(liveAgentFrontGetKycConfigRequestConfig);
export const useLiveAgentFrontGetKycConfig = makeRequestHook<
  LiveAgentFrontGetKycConfigRequest,
  LiveAgentFrontGetKycConfigRequestConfig,
  ReturnType<typeof liveAgentFrontGetKycConfig>
>(liveAgentFrontGetKycConfig);

export interface LiveAgentFrontSubmitKycInfoRequest {}

export type LiveAgentFrontSubmitKycInfoResponse = any;
type LiveAgentFrontSubmitKycInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/SubmitKycInfo',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentFrontSubmitKycInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_agent_front/SubmitKycInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontSubmitKycInfo',
};

export const liveAgentFrontSubmitKycInfo = makeRequest<
  LiveAgentFrontSubmitKycInfoRequest,
  LiveAgentFrontSubmitKycInfoResponse
>(liveAgentFrontSubmitKycInfoRequestConfig);
export const useLiveAgentFrontSubmitKycInfo = makeRequestHook<
  LiveAgentFrontSubmitKycInfoRequest,
  LiveAgentFrontSubmitKycInfoRequestConfig,
  ReturnType<typeof liveAgentFrontSubmitKycInfo>
>(liveAgentFrontSubmitKycInfo);

export interface LiveAgentFrontGetLastSubmittedKycInfoRequest {
  /**
   * Token
   */
  token: string;
  /**
   * 签约类型：1-主播  2-代理
   */
  signed_type: string;
}

export interface LiveAgentFrontGetLastSubmittedKycInfoResponse {
  is_kyc_tick: number;
  submit_type: number;
  is_renew: number;
  type: number;
  signed_status: number;
  legal_name: string;
  email: string;
  identity_no: string;
  bank_no: string;
  bank_name: string;
  bank_card_owner: string;
  identity_font: string;
  identity_back: string;
  identity_card: string;
  bank_card_font: string;
  local_information: {
    id: string;
    type: string;
    sort: string;
    image: string;
    content: {
      en: string;
      cn: string;
    };
  }[];
  contract_content: string;
  contract_effective_time: string;
  contract_expire_time: string;
  policy_content: string;
  phone_data: {
    acode: {
      AF: number;
      AL: number;
      AD: number;
      AO: number;
      AI: number;
      AG: number;
      AQ: number;
      AR: number;
      AS: number;
      AM: number;
      AT: number;
      AU: number;
      AW: number;
      AZ: number;
      BS: number;
      BH: number;
      BD: number;
      BB: number;
      BY: number;
      BE: number;
      BZ: number;
      BJ: number;
      BL: number;
      BM: number;
      BT: number;
      BO: number;
      BA: number;
      BW: number;
      BR: number;
      VG: number;
      BN: number;
      BG: number;
      BF: number;
      MM: number;
      BI: number;
      KH: number;
      CA: number;
      CC: number;
      CD: number;
      KY: number;
      CF: number;
      TD: number;
      KM: number;
      HR: number;
      CG: number;
      CH: number;
      CI: number;
      CK: number;
      CL: number;
      CM: number;
      CN: number;
      CO: number;
      CR: number;
      CU: number;
      CV: number;
      CX: number;
      CY: number;
      CZ: number;
      DE: number;
      DG: number;
      DJ: number;
      DK: number;
      DM: number;
      DO: number;
      DZ: number;
      EC: number;
      EE: number;
      EG: number;
      SV: number;
      GQ: number;
      ER: number;
      ET: number;
      FK: number;
      FO: number;
      FJ: number;
      FI: number;
      FR: number;
      PF: number;
      GA: number;
      GM: number;
      GE: number;
      GF: number;
      GH: number;
      GI: number;
      GR: number;
      GL: number;
      GP: number;
      GD: number;
      GU: number;
      GT: number;
      GN: number;
      GW: number;
      GY: number;
      HT: number;
      VA: number;
      HN: number;
      HK: number;
      HU: number;
      IS: number;
      IN: number;
      ID: number;
      IR: number;
      IQ: number;
      IE: number;
      IM: number;
      IL: number;
      IT: number;
      JM: number;
      JP: number;
      JO: number;
      KZ: number;
      KE: number;
      KI: number;
      KW: number;
      KG: number;
      LA: number;
      LV: number;
      LB: number;
      LS: number;
      LR: number;
      LY: number;
      LI: number;
      LT: number;
      LU: number;
      MO: number;
      MK: number;
      MG: number;
      MH: number;
      MW: number;
      MY: number;
      MV: number;
      ML: number;
      MT: number;
      MR: number;
      MU: number;
      YT: number;
      MX: number;
      FM: number;
      MD: number;
      MC: number;
      MN: number;
      ME: number;
      MS: number;
      MA: number;
      MQ: number;
      MZ: number;
      NA: number;
      NR: number;
      NP: number;
      NL: number;
      AN: number;
      NC: number;
      NZ: number;
      NI: number;
      NE: number;
      NG: number;
      NU: number;
      KP: number;
      MP: number;
      NO: number;
      OM: number;
      PK: number;
      PW: number;
      PA: number;
      PG: number;
      PY: number;
      PE: number;
      PH: number;
      PN: number;
      PL: number;
      PT: number;
      PR: number;
      PS: number;
      QA: number;
      RO: number;
      RU: number;
      RW: number;
      SH: number;
      KN: number;
      LC: number;
      MF: number;
      PM: number;
      VC: number;
      WS: number;
      SM: number;
      ST: number;
      SA: number;
      SN: number;
      RS: number;
      SC: number;
      SL: number;
      SG: number;
      SK: number;
      SI: number;
      SB: number;
      SO: number;
      ZA: number;
      KR: number;
      ES: number;
      LK: number;
      SD: number;
      SS: number;
      SR: number;
      SZ: number;
      SE: number;
      SY: number;
      TW: number;
      TJ: number;
      TZ: number;
      TH: number;
      TL: number;
      TG: number;
      TK: number;
      TO: number;
      TT: number;
      TN: number;
      TR: number;
      TM: number;
      TC: number;
      TV: number;
      UG: number;
      UA: number;
      AE: number;
      GB: number;
      US: number;
      UY: number;
      VI: number;
      UZ: number;
      VU: number;
      VE: number;
      VN: number;
      WF: number;
      YE: number;
      ZM: number;
      ZW: number;
    };
    country_data: {
      AX: string;
      BU: string;
      BV: string;
      CS: string;
      DD: string;
      EH: string;
      FX: string;
      GG: string;
      GS: string;
      HM: string;
      IO: string;
      JE: string;
      MM: string;
      NF: string;
      NT: string;
      RE: string;
      SJ: string;
      SU: string;
      TF: string;
      TP: string;
      UM: string;
      YD: string;
      YE: string;
      YU: string;
      ZR: string;
      ZZ: string;
      AU: string;
      BL: string;
      VA: string;
      AN: string;
      CA: string;
      US: string;
      KZ: string;
      RUB: string;
      RU: string;
      EG: string;
      ZA: string;
      GR: string;
      CC: string;
      NL: string;
      BE: string;
      FR: string;
      ES: string;
      HU: string;
      IT: string;
      RO: string;
      CH: string;
      AT: string;
      GB: string;
      DK: string;
      SE: string;
      NO: string;
      PL: string;
      DE: string;
      PE: string;
      MX: string;
      CU: string;
      AR: string;
      BR: string;
      CL: string;
      CO: string;
      VE: string;
      MY: string;
      CX: string;
      ID: string;
      PH: string;
      NZ: string;
      SG: string;
      TH: string;
      JP: string;
      KR: string;
      VN: string;
      CN: string;
      TR: string;
      IN: string;
      PK: string;
      AF: string;
      LK: string;
      IR: string;
      SS: string;
      MA: string;
      DZ: string;
      TN: string;
      LY: string;
      GM: string;
      SN: string;
      MR: string;
      ML: string;
      GN: string;
      CI: string;
      BF: string;
      NE: string;
      TG: string;
      BJ: string;
      MU: string;
      LR: string;
      SL: string;
      GH: string;
      NG: string;
      TD: string;
      CF: string;
      CM: string;
      CV: string;
      ST: string;
      GQ: string;
      GA: string;
      CG: string;
      CD: string;
      AO: string;
      GW: string;
      DG: string;
      SC: string;
      SD: string;
      RW: string;
      ET: string;
      SO: string;
      DJ: string;
      KE: string;
      TZ: string;
      UG: string;
      BI: string;
      MZ: string;
      ZM: string;
      MG: string;
      YT: string;
      ZW: string;
      NA: string;
      MW: string;
      LS: string;
      BW: string;
      SZ: string;
      KM: string;
      SH: string;
      ER: string;
      AW: string;
      FO: string;
      GL: string;
      GI: string;
      PT: string;
      LU: string;
      IE: string;
      IS: string;
      AL: string;
      MT: string;
      CY: string;
      FI: string;
      BG: string;
      LT: string;
      LV: string;
      EE: string;
      MD: string;
      AM: string;
      BY: string;
      AD: string;
      MC: string;
      SM: string;
      UA: string;
      RS: string;
      ME: string;
      HR: string;
      SI: string;
      BA: string;
      MK: string;
      CZ: string;
      SK: string;
      LI: string;
      FK: string;
      BZ: string;
      GT: string;
      SV: string;
      HN: string;
      NI: string;
      CR: string;
      PA: string;
      PM: string;
      HT: string;
      GP: string;
      BO: string;
      GY: string;
      EC: string;
      GF: string;
      PY: string;
      MQ: string;
      SR: string;
      UY: string;
      MF: string;
      TL: string;
      AQ: string;
      BN: string;
      NR: string;
      PG: string;
      TO: string;
      SB: string;
      VU: string;
      FJ: string;
      PW: string;
      WF: string;
      CK: string;
      NU: string;
      WS: string;
      KI: string;
      NC: string;
      TV: string;
      PF: string;
      TK: string;
      FM: string;
      MH: string;
      KP: string;
      HK: string;
      MO: string;
      KH: string;
      LA: string;
      BD: string;
      TW: string;
      MV: string;
      LB: string;
      JO: string;
      SY: string;
      IQ: string;
      KW: string;
      SA: string;
      OM: string;
      PS: string;
      AE: string;
      IL: string;
      BH: string;
      QA: string;
      BT: string;
      MN: string;
      NP: string;
      TJ: string;
      TM: string;
      AZ: string;
      GE: string;
      KG: string;
      UZ: string;
      BS: string;
      BB: string;
      AI: string;
      AG: string;
      VG: string;
      VI: string;
      KY: string;
      BM: string;
      GD: string;
      TC: string;
      MS: string;
      MP: string;
      GU: string;
      AS: string;
      LC: string;
      DM: string;
      VC: string;
      PR: string;
      DO: string;
      TT: string;
      KN: string;
      IM: string;
      JM: string;
      PN: string;
    };
  };
  is_company: number;
  address: string;
  swiftcode: string;
  bank_address: string;
  company_name: string;
  company_registered_address: string;
  company_tax_number: string;
  bank_region: string;
  country_bank: {
    Algeria: string[];
    Armenia: string[];
    Australia: string[];
    Austria: string[];
    Azerbaijan: string[];
    Bahrain: string[];
    Bangladesh: string[];
    Belarus: string[];
    Belgium: string[];
    Brazil: string[];
    Cambodia: string[];
    Canada: string[];
    Cyprus: string[];
    Denmark: string[];
    Egypt: string[];
    Estonia: string[];
    France: string[];
    Germany: string[];
    Greece: string[];
    "Hong Kong Special Administrative Region of People's Republic of China": string[];
    India: string[];
    Indonesia: string[];
    Iraq: string[];
    Ireland: string[];
    Israel: string[];
    Italy: string[];
    Japan: string[];
    Jordan: string[];
    Kazakhstan: string[];
    Kuwait: string[];
    Lebanon: string[];
    Liechtenstein: string[];
    Lithuania: string[];
    Malaysia: string[];
    Mexico: string[];
    Morocco: string[];
    Myanmar: string[];
    Netherlands: string[];
    'New Zealand': string[];
    Nigeria: string[];
    Norway: string[];
    Oman: string[];
    Pakistan: string[];
    "People's Republic of China": string[];
    Philippines: string[];
    Poland: string[];
    Qatar: string[];
    'Republic of China (Taiwan)': string[];
    'Republic of Korea': string[];
    Romania: string[];
    'Russian Federation': string[];
    'Saudi Arabia': string[];
    Singapore: string[];
    Spain: string[];
    'Sri Lanka': string[];
    'State of Palestine': string[];
    Sweden: string[];
    Switzerland: string[];
    Thailand: string[];
    Tunisia: string[];
    Turkey: string[];
    Ukraine: string[];
    'United Arab Emirates': string[];
    'United Kingdom of Great Britain and Northern Ireland': string[];
    'United States of America': string[];
    Vietnam: string[];
    Yemen: string[];
  };
}
type LiveAgentFrontGetLastSubmittedKycInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetLastSubmittedKycInfo',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontGetLastSubmittedKycInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_agent_front/GetLastSubmittedKycInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetLastSubmittedKycInfo',
};

export const liveAgentFrontGetLastSubmittedKycInfo = makeRequest<
  LiveAgentFrontGetLastSubmittedKycInfoRequest,
  LiveAgentFrontGetLastSubmittedKycInfoResponse
>(liveAgentFrontGetLastSubmittedKycInfoRequestConfig);
export const useLiveAgentFrontGetLastSubmittedKycInfo = makeRequestHook<
  LiveAgentFrontGetLastSubmittedKycInfoRequest,
  LiveAgentFrontGetLastSubmittedKycInfoRequestConfig,
  ReturnType<typeof liveAgentFrontGetLastSubmittedKycInfo>
>(liveAgentFrontGetLastSubmittedKycInfo);

export interface LiveAgentFrontUpdateKycInfoRequest {}

export type LiveAgentFrontUpdateKycInfoResponse = any;
type LiveAgentFrontUpdateKycInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/UpdateKycInfo',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentFrontUpdateKycInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_agent_front/UpdateKycInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontUpdateKycInfo',
};

export const liveAgentFrontUpdateKycInfo = makeRequest<
  LiveAgentFrontUpdateKycInfoRequest,
  LiveAgentFrontUpdateKycInfoResponse
>(liveAgentFrontUpdateKycInfoRequestConfig);
export const useLiveAgentFrontUpdateKycInfo = makeRequestHook<
  LiveAgentFrontUpdateKycInfoRequest,
  LiveAgentFrontUpdateKycInfoRequestConfig,
  ReturnType<typeof liveAgentFrontUpdateKycInfo>
>(liveAgentFrontUpdateKycInfo);

export interface LiveAgentFrontGetKycEntranceRequest {
  /**
   * 1232432
   */
  seq_id: number;
}

export interface LiveAgentFrontGetKycEntranceResponse {
  sign_type: number;
}
type LiveAgentFrontGetKycEntranceRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetKycEntrance',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontGetKycEntranceRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_agent_front/GetKycEntrance',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetKycEntrance',
};

export const liveAgentFrontGetKycEntrance = makeRequest<
  LiveAgentFrontGetKycEntranceRequest,
  LiveAgentFrontGetKycEntranceResponse
>(liveAgentFrontGetKycEntranceRequestConfig);
export const useLiveAgentFrontGetKycEntrance = makeRequestHook<
  LiveAgentFrontGetKycEntranceRequest,
  LiveAgentFrontGetKycEntranceRequestConfig,
  ReturnType<typeof liveAgentFrontGetKycEntrance>
>(liveAgentFrontGetKycEntrance);

export interface LiveAgentFrontExtendContractRequest {}

export type LiveAgentFrontExtendContractResponse = any;
type LiveAgentFrontExtendContractRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/ExtendContract',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentFrontExtendContractRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_agent_front/ExtendContract',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontExtendContract',
};

export const liveAgentFrontExtendContract = makeRequest<
  LiveAgentFrontExtendContractRequest,
  LiveAgentFrontExtendContractResponse
>(liveAgentFrontExtendContractRequestConfig);
export const useLiveAgentFrontExtendContract = makeRequestHook<
  LiveAgentFrontExtendContractRequest,
  LiveAgentFrontExtendContractRequestConfig,
  ReturnType<typeof liveAgentFrontExtendContract>
>(liveAgentFrontExtendContract);

export interface LiveAgentFrontCheckAnchorKycStatusRequest {}

export interface LiveAgentFrontCheckAnchorKycStatusResponse {
  kyc_status: number;
  recheck_status: number;
  user_type: number;
}
type LiveAgentFrontCheckAnchorKycStatusRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/CheckAnchorKycStatus',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentFrontCheckAnchorKycStatusRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_agent_front/CheckAnchorKycStatus',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontCheckAnchorKycStatus',
};

export const liveAgentFrontCheckAnchorKycStatus = makeRequest<
  LiveAgentFrontCheckAnchorKycStatusRequest,
  LiveAgentFrontCheckAnchorKycStatusResponse
>(liveAgentFrontCheckAnchorKycStatusRequestConfig);
export const useLiveAgentFrontCheckAnchorKycStatus = makeRequestHook<
  LiveAgentFrontCheckAnchorKycStatusRequest,
  LiveAgentFrontCheckAnchorKycStatusRequestConfig,
  ReturnType<typeof liveAgentFrontCheckAnchorKycStatus>
>(liveAgentFrontCheckAnchorKycStatus);

export interface LiveAgentPortalSubmitRecheckKycInfoRequest {}

export type LiveAgentPortalSubmitRecheckKycInfoResponse = any;
type LiveAgentPortalSubmitRecheckKycInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_portal/submitRecheckKycInfo',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentPortalSubmitRecheckKycInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_agent_portal/submitRecheckKycInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentPortalSubmitRecheckKycInfo',
};

export const liveAgentPortalSubmitRecheckKycInfo = makeRequest<
  LiveAgentPortalSubmitRecheckKycInfoRequest,
  LiveAgentPortalSubmitRecheckKycInfoResponse
>(liveAgentPortalSubmitRecheckKycInfoRequestConfig);
export const useLiveAgentPortalSubmitRecheckKycInfo = makeRequestHook<
  LiveAgentPortalSubmitRecheckKycInfoRequest,
  LiveAgentPortalSubmitRecheckKycInfoRequestConfig,
  ReturnType<typeof liveAgentPortalSubmitRecheckKycInfo>
>(liveAgentPortalSubmitRecheckKycInfo);

export interface LiveAgentPortalCheckIdentityIdExistRequest {}

export type LiveAgentPortalCheckIdentityIdExistResponse = any;
type LiveAgentPortalCheckIdentityIdExistRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_portal/checkIdentityIdExist',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentPortalCheckIdentityIdExistRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_agent_portal/checkIdentityIdExist',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentPortalCheckIdentityIdExist',
};

export const liveAgentPortalCheckIdentityIdExist = makeRequest<
  LiveAgentPortalCheckIdentityIdExistRequest,
  LiveAgentPortalCheckIdentityIdExistResponse
>(liveAgentPortalCheckIdentityIdExistRequestConfig);
export const useLiveAgentPortalCheckIdentityIdExist = makeRequestHook<
  LiveAgentPortalCheckIdentityIdExistRequest,
  LiveAgentPortalCheckIdentityIdExistRequestConfig,
  ReturnType<typeof liveAgentPortalCheckIdentityIdExist>
>(liveAgentPortalCheckIdentityIdExist);

export interface LiveAgentServiceGetUnFinishKycAnchorCountRequest {}

export interface LiveAgentServiceGetUnFinishKycAnchorCountResponse {
  count: number;
}
type LiveAgentServiceGetUnFinishKycAnchorCountRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/GetUnFinishKycAnchorCount',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentServiceGetUnFinishKycAnchorCountRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_agent_service/GetUnFinishKycAnchorCount',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceGetUnFinishKycAnchorCount',
};

export const liveAgentServiceGetUnFinishKycAnchorCount = makeRequest<
  LiveAgentServiceGetUnFinishKycAnchorCountRequest,
  LiveAgentServiceGetUnFinishKycAnchorCountResponse
>(liveAgentServiceGetUnFinishKycAnchorCountRequestConfig);
export const useLiveAgentServiceGetUnFinishKycAnchorCount = makeRequestHook<
  LiveAgentServiceGetUnFinishKycAnchorCountRequest,
  LiveAgentServiceGetUnFinishKycAnchorCountRequestConfig,
  ReturnType<typeof liveAgentServiceGetUnFinishKycAnchorCount>
>(liveAgentServiceGetUnFinishKycAnchorCount);

export interface LiveAgentServiceGetUnFinishKycAnchorListRequest {
  last_uid: number;
  /**
   * 100
   */
  page_size: number;
}

export interface LiveAgentServiceGetUnFinishKycAnchorListResponse {
  count: number;
  rows: {
    uid: number;
    avatar: string;
    nickname: string;
    bigoid: string;
    this_month_bean: number;
    sixty_days_bean: number;
  }[];
}
type LiveAgentServiceGetUnFinishKycAnchorListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/GetUnFinishKycAnchorList',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServiceGetUnFinishKycAnchorListRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_agent_service/GetUnFinishKycAnchorList',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceGetUnFinishKycAnchorList',
};

export const liveAgentServiceGetUnFinishKycAnchorList = makeRequest<
  LiveAgentServiceGetUnFinishKycAnchorListRequest,
  LiveAgentServiceGetUnFinishKycAnchorListResponse
>(liveAgentServiceGetUnFinishKycAnchorListRequestConfig);
export const useLiveAgentServiceGetUnFinishKycAnchorList = makeRequestHook<
  LiveAgentServiceGetUnFinishKycAnchorListRequest,
  LiveAgentServiceGetUnFinishKycAnchorListRequestConfig,
  ReturnType<typeof liveAgentServiceGetUnFinishKycAnchorList>
>(liveAgentServiceGetUnFinishKycAnchorList);

export interface LiveAgentPortalSubmitUserKycInfoRequest {}

export type LiveAgentPortalSubmitUserKycInfoResponse = any;
type LiveAgentPortalSubmitUserKycInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_portal/submitUserKycInfo',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentPortalSubmitUserKycInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_agent_portal/submitUserKycInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentPortalSubmitUserKycInfo',
};

export const liveAgentPortalSubmitUserKycInfo = makeRequest<
  LiveAgentPortalSubmitUserKycInfoRequest,
  LiveAgentPortalSubmitUserKycInfoResponse
>(liveAgentPortalSubmitUserKycInfoRequestConfig);
export const useLiveAgentPortalSubmitUserKycInfo = makeRequestHook<
  LiveAgentPortalSubmitUserKycInfoRequest,
  LiveAgentPortalSubmitUserKycInfoRequestConfig,
  ReturnType<typeof liveAgentPortalSubmitUserKycInfo>
>(liveAgentPortalSubmitUserKycInfo);

export interface LiveAgentPortalAnchorConfirmContractRequest {
  /**
   * true
   */
  is_confirm: boolean;
}

export interface LiveAgentPortalAnchorConfirmContractResponse {
  reqSymbol: string;
  code: number;
  msg: string;
  success: boolean;
}
type LiveAgentPortalAnchorConfirmContractRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_portal/anchorConfirmContract',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentPortalAnchorConfirmContractRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_agent_portal/anchorConfirmContract',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentPortalAnchorConfirmContract',
};

export const liveAgentPortalAnchorConfirmContract = makeRequest<
  LiveAgentPortalAnchorConfirmContractRequest,
  LiveAgentPortalAnchorConfirmContractResponse
>(liveAgentPortalAnchorConfirmContractRequestConfig);
export const useLiveAgentPortalAnchorConfirmContract = makeRequestHook<
  LiveAgentPortalAnchorConfirmContractRequest,
  LiveAgentPortalAnchorConfirmContractRequestConfig,
  ReturnType<typeof liveAgentPortalAnchorConfirmContract>
>(liveAgentPortalAnchorConfirmContract);

export interface LiveAgentPortalKycStatusRequest {}

export type LiveAgentPortalKycStatusResponse = any;
type LiveAgentPortalKycStatusRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_portal/kycStatus',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentPortalKycStatusRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_agent_portal/kycStatus',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentPortalKycStatus',
};

export const liveAgentPortalKycStatus = makeRequest<
  LiveAgentPortalKycStatusRequest,
  LiveAgentPortalKycStatusResponse
>(liveAgentPortalKycStatusRequestConfig);
export const useLiveAgentPortalKycStatus = makeRequestHook<
  LiveAgentPortalKycStatusRequest,
  LiveAgentPortalKycStatusRequestConfig,
  ReturnType<typeof liveAgentPortalKycStatus>
>(liveAgentPortalKycStatus);

export interface LiveAgentPortalCheckKycRequest {}

export interface LiveAgentPortalCheckKycResponse {}
type LiveAgentPortalCheckKycRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_portal/checkKyc',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentPortalCheckKycRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_agent_portal/checkKyc',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentPortalCheckKyc',
};

export const liveAgentPortalCheckKyc = makeRequest<
  LiveAgentPortalCheckKycRequest,
  LiveAgentPortalCheckKycResponse
>(liveAgentPortalCheckKycRequestConfig);
export const useLiveAgentPortalCheckKyc = makeRequestHook<
  LiveAgentPortalCheckKycRequest,
  LiveAgentPortalCheckKycRequestConfig,
  ReturnType<typeof liveAgentPortalCheckKyc>
>(liveAgentPortalCheckKyc);

export interface LiveAgentPortalKycRejectInfoRequest {}

export interface LiveAgentPortalKycRejectInfoResponse {}
type LiveAgentPortalKycRejectInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_portal/kycRejectInfo',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentPortalKycRejectInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_agent_portal/kycRejectInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentPortalKycRejectInfo',
};

export const liveAgentPortalKycRejectInfo = makeRequest<
  LiveAgentPortalKycRejectInfoRequest,
  LiveAgentPortalKycRejectInfoResponse
>(liveAgentPortalKycRejectInfoRequestConfig);
export const useLiveAgentPortalKycRejectInfo = makeRequestHook<
  LiveAgentPortalKycRejectInfoRequest,
  LiveAgentPortalKycRejectInfoRequestConfig,
  ReturnType<typeof liveAgentPortalKycRejectInfo>
>(liveAgentPortalKycRejectInfo);

export interface LiveKycManagerGetKycInfoRequest {}

export interface LiveKycManagerGetKycInfoResponse {}
type LiveKycManagerGetKycInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_kyc_manager/GetKycInfo',
    'data',
    string,
    string,
    true
  >
>;

const liveKycManagerGetKycInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_kyc_manager/GetKycInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveKycManagerGetKycInfo',
};

export const liveKycManagerGetKycInfo = makeRequest<
  LiveKycManagerGetKycInfoRequest,
  LiveKycManagerGetKycInfoResponse
>(liveKycManagerGetKycInfoRequestConfig);
export const useLiveKycManagerGetKycInfo = makeRequestHook<
  LiveKycManagerGetKycInfoRequest,
  LiveKycManagerGetKycInfoRequestConfig,
  ReturnType<typeof liveKycManagerGetKycInfo>
>(liveKycManagerGetKycInfo);

export interface LiveKycManagerSubmitKycInfoRequest {}

export interface LiveKycManagerSubmitKycInfoResponse {}
type LiveKycManagerSubmitKycInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_kyc_manager/SubmitKycInfo',
    'data',
    string,
    string,
    true
  >
>;

const liveKycManagerSubmitKycInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_kyc_manager/SubmitKycInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveKycManagerSubmitKycInfo',
};

export const liveKycManagerSubmitKycInfo = makeRequest<
  LiveKycManagerSubmitKycInfoRequest,
  LiveKycManagerSubmitKycInfoResponse
>(liveKycManagerSubmitKycInfoRequestConfig);
export const useLiveKycManagerSubmitKycInfo = makeRequestHook<
  LiveKycManagerSubmitKycInfoRequest,
  LiveKycManagerSubmitKycInfoRequestConfig,
  ReturnType<typeof liveKycManagerSubmitKycInfo>
>(liveKycManagerSubmitKycInfo);

export interface LiveKycManagerCheckIdentityIdExistRequest {}

export interface LiveKycManagerCheckIdentityIdExistResponse {}
type LiveKycManagerCheckIdentityIdExistRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_kyc_manager/CheckIdentityIdExist',
    'data',
    string,
    string,
    true
  >
>;

const liveKycManagerCheckIdentityIdExistRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_kyc_manager/CheckIdentityIdExist',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveKycManagerCheckIdentityIdExist',
};

export const liveKycManagerCheckIdentityIdExist = makeRequest<
  LiveKycManagerCheckIdentityIdExistRequest,
  LiveKycManagerCheckIdentityIdExistResponse
>(liveKycManagerCheckIdentityIdExistRequestConfig);
export const useLiveKycManagerCheckIdentityIdExist = makeRequestHook<
  LiveKycManagerCheckIdentityIdExistRequest,
  LiveKycManagerCheckIdentityIdExistRequestConfig,
  ReturnType<typeof liveKycManagerCheckIdentityIdExist>
>(liveKycManagerCheckIdentityIdExist);

export interface LiveAgentFrontGetKycCountryConfigRequest {
  /**
   * 1
   */
  type: number;
  /**
   * "AD"
   */
  lang_code: string;
}

export interface LiveAgentFrontGetKycCountryConfigResponse {
  country_code: {
    US: {
      lang: string;
      name: string;
    };
    SG: {
      lang: string;
      name: string;
    };
  };
  country_identity: {
    US: {
      identity_list: {
        lang: string;
        name: string;
        identity_no_disable: number;
      }[];
    };
    SG: {
      identity_list: {
        lang: string;
        name: string;
        identity_no_disable: number;
      }[];
    };
  };
}
type LiveAgentFrontGetKycCountryConfigRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetKycCountryConfig',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontGetKycCountryConfigRequestConfig = {
  mockUrl: mockUrl_0_0_0_4,
  path: '/bigolive/live_agent_front/GetKycCountryConfig',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetKycCountryConfig',
};

export const liveAgentFrontGetKycCountryConfig = makeRequest<
  LiveAgentFrontGetKycCountryConfigRequest,
  LiveAgentFrontGetKycCountryConfigResponse
>(liveAgentFrontGetKycCountryConfigRequestConfig);
export const useLiveAgentFrontGetKycCountryConfig = makeRequestHook<
  LiveAgentFrontGetKycCountryConfigRequest,
  LiveAgentFrontGetKycCountryConfigRequestConfig,
  ReturnType<typeof liveAgentFrontGetKycCountryConfig>
>(liveAgentFrontGetKycCountryConfig);

const mockUrl_0_0_0_5 = 'http://yapi.ppx520.com/mock/8015' as any;
const dataKey_0_0_0_5 = 'data' as any;

export interface LiveAgentFrontGetAnchorSignDetailRequest {
  /**
   * 123456789
   */
  seq_id: number;
}

export interface LiveAgentFrontGetAnchorSignDetailResponse {
  sign_info: {
    agent_name: string;
    agent_bigoid: string;
    contract_begin_ts: number;
    contract_end_ts: number;
    kyc_status: number;
    hide_kyc_verify: number;
    new_contract_begin_ts: number;
    new_contract_end_ts: number;
    is_official: boolean;
    agent_region: string;
  };
}
type LiveAgentFrontGetAnchorSignDetailRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetAnchorSignDetail',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontGetAnchorSignDetailRequestConfig = {
  mockUrl: mockUrl_0_0_0_5,
  path: '/bigolive/live_agent_front/GetAnchorSignDetail',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_5,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetAnchorSignDetail',
};

export const liveAgentFrontGetAnchorSignDetail = makeRequest<
  LiveAgentFrontGetAnchorSignDetailRequest,
  LiveAgentFrontGetAnchorSignDetailResponse
>(liveAgentFrontGetAnchorSignDetailRequestConfig);
export const useLiveAgentFrontGetAnchorSignDetail = makeRequestHook<
  LiveAgentFrontGetAnchorSignDetailRequest,
  LiveAgentFrontGetAnchorSignDetailRequestConfig,
  ReturnType<typeof liveAgentFrontGetAnchorSignDetail>
>(liveAgentFrontGetAnchorSignDetail);

export interface LiveAgentFrontGetAnchorSignProgressRequest {
  /**
   * 1233456789
   */
  seq_id: number;
}

export interface LiveAgentFrontGetAnchorSignProgressResponse {
  entire_progress: number[];
  historical_progress: {
    ts: number;
    progress: number;
    status: number;
    description: string;
  }[];
  progress: number;
  status: number;
  description: string;
}
type LiveAgentFrontGetAnchorSignProgressRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetAnchorSignProgress',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontGetAnchorSignProgressRequestConfig = {
  mockUrl: mockUrl_0_0_0_5,
  path: '/bigolive/live_agent_front/GetAnchorSignProgress',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_5,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetAnchorSignProgress',
};

export const liveAgentFrontGetAnchorSignProgress = makeRequest<
  LiveAgentFrontGetAnchorSignProgressRequest,
  LiveAgentFrontGetAnchorSignProgressResponse
>(liveAgentFrontGetAnchorSignProgressRequestConfig);
export const useLiveAgentFrontGetAnchorSignProgress = makeRequestHook<
  LiveAgentFrontGetAnchorSignProgressRequest,
  LiveAgentFrontGetAnchorSignProgressRequestConfig,
  ReturnType<typeof liveAgentFrontGetAnchorSignProgress>
>(liveAgentFrontGetAnchorSignProgress);

export interface LiveAgentFrontGetAuditBanListRequest {}

export interface LiveAgentFrontGetAuditBanListResponse {
  ban_list: {}[];
}
type LiveAgentFrontGetAuditBanListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetAuditBanList',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentFrontGetAuditBanListRequestConfig = {
  mockUrl: mockUrl_0_0_0_5,
  path: '/bigolive/live_agent_front/GetAuditBanList',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_5,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetAuditBanList',
};

export const liveAgentFrontGetAuditBanList = makeRequest<
  LiveAgentFrontGetAuditBanListRequest,
  LiveAgentFrontGetAuditBanListResponse
>(liveAgentFrontGetAuditBanListRequestConfig);
export const useLiveAgentFrontGetAuditBanList = makeRequestHook<
  LiveAgentFrontGetAuditBanListRequest,
  LiveAgentFrontGetAuditBanListRequestConfig,
  ReturnType<typeof liveAgentFrontGetAuditBanList>
>(liveAgentFrontGetAuditBanList);

const mockUrl_0_0_0_6 = 'http://yapi.ppx520.com/mock/8015' as any;
const dataKey_0_0_0_6 = 'data' as any;

export interface LiveAgentFrontGetAgentDetailRequest {
  /**
   * 1233456789
   */
  seq_id: number;
}

export interface LiveAgentFrontGetAgentDetailResponse {
  sign_info: {
    role: number;
    agent_name: string;
    contract_begin_ts: number;
    contract_end_ts: number;
    kyc_status: number;
    new_contract_begin_ts: number;
    new_contract_end_ts: number;
    agent_bigoid: string;
    agent_avatar: string;
    agent_uid: number;
  };
}
type LiveAgentFrontGetAgentDetailRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetAgentDetail',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontGetAgentDetailRequestConfig = {
  mockUrl: mockUrl_0_0_0_6,
  path: '/bigolive/live_agent_front/GetAgentDetail',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_6,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetAgentDetail',
};

export const liveAgentFrontGetAgentDetail = makeRequest<
  LiveAgentFrontGetAgentDetailRequest,
  LiveAgentFrontGetAgentDetailResponse
>(liveAgentFrontGetAgentDetailRequestConfig);
export const useLiveAgentFrontGetAgentDetail = makeRequestHook<
  LiveAgentFrontGetAgentDetailRequest,
  LiveAgentFrontGetAgentDetailRequestConfig,
  ReturnType<typeof liveAgentFrontGetAgentDetail>
>(liveAgentFrontGetAgentDetail);

export interface LiveAgentFrontGetAgentSignProgressRequest {
  /**
   * 1233456789
   */
  seq_id: number;
}

export interface LiveAgentFrontGetAgentSignProgressResponse {
  entire_progress: number[];
  historical_progress: {
    ts: number;
    progress: number;
    status: number;
    description: string;
  }[];
  progress: number;
  status: number;
  description: string;
}
type LiveAgentFrontGetAgentSignProgressRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetAgentSignProgress',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontGetAgentSignProgressRequestConfig = {
  mockUrl: mockUrl_0_0_0_6,
  path: '/bigolive/live_agent_front/GetAgentSignProgress',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_6,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetAgentSignProgress',
};

export const liveAgentFrontGetAgentSignProgress = makeRequest<
  LiveAgentFrontGetAgentSignProgressRequest,
  LiveAgentFrontGetAgentSignProgressResponse
>(liveAgentFrontGetAgentSignProgressRequestConfig);
export const useLiveAgentFrontGetAgentSignProgress = makeRequestHook<
  LiveAgentFrontGetAgentSignProgressRequest,
  LiveAgentFrontGetAgentSignProgressRequestConfig,
  ReturnType<typeof liveAgentFrontGetAgentSignProgress>
>(liveAgentFrontGetAgentSignProgress);

export interface LiveAgentFrontGetAgentDataRequest {}

export interface LiveAgentFrontGetAgentDataResponse {
  avatar: string;
  month: number;
  sign_anchor_num: number;
  month_live_time: number;
  month_bean_num: number;
}
type LiveAgentFrontGetAgentDataRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetAgentData',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentFrontGetAgentDataRequestConfig = {
  mockUrl: mockUrl_0_0_0_6,
  path: '/bigolive/live_agent_front/GetAgentData',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_6,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetAgentData',
};

export const liveAgentFrontGetAgentData = makeRequest<
  LiveAgentFrontGetAgentDataRequest,
  LiveAgentFrontGetAgentDataResponse
>(liveAgentFrontGetAgentDataRequestConfig);
export const useLiveAgentFrontGetAgentData = makeRequestHook<
  LiveAgentFrontGetAgentDataRequest,
  LiveAgentFrontGetAgentDataRequestConfig,
  ReturnType<typeof liveAgentFrontGetAgentData>
>(liveAgentFrontGetAgentData);

export interface LiveAgentUnionOssGetBrokerDataRequest {}

export interface LiveAgentUnionOssGetBrokerDataResponse {
  avatar: string;
  cur_anchor_num: number;
  new_anchor_num: number;
  pending_anchor_num: number;
}
type LiveAgentUnionOssGetBrokerDataRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/getBrokerData',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentUnionOssGetBrokerDataRequestConfig = {
  mockUrl: mockUrl_0_0_0_6,
  path: '/bigolive/live_agent_union_oss/getBrokerData',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_6,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssGetBrokerData',
};

export const liveAgentUnionOssGetBrokerData = makeRequest<
  LiveAgentUnionOssGetBrokerDataRequest,
  LiveAgentUnionOssGetBrokerDataResponse
>(liveAgentUnionOssGetBrokerDataRequestConfig);
export const useLiveAgentUnionOssGetBrokerData = makeRequestHook<
  LiveAgentUnionOssGetBrokerDataRequest,
  LiveAgentUnionOssGetBrokerDataRequestConfig,
  ReturnType<typeof liveAgentUnionOssGetBrokerData>
>(liveAgentUnionOssGetBrokerData);

export interface AgentOssQueryProxyOverviewRequest {
  /**
   * "2023-02-10"
   */
  startTime: string;
  /**
   * "2023-03-10"
   */
  endTime: string;
}

export interface AgentOssQueryProxyOverviewResponse {
  liveTime: number;
  beans: number;
  anchorCnt: number;
  avatar: string;
  packGiftBeans: number;
}
type AgentOssQueryProxyOverviewRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigo_act_livedata_api/agentOss/queryProxyOverview',
    'data',
    string,
    string,
    false
  >
>;

const agentOssQueryProxyOverviewRequestConfig = {
  mockUrl: mockUrl_0_0_0_6,
  path: '/bigo_act_livedata_api/agentOss/queryProxyOverview',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_6,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssQueryProxyOverview',
};

export const agentOssQueryProxyOverview = makeRequest<
  AgentOssQueryProxyOverviewRequest,
  AgentOssQueryProxyOverviewResponse
>(agentOssQueryProxyOverviewRequestConfig);
export const useAgentOssQueryProxyOverview = makeRequestHook<
  AgentOssQueryProxyOverviewRequest,
  AgentOssQueryProxyOverviewRequestConfig,
  ReturnType<typeof agentOssQueryProxyOverview>
>(agentOssQueryProxyOverview);

export interface LiveAgentUnionOssPolicyPreviewRequest {
  /**
   * "123123123"
   */
  id: string;
  /**
   * "en"
   */
  lang: string;
}

export interface LiveAgentUnionOssPolicyPreviewResponse {
  id: string;
  code: string;
  name: string;
  type: string;
  approval_process: string;
  content: string;
  status: string;
  region_id: string;
  code_suffix: string;
  day_min: string;
  day_max: string;
  month_min: string;
  month_max: string;
  operator: string;
  ctime: string;
  utime: string;
  ia_auditor: string;
  ia_audit_time: string;
  disabled_username: string;
  ext1: string;
  ext2: string;
  ext3: string;
  content_desc: string;
  is_proxy_select: string;
  proxy_show_name: string;
  proxy_show_intro: string;
  disable_operator: string;
  disable_time: string;
  previewRegion: string;
  previewRegionEn: string;
  previewType: string;
}
type LiveAgentUnionOssPolicyPreviewRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_union_oss/policyPreview',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentUnionOssPolicyPreviewRequestConfig = {
  mockUrl: mockUrl_0_0_0_6,
  path: '/bigolive/live_agent_union_oss/policyPreview',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_6,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentUnionOssPolicyPreview',
};

export const liveAgentUnionOssPolicyPreview = makeRequest<
  LiveAgentUnionOssPolicyPreviewRequest,
  LiveAgentUnionOssPolicyPreviewResponse
>(liveAgentUnionOssPolicyPreviewRequestConfig);
export const useLiveAgentUnionOssPolicyPreview = makeRequestHook<
  LiveAgentUnionOssPolicyPreviewRequest,
  LiveAgentUnionOssPolicyPreviewRequestConfig,
  ReturnType<typeof liveAgentUnionOssPolicyPreview>
>(liveAgentUnionOssPolicyPreview);

export interface Act_75352AgentEntranceRequest {}

export interface Act_75352AgentEntranceResponse {
  hasEntrance: boolean;
}
type Act_75352AgentEntranceRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigo_act_75352_api/act_75352/agent/entrance',
    'data',
    string,
    string,
    true
  >
>;

const act_75352AgentEntranceRequestConfig = {
  mockUrl: mockUrl_0_0_0_6,
  path: '/bigo_act_75352_api/act_75352/agent/entrance',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_6,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_75352AgentEntrance',
};

export const act_75352AgentEntrance = makeRequest<
  Act_75352AgentEntranceRequest,
  Act_75352AgentEntranceResponse
>(act_75352AgentEntranceRequestConfig);
export const useAct_75352AgentEntrance = makeRequestHook<
  Act_75352AgentEntranceRequest,
  Act_75352AgentEntranceRequestConfig,
  ReturnType<typeof act_75352AgentEntrance>
>(act_75352AgentEntrance);

const mockUrl_0_0_0_7 = 'http://yapi.ppx520.com/mock/8015' as any;
const dataKey_0_0_0_7 = 'data' as any;

export interface LiveAgentFrontGetUserRoleRequest {
  /**
   * 1
   */
  source: number;
  security_packet: string;
}

export interface LiveAgentFrontGetUserRoleResponse {
  anchor_role: {
    role: number;
    other: {
      agent_invitation: string;
      'kyc_verify:': string;
      contract_extension: string;
      hide_signed_status: string;
      can_transfer: string;
      contract_end_if_transfer: string;
      agent_name: string;
      is_official: string;
      agent_region: string;
      regret_days: string;
    };
  };
  agent_role: {
    role: number;
    other: {
      anchor_pending: string;
      recruit_type: string;
      recruit_permisson: string;
      kyc_verify: string;
      contract_extension: string;
      can_apply: string;
      can_apply_logic_code: string;
      can_manage_anchor_relation: string;
    };
  };
  act77307_invite_entry: boolean;
}
type LiveAgentFrontGetUserRoleRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetUserRole',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontGetUserRoleRequestConfig = {
  mockUrl: mockUrl_0_0_0_7,
  path: '/bigolive/live_agent_front/GetUserRole',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetUserRole',
};

export const liveAgentFrontGetUserRole = makeRequest<
  LiveAgentFrontGetUserRoleRequest,
  LiveAgentFrontGetUserRoleResponse
>(liveAgentFrontGetUserRoleRequestConfig);
export const useLiveAgentFrontGetUserRole = makeRequestHook<
  LiveAgentFrontGetUserRoleRequest,
  LiveAgentFrontGetUserRoleRequestConfig,
  ReturnType<typeof liveAgentFrontGetUserRole>
>(liveAgentFrontGetUserRole);

export interface LiveAgentFrontCheckNewAgentOssRequest {
  /**
   * 1
   */
  source: number;
  /**
   * 1
   */
  platform: number;
  /**
   * 123
   */
  version: number;
}

export interface LiveAgentFrontCheckNewAgentOssResponse {
  use_new_agent_oss: boolean;
}
type LiveAgentFrontCheckNewAgentOssRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/CheckNewAgentOss',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontCheckNewAgentOssRequestConfig = {
  mockUrl: mockUrl_0_0_0_7,
  path: '/bigolive/live_agent_front/CheckNewAgentOss',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontCheckNewAgentOss',
};

export const liveAgentFrontCheckNewAgentOss = makeRequest<
  LiveAgentFrontCheckNewAgentOssRequest,
  LiveAgentFrontCheckNewAgentOssResponse
>(liveAgentFrontCheckNewAgentOssRequestConfig);
export const useLiveAgentFrontCheckNewAgentOss = makeRequestHook<
  LiveAgentFrontCheckNewAgentOssRequest,
  LiveAgentFrontCheckNewAgentOssRequestConfig,
  ReturnType<typeof liveAgentFrontCheckNewAgentOss>
>(liveAgentFrontCheckNewAgentOss);

export interface LiveAgentFrontGetOssOpenRegionRequest {
  /**
   * 123456789
   */
  seq_id: number;
}

export interface LiveAgentFrontGetOssOpenRegionResponse {
  main_switch: number;
  open_region: string[];
}
type LiveAgentFrontGetOssOpenRegionRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/GetOssOpenRegion',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontGetOssOpenRegionRequestConfig = {
  mockUrl: mockUrl_0_0_0_7,
  path: '/bigolive/live_agent_front/GetOssOpenRegion',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontGetOssOpenRegion',
};

export const liveAgentFrontGetOssOpenRegion = makeRequest<
  LiveAgentFrontGetOssOpenRegionRequest,
  LiveAgentFrontGetOssOpenRegionResponse
>(liveAgentFrontGetOssOpenRegionRequestConfig);
export const useLiveAgentFrontGetOssOpenRegion = makeRequestHook<
  LiveAgentFrontGetOssOpenRegionRequest,
  LiveAgentFrontGetOssOpenRegionRequestConfig,
  ReturnType<typeof liveAgentFrontGetOssOpenRegion>
>(liveAgentFrontGetOssOpenRegion);

export interface LiveAgentFrontAgentPreCheckRequest {
  /**
   * 3
   */
  source: number;
  security_packet: string;
}

export interface LiveAgentFrontAgentPreCheckResponse {
  role: number;
  other: {
    can_apply_logic_code: string;
  };
}
type LiveAgentFrontAgentPreCheckRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/AgentPreCheck',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontAgentPreCheckRequestConfig = {
  mockUrl: mockUrl_0_0_0_7,
  path: '/bigolive/live_agent_front/AgentPreCheck',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontAgentPreCheck',
};

export const liveAgentFrontAgentPreCheck = makeRequest<
  LiveAgentFrontAgentPreCheckRequest,
  LiveAgentFrontAgentPreCheckResponse
>(liveAgentFrontAgentPreCheckRequestConfig);
export const useLiveAgentFrontAgentPreCheck = makeRequestHook<
  LiveAgentFrontAgentPreCheckRequest,
  LiveAgentFrontAgentPreCheckRequestConfig,
  ReturnType<typeof liveAgentFrontAgentPreCheck>
>(liveAgentFrontAgentPreCheck);

const mockUrl_0_0_0_8 = 'http://yapi.ppx520.com/mock/8015' as any;
const dataKey_0_0_0_8 = 'data' as any;

export interface LiveAgentSecurityCenterQueryBanListRequest {
  /**
   * 123
   */
  seqid: number;
  /**
   * "test_name"
   */
  bigo_id: string;
  /**
   * [1,2,3]
   */
  regions: number[];
  /**
   * ["CN","EN"]
   */
  countries: string[];
  /**
   * 1
   */
  order_by: number;
  /**
   * 20
   */
  count: number;
  reflection: string;
}

export interface LiveAgentSecurityCenterQueryBanListResponse {
  infos: {
    uid: number;
    bigo_id: string;
    nick_name: string;
    avatar: string;
    deny_type: number;
    deny_type_lang: string;
    business_reason: string;
    start_s: number;
    end_s: number;
    appeal_status: number;
    broker_name: string;
    can_appeal: boolean;
    allow_appeal_pic: boolean;
  }[];
  reflection: string;
}
type LiveAgentSecurityCenterQueryBanListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_security_center/QueryBanList',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentSecurityCenterQueryBanListRequestConfig = {
  mockUrl: mockUrl_0_0_0_8,
  path: '/bigolive/live_agent_security_center/QueryBanList',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_8,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentSecurityCenterQueryBanList',
};

export const liveAgentSecurityCenterQueryBanList = makeRequest<
  LiveAgentSecurityCenterQueryBanListRequest,
  LiveAgentSecurityCenterQueryBanListResponse
>(liveAgentSecurityCenterQueryBanListRequestConfig);
export const useLiveAgentSecurityCenterQueryBanList = makeRequestHook<
  LiveAgentSecurityCenterQueryBanListRequest,
  LiveAgentSecurityCenterQueryBanListRequestConfig,
  ReturnType<typeof liveAgentSecurityCenterQueryBanList>
>(liveAgentSecurityCenterQueryBanList);

export interface LiveAgentSecurityCenterQueryBanUserInfoRequest {
  /**
   * 1
   */
  anchor_uid: number;
  /**
   * 2
   */
  seqid: number;
}

export interface LiveAgentSecurityCenterQueryBanUserInfoResponse {
  bigo_id: string;
  country: string;
  language: string;
  nick_name: string;
  level: number;
  fans_count: number;
  punish_count: number;
}
type LiveAgentSecurityCenterQueryBanUserInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_security_center/QueryBanUserInfo',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentSecurityCenterQueryBanUserInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_8,
  path: '/bigolive/live_agent_security_center/QueryBanUserInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_8,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentSecurityCenterQueryBanUserInfo',
};

export const liveAgentSecurityCenterQueryBanUserInfo = makeRequest<
  LiveAgentSecurityCenterQueryBanUserInfoRequest,
  LiveAgentSecurityCenterQueryBanUserInfoResponse
>(liveAgentSecurityCenterQueryBanUserInfoRequestConfig);
export const useLiveAgentSecurityCenterQueryBanUserInfo = makeRequestHook<
  LiveAgentSecurityCenterQueryBanUserInfoRequest,
  LiveAgentSecurityCenterQueryBanUserInfoRequestConfig,
  ReturnType<typeof liveAgentSecurityCenterQueryBanUserInfo>
>(liveAgentSecurityCenterQueryBanUserInfo);

export interface LiveAgentSecurityCenterCreateAppealRequest {
  /**
   * 123
   */
  anchor_uid: number;
  /**
   * 3
   */
  deny_type: number;
  /**
   * "reason"
   */
  reason: string;
  /**
   * ["1.jpg","2.jpg"]
   */
  pic_urls: string[];
}

export type LiveAgentSecurityCenterCreateAppealResponse = string;
type LiveAgentSecurityCenterCreateAppealRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_security_center/CreateAppeal',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentSecurityCenterCreateAppealRequestConfig = {
  mockUrl: mockUrl_0_0_0_8,
  path: '/bigolive/live_agent_security_center/CreateAppeal',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_8,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentSecurityCenterCreateAppeal',
};

export const liveAgentSecurityCenterCreateAppeal = makeRequest<
  LiveAgentSecurityCenterCreateAppealRequest,
  LiveAgentSecurityCenterCreateAppealResponse
>(liveAgentSecurityCenterCreateAppealRequestConfig);
export const useLiveAgentSecurityCenterCreateAppeal = makeRequestHook<
  LiveAgentSecurityCenterCreateAppealRequest,
  LiveAgentSecurityCenterCreateAppealRequestConfig,
  ReturnType<typeof liveAgentSecurityCenterCreateAppeal>
>(liveAgentSecurityCenterCreateAppeal);

export interface LiveAgentSecurityCenterQueryAppealRequest {
  /**
   * 123
   */
  anchor_uid: number;
  /**
   * 1
   */
  deny_type: number;
}

export interface LiveAgentSecurityCenterQueryAppealResponse {
  status: number;
  appeal_time: number;
  reject_reason: string;
}
type LiveAgentSecurityCenterQueryAppealRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_security_center/QueryAppeal',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentSecurityCenterQueryAppealRequestConfig = {
  mockUrl: mockUrl_0_0_0_8,
  path: '/bigolive/live_agent_security_center/QueryAppeal',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_8,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentSecurityCenterQueryAppeal',
};

export const liveAgentSecurityCenterQueryAppeal = makeRequest<
  LiveAgentSecurityCenterQueryAppealRequest,
  LiveAgentSecurityCenterQueryAppealResponse
>(liveAgentSecurityCenterQueryAppealRequestConfig);
export const useLiveAgentSecurityCenterQueryAppeal = makeRequestHook<
  LiveAgentSecurityCenterQueryAppealRequest,
  LiveAgentSecurityCenterQueryAppealRequestConfig,
  ReturnType<typeof liveAgentSecurityCenterQueryAppeal>
>(liveAgentSecurityCenterQueryAppeal);

export interface LiveAgentSecurityCenterGetAuditRecordListRequest {
  /**
   * "123"
   */
  bigo_id: string;
  /**
   * "punish_dimension"
   */
  punish_dimension: string;
  /**
   * 1239
   */
  start_s: number;
  /**
   * 1231231
   */
  end_s: number;
  /**
   * 1
   */
  ban_type: number;
  hangup_record: boolean;
  /**
   * 20
   */
  count: number;
  /**
   * true
   */
  is_export: boolean;
  /**
   * 480
   */
  time_zone_minute: number;
  reflection: string;
}

export interface LiveAgentSecurityCenterGetAuditRecordListResponse {
  records: {
    punish_dimension: string;
    punish_dimension_lang: string;
    punish_type_lang: string;
    punish_type_detail_lang: string;
    start_s: number;
    end_s: number;
    label_id_lang: string;
    data: {
      text:
        | []
        | [
            {
              id: string;
              content: string;
            },
          ];
      pic:
        | []
        | [
            {
              id: string;
              content: string;
            },
          ];
    };
  }[];
  reflection: string;
  export_info: {
    url: string;
    bucket: string;
    token: string;
  };
}
type LiveAgentSecurityCenterGetAuditRecordListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_security_center/GetAuditRecordList',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentSecurityCenterGetAuditRecordListRequestConfig = {
  mockUrl: mockUrl_0_0_0_8,
  path: '/bigolive/live_agent_security_center/GetAuditRecordList',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_8,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentSecurityCenterGetAuditRecordList',
};

export const liveAgentSecurityCenterGetAuditRecordList = makeRequest<
  LiveAgentSecurityCenterGetAuditRecordListRequest,
  LiveAgentSecurityCenterGetAuditRecordListResponse
>(liveAgentSecurityCenterGetAuditRecordListRequestConfig);
export const useLiveAgentSecurityCenterGetAuditRecordList = makeRequestHook<
  LiveAgentSecurityCenterGetAuditRecordListRequest,
  LiveAgentSecurityCenterGetAuditRecordListRequestConfig,
  ReturnType<typeof liveAgentSecurityCenterGetAuditRecordList>
>(liveAgentSecurityCenterGetAuditRecordList);

export interface LiveAgentSecurityCenterGetSecurityTokenRequest {
  /**
   * "url"
   */
  url: string;
}

export interface LiveAgentSecurityCenterGetSecurityTokenResponse {
  url: string;
  bucket: string;
  token: string;
  expire_s: number;
}
type LiveAgentSecurityCenterGetSecurityTokenRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_security_center/GetSecurityToken',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentSecurityCenterGetSecurityTokenRequestConfig = {
  mockUrl: mockUrl_0_0_0_8,
  path: '/bigolive/live_agent_security_center/GetSecurityToken',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_8,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentSecurityCenterGetSecurityToken',
};

export const liveAgentSecurityCenterGetSecurityToken = makeRequest<
  LiveAgentSecurityCenterGetSecurityTokenRequest,
  LiveAgentSecurityCenterGetSecurityTokenResponse
>(liveAgentSecurityCenterGetSecurityTokenRequestConfig);
export const useLiveAgentSecurityCenterGetSecurityToken = makeRequestHook<
  LiveAgentSecurityCenterGetSecurityTokenRequest,
  LiveAgentSecurityCenterGetSecurityTokenRequestConfig,
  ReturnType<typeof liveAgentSecurityCenterGetSecurityToken>
>(liveAgentSecurityCenterGetSecurityToken);

export interface BrpcTiebaNotificationFrontGetNotificationInfoRequest {
  seq_id: string;
  /**
   * 123
   */
  uuid: number;
}

export interface BrpcTiebaNotificationFrontGetNotificationInfoResponse {
  ts: number;
  punishment_method: string;
  reason4violation: string;
  content: string;
  picture: string[];
}
type BrpcTiebaNotificationFrontGetNotificationInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/brpc_tieba_notification_front/GetNotificationInfo',
    'data',
    string,
    string,
    false
  >
>;

const brpcTiebaNotificationFrontGetNotificationInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_8,
  path: '/bigolive/brpc_tieba_notification_front/GetNotificationInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_8,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brpcTiebaNotificationFrontGetNotificationInfo',
};

export const brpcTiebaNotificationFrontGetNotificationInfo = makeRequest<
  BrpcTiebaNotificationFrontGetNotificationInfoRequest,
  BrpcTiebaNotificationFrontGetNotificationInfoResponse
>(brpcTiebaNotificationFrontGetNotificationInfoRequestConfig);
export const useBrpcTiebaNotificationFrontGetNotificationInfo = makeRequestHook<
  BrpcTiebaNotificationFrontGetNotificationInfoRequest,
  BrpcTiebaNotificationFrontGetNotificationInfoRequestConfig,
  ReturnType<typeof brpcTiebaNotificationFrontGetNotificationInfo>
>(brpcTiebaNotificationFrontGetNotificationInfo);

export interface LiveAgentSecurityCenterCreateAppealV2Request {
  /**
   * 123
   */
  anchor_uid: number;
  /**
   * 3
   */
  deny_type: number;
  /**
   * "reason"
   */
  reason: string;
  /**
   * ["1.jpg","2.jpg"]
   */
  pic_urls: string[];
}

export interface LiveAgentSecurityCenterCreateAppealV2Response {
  result: number;
  postId: string;
  msg: string;
}
type LiveAgentSecurityCenterCreateAppealV2RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_security_center/CreateAppealV2',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentSecurityCenterCreateAppealV2RequestConfig = {
  mockUrl: mockUrl_0_0_0_8,
  path: '/bigolive/live_agent_security_center/CreateAppealV2',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_8,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentSecurityCenterCreateAppealV2',
};

export const liveAgentSecurityCenterCreateAppealV2 = makeRequest<
  LiveAgentSecurityCenterCreateAppealV2Request,
  LiveAgentSecurityCenterCreateAppealV2Response
>(liveAgentSecurityCenterCreateAppealV2RequestConfig);
export const useLiveAgentSecurityCenterCreateAppealV2 = makeRequestHook<
  LiveAgentSecurityCenterCreateAppealV2Request,
  LiveAgentSecurityCenterCreateAppealV2RequestConfig,
  ReturnType<typeof liveAgentSecurityCenterCreateAppealV2>
>(liveAgentSecurityCenterCreateAppealV2);

export interface LiveAgentSecurityCenterQueryAppealV2Request {
  /**
   * 123
   */
  anchor_uid: number;
  /**
   * 1
   */
  deny_type: number;
}

export interface LiveAgentSecurityCenterQueryAppealV2Response {
  appealStatus: number;
  type: string;
  punishType: string;
  specialType: null;
  beginTime: number;
  duration: number;
  nickName: string;
  msg: null;
  appealOrderInfo: {
    postId: string;
    createTime: number;
    reviewTime: number;
    type: string;
    punishType: string;
    status: string;
    result: string;
    reason: null;
    details: string;
  };
}
type LiveAgentSecurityCenterQueryAppealV2RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_security_center/QueryAppealV2',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentSecurityCenterQueryAppealV2RequestConfig = {
  mockUrl: mockUrl_0_0_0_8,
  path: '/bigolive/live_agent_security_center/QueryAppealV2',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_8,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentSecurityCenterQueryAppealV2',
};

export const liveAgentSecurityCenterQueryAppealV2 = makeRequest<
  LiveAgentSecurityCenterQueryAppealV2Request,
  LiveAgentSecurityCenterQueryAppealV2Response
>(liveAgentSecurityCenterQueryAppealV2RequestConfig);
export const useLiveAgentSecurityCenterQueryAppealV2 = makeRequestHook<
  LiveAgentSecurityCenterQueryAppealV2Request,
  LiveAgentSecurityCenterQueryAppealV2RequestConfig,
  ReturnType<typeof liveAgentSecurityCenterQueryAppealV2>
>(liveAgentSecurityCenterQueryAppealV2);

const mockUrl_0_0_0_9 = 'http://yapi.ppx520.com/mock/8015' as any;
const dataKey_0_0_0_9 = 'data' as any;

export interface LiveAgentRecruitProxyQryProxyRecruitProgressRequest {
  seq_id?: number;
  proxy_uid?: number;
  /**
   * 平台 1app 2PC
   */
  plat_type?: number;
}

export interface LiveAgentRecruitProxyQryProxyRecruitProgressResponse {
  res_code: number;
  his_progress_infos: {
    update_time: number;
    stat: number;
    reject_info: string;
  }[];
  recruit_id: number;
  proxy_uid: number;
  seq_id: number;
  sign_type: number;
  apply_type: number;
}
type LiveAgentRecruitProxyQryProxyRecruitProgressRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_recruit_proxy/QryProxyRecruitProgress',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentRecruitProxyQryProxyRecruitProgressRequestConfig = {
  mockUrl: mockUrl_0_0_0_9,
  path: '/bigolive/live_agent_recruit_proxy/QryProxyRecruitProgress',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentRecruitProxyQryProxyRecruitProgress',
};

export const liveAgentRecruitProxyQryProxyRecruitProgress = makeRequest<
  LiveAgentRecruitProxyQryProxyRecruitProgressRequest,
  LiveAgentRecruitProxyQryProxyRecruitProgressResponse
>(liveAgentRecruitProxyQryProxyRecruitProgressRequestConfig);
export const useLiveAgentRecruitProxyQryProxyRecruitProgress = makeRequestHook<
  LiveAgentRecruitProxyQryProxyRecruitProgressRequest,
  LiveAgentRecruitProxyQryProxyRecruitProgressRequestConfig,
  ReturnType<typeof liveAgentRecruitProxyQryProxyRecruitProgress>
>(liveAgentRecruitProxyQryProxyRecruitProgress);

export interface LiveAgentRecruitProxyProxyApplyRequest {
  seq_id?: number;
  proxy_uid?: number;
  /**
   * 1app 2PC 内部标志区分app来的请求还是非app
   */
  plat_type: number;
}

export interface LiveAgentRecruitProxyProxyApplyResponse {
  seq_id: number;
  resCode: number;
  proxy_other_info_question: string;
  person_email_required_type: number;
  company_email_required_type: number;
  proxy_required_info: {
    phone_area_code: string;
    proxy_email: string;
    proxy_name: string;
    union_name: string;
    proxy_phone: string;
    union_type: number;
  };
  proxy_other_info_answer: string;
  area_id: string;
  is_vn: boolean;
  agent_type: number[];
}
type LiveAgentRecruitProxyProxyApplyRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_recruit_proxy/ProxyApply',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentRecruitProxyProxyApplyRequestConfig = {
  mockUrl: mockUrl_0_0_0_9,
  path: '/bigolive/live_agent_recruit_proxy/ProxyApply',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentRecruitProxyProxyApply',
};

export const liveAgentRecruitProxyProxyApply = makeRequest<
  LiveAgentRecruitProxyProxyApplyRequest,
  LiveAgentRecruitProxyProxyApplyResponse
>(liveAgentRecruitProxyProxyApplyRequestConfig);
export const useLiveAgentRecruitProxyProxyApply = makeRequestHook<
  LiveAgentRecruitProxyProxyApplyRequest,
  LiveAgentRecruitProxyProxyApplyRequestConfig,
  ReturnType<typeof liveAgentRecruitProxyProxyApply>
>(liveAgentRecruitProxyProxyApply);

export interface LiveAgentRecruitProxyProxyCommitInfoRequest {
  proxy_uid: number;
  /**
   * 1app 2PC 内部标志区分app来的请求还是非app
   */
  plat_type: number;
  commit_valid_code: string;
  /**
   * 必填信息
   */
  proxy_required_info: {
    proxy_name?: string;
    proxy_phone?: string;
    union_type?: number;
    union_name?: string;
    /**
     * 特殊
     */
    proxy_email?: string;
    phone_area_code?: string;
  };
  /**
   * 选填信息
   */
  proxy_other_info_answer: string;
  /**
   * 拉取表单返回的区域（校验用）
   */
  area_id: string;
}

export interface LiveAgentRecruitProxyProxyCommitInfoResponse {
  seq_id?: number;
  /**
   * 200成功 401验证码错误
   */
  res_code?: number;
}
type LiveAgentRecruitProxyProxyCommitInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_recruit_proxy/ProxyCommitInfo',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentRecruitProxyProxyCommitInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_9,
  path: '/bigolive/live_agent_recruit_proxy/ProxyCommitInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentRecruitProxyProxyCommitInfo',
};

export const liveAgentRecruitProxyProxyCommitInfo = makeRequest<
  LiveAgentRecruitProxyProxyCommitInfoRequest,
  LiveAgentRecruitProxyProxyCommitInfoResponse
>(liveAgentRecruitProxyProxyCommitInfoRequestConfig);
export const useLiveAgentRecruitProxyProxyCommitInfo = makeRequestHook<
  LiveAgentRecruitProxyProxyCommitInfoRequest,
  LiveAgentRecruitProxyProxyCommitInfoRequestConfig,
  ReturnType<typeof liveAgentRecruitProxyProxyCommitInfo>
>(liveAgentRecruitProxyProxyCommitInfo);

const mockUrl_0_0_0_10 = 'http://yapi.ppx520.com/mock/8015' as any;
const dataKey_0_0_0_10 = 'data' as any;

export interface LiveAgentRecruitAnchorQryRecruitRecordRequest {
  /**
   * "32132"
   */
  bigo_id: string;
  /**
   * 1600003233
   */
  recruit_uid: number;
  /**
   * 2
   */
  recruit_status: number;
  /**
   * 1
   */
  need_total_size: number;
  /**
   * 1
   */
  contact_type: number;
  /**
   * 5
   */
  qry_size: number;
  /**
   * "13213213534"
   */
  qry_context: string;
}

export interface LiveAgentRecruitAnchorQryRecruitRecordResponse {
  total_size: number;
  to_submit_size: number;
  records: {
    recruit_id: string;
    anchor_uid: number;
    bigo_id: string;
    nickname: string;
    head_url: string;
    recv_bean: string;
    live_duration: string;
    recruit_uid: number;
    recruit_nickname: string;
    progress: number;
    begin_time: number;
    expire_sec: number;
    contact_type: number;
    followed: number;
    ext: {};
  }[];
  qry_context: string;
}
type LiveAgentRecruitAnchorQryRecruitRecordRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_recruit_anchor/QryRecruitRecord',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentRecruitAnchorQryRecruitRecordRequestConfig = {
  mockUrl: mockUrl_0_0_0_10,
  path: '/bigolive/live_agent_recruit_anchor/QryRecruitRecord',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_10,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentRecruitAnchorQryRecruitRecord',
};

export const liveAgentRecruitAnchorQryRecruitRecord = makeRequest<
  LiveAgentRecruitAnchorQryRecruitRecordRequest,
  LiveAgentRecruitAnchorQryRecruitRecordResponse
>(liveAgentRecruitAnchorQryRecruitRecordRequestConfig);
export const useLiveAgentRecruitAnchorQryRecruitRecord = makeRequestHook<
  LiveAgentRecruitAnchorQryRecruitRecordRequest,
  LiveAgentRecruitAnchorQryRecruitRecordRequestConfig,
  ReturnType<typeof liveAgentRecruitAnchorQryRecruitRecord>
>(liveAgentRecruitAnchorQryRecruitRecord);

export interface LiveAgentRecruitAnchorQryAnchorRecruitProgressRequest {}

export interface LiveAgentRecruitAnchorQryAnchorRecruitProgressResponse {
  sign_type: number;
  recruit_src: number;
  proxy_uid: number;
  proxy_nickname: string;
  proxy_bigo_id: string;
  broker_uid: number;
  broker_nickname: string;
  broker_bigo_id: string;
  broker_head_url: string;
  union_name: string;
  union_type: number;
  agent_region: string;
  contract_begin_time: number;
  contract_end_time: number;
  need_anchor_confirm: number;
  prog_list: [];
  can_anchor_set: number;
}
type LiveAgentRecruitAnchorQryAnchorRecruitProgressRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_recruit_anchor/QryAnchorRecruitProgress',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentRecruitAnchorQryAnchorRecruitProgressRequestConfig = {
  mockUrl: mockUrl_0_0_0_10,
  path: '/bigolive/live_agent_recruit_anchor/QryAnchorRecruitProgress',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_10,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentRecruitAnchorQryAnchorRecruitProgress',
};

export const liveAgentRecruitAnchorQryAnchorRecruitProgress = makeRequest<
  LiveAgentRecruitAnchorQryAnchorRecruitProgressRequest,
  LiveAgentRecruitAnchorQryAnchorRecruitProgressResponse
>(liveAgentRecruitAnchorQryAnchorRecruitProgressRequestConfig);
export const useLiveAgentRecruitAnchorQryAnchorRecruitProgress = makeRequestHook<
  LiveAgentRecruitAnchorQryAnchorRecruitProgressRequest,
  LiveAgentRecruitAnchorQryAnchorRecruitProgressRequestConfig,
  ReturnType<typeof liveAgentRecruitAnchorQryAnchorRecruitProgress>
>(liveAgentRecruitAnchorQryAnchorRecruitProgress);

export interface LiveAgentRecruitAnchorQrySubmitAnchorInfoRequest {
  /**
   * 1213
   */
  seq_id: number;
  /**
   * "en"
   */
  lang: string;
  /**
   * ["4234234342342333333","13243243453"]
   */
  recruit_ids: string[];
  /**
   * 1
   */
  role: number;
}

export interface LiveAgentRecruitAnchorQrySubmitAnchorInfoResponse {
  progress: number;
  contract_begin_time: number;
  contract_end_time: number;
  contract_month: number;
  custom_question: {
    id: number;
    version: number;
    questions: {
      id: string;
      type: number;
      title: string;
      img_url: string;
      is_required: boolean;
      options:
        | []
        | [
            {
              id: string;
              title: string;
            },
          ];
      extra_info: {
        is_have_other: boolean;
      };
    }[];
  };
  need_video: number;
  video_desc: string;
  is_middle_east: number;
  policy_id: string;
  policy_list: {
    id: string;
    name: string;
    introduce: string;
    ext: {};
  }[];
  ethnicity_title: string;
  ethnicity_list: {
    id: string;
    name: string;
    ext: {};
  }[];
  anchor_infos: {
    recruit_id: string;
    anchor_uid: number;
    bigo_id: string;
    nickname: string;
    head_url: string;
    real_name: string;
    skill: string;
    interview_video: string;
    custom_answer: {
      id: number;
      version: number;
      name: string;
      phone: string;
      contract_start_time: string;
      contract_end_time: string;
      proxy_type: string;
      union_name: string;
      questions:
        | []
        | [
            {
              id: string;
              type: number;
              answer: string;
              other: string;
            },
          ];
    };
    ethnicity_id: string;
    other_ethnicity: string;
    ext: {};
  }[];
}
type LiveAgentRecruitAnchorQrySubmitAnchorInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_recruit_anchor/QrySubmitAnchorInfo',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentRecruitAnchorQrySubmitAnchorInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_10,
  path: '/bigolive/live_agent_recruit_anchor/QrySubmitAnchorInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_10,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentRecruitAnchorQrySubmitAnchorInfo',
};

export const liveAgentRecruitAnchorQrySubmitAnchorInfo = makeRequest<
  LiveAgentRecruitAnchorQrySubmitAnchorInfoRequest,
  LiveAgentRecruitAnchorQrySubmitAnchorInfoResponse
>(liveAgentRecruitAnchorQrySubmitAnchorInfoRequestConfig);
export const useLiveAgentRecruitAnchorQrySubmitAnchorInfo = makeRequestHook<
  LiveAgentRecruitAnchorQrySubmitAnchorInfoRequest,
  LiveAgentRecruitAnchorQrySubmitAnchorInfoRequestConfig,
  ReturnType<typeof liveAgentRecruitAnchorQrySubmitAnchorInfo>
>(liveAgentRecruitAnchorQrySubmitAnchorInfo);

export interface LiveAgentRecruitAnchorSaveSubmitAnchorInfoRequest {
  /**
   * 1343
   */
  contract_begin_time: number;
  /**
   * 143
   */
  contract_end_time: number;
  /**
   * 2
   */
  contract_month: number;
  /**
   * 1
   */
  operate_type: number;
  /**
   * "11111111111123232423"
   */
  policy_id: string;
  /**
   * [{"recruit_id":"7257009521959129000","anchor_uid":1600007601,"real_name":"Jim Green","interview_video":"http://headUrlxxxrfdsf.mp4","custom_answer":"json","ethnicity_id":"1","other_ethnicity":"","ext":{}},{"recruit_id":"7257009521959129000","anchor_uid":1600004622,"real_name":"Tom Green","interview_video":"http://headUrlxxxrfdsf.mp4","custom_answer":"json","ethnicity_id":"0","other_ethnicity":"xxx","ext":{}}]
   */
  anchor_infos: {
    /**
     * "7257009521959129000"
     */
    recruit_id: string;
    /**
     * 1600007601
     */
    anchor_uid: number;
    /**
     * "Jim Green"
     */
    real_name: string;
    /**
     * "http://headUrlxxxrfdsf.mp4"
     */
    interview_video: string;
    /**
     * "json"
     */
    custom_answer: string;
    /**
     * "1"
     */
    ethnicity_id: string;
    other_ethnicity: string;
    ext: {};
  }[];
  /**
   * 1
   */
  role: number;
}

export type LiveAgentRecruitAnchorSaveSubmitAnchorInfoResponse =
  | []
  | [
      {
        recruit_id: string;
        reason: number;
        desc: string;
        ext: {};
      },
    ];
type LiveAgentRecruitAnchorSaveSubmitAnchorInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_recruit_anchor/SaveSubmitAnchorInfo',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentRecruitAnchorSaveSubmitAnchorInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_10,
  path: '/bigolive/live_agent_recruit_anchor/SaveSubmitAnchorInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_10,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentRecruitAnchorSaveSubmitAnchorInfo',
};

export const liveAgentRecruitAnchorSaveSubmitAnchorInfo = makeRequest<
  LiveAgentRecruitAnchorSaveSubmitAnchorInfoRequest,
  LiveAgentRecruitAnchorSaveSubmitAnchorInfoResponse
>(liveAgentRecruitAnchorSaveSubmitAnchorInfoRequestConfig);
export const useLiveAgentRecruitAnchorSaveSubmitAnchorInfo = makeRequestHook<
  LiveAgentRecruitAnchorSaveSubmitAnchorInfoRequest,
  LiveAgentRecruitAnchorSaveSubmitAnchorInfoRequestConfig,
  ReturnType<typeof liveAgentRecruitAnchorSaveSubmitAnchorInfo>
>(liveAgentRecruitAnchorSaveSubmitAnchorInfo);

export interface LiveAgentRecruitAnchorStopAnchorRecruitRequest {
  /**
   * ["4234234342342333333","13243243453"]
   */
  recruit_ids: string[];
}

export type LiveAgentRecruitAnchorStopAnchorRecruitResponse =
  | []
  | [
      {
        recruit_id: string;
        reason: number;
        desc: string;
        ext: {};
      },
    ];
type LiveAgentRecruitAnchorStopAnchorRecruitRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_recruit_anchor/StopAnchorRecruit',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentRecruitAnchorStopAnchorRecruitRequestConfig = {
  mockUrl: mockUrl_0_0_0_10,
  path: '/bigolive/live_agent_recruit_anchor/StopAnchorRecruit',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_10,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentRecruitAnchorStopAnchorRecruit',
};

export const liveAgentRecruitAnchorStopAnchorRecruit = makeRequest<
  LiveAgentRecruitAnchorStopAnchorRecruitRequest,
  LiveAgentRecruitAnchorStopAnchorRecruitResponse
>(liveAgentRecruitAnchorStopAnchorRecruitRequestConfig);
export const useLiveAgentRecruitAnchorStopAnchorRecruit = makeRequestHook<
  LiveAgentRecruitAnchorStopAnchorRecruitRequest,
  LiveAgentRecruitAnchorStopAnchorRecruitRequestConfig,
  ReturnType<typeof liveAgentRecruitAnchorStopAnchorRecruit>
>(liveAgentRecruitAnchorStopAnchorRecruit);

export interface LiveAgentRecruitAnchorXxxxxxxxxxxxxxxRequest {}

export interface LiveAgentRecruitAnchorXxxxxxxxxxxxxxxResponse {}
type LiveAgentRecruitAnchorXxxxxxxxxxxxxxxRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_recruit_anchor/xxxxxxxxxxxxxxx',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentRecruitAnchorXxxxxxxxxxxxxxxRequestConfig = {
  mockUrl: mockUrl_0_0_0_10,
  path: '/bigolive/live_agent_recruit_anchor/xxxxxxxxxxxxxxx',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_10,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentRecruitAnchorXxxxxxxxxxxxxxx',
};

export const liveAgentRecruitAnchorXxxxxxxxxxxxxxx = makeRequest<
  LiveAgentRecruitAnchorXxxxxxxxxxxxxxxRequest,
  LiveAgentRecruitAnchorXxxxxxxxxxxxxxxResponse
>(liveAgentRecruitAnchorXxxxxxxxxxxxxxxRequestConfig);
export const useLiveAgentRecruitAnchorXxxxxxxxxxxxxxx = makeRequestHook<
  LiveAgentRecruitAnchorXxxxxxxxxxxxxxxRequest,
  LiveAgentRecruitAnchorXxxxxxxxxxxxxxxRequestConfig,
  ReturnType<typeof liveAgentRecruitAnchorXxxxxxxxxxxxxxx>
>(liveAgentRecruitAnchorXxxxxxxxxxxxxxx);

export interface LiveAgentRecruitAnchorExportRecruitRecordRequest {}

export interface LiveAgentRecruitAnchorExportRecruitRecordResponse {}
type LiveAgentRecruitAnchorExportRecruitRecordRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_recruit_anchor/ExportRecruitRecord',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentRecruitAnchorExportRecruitRecordRequestConfig = {
  mockUrl: mockUrl_0_0_0_10,
  path: '/bigolive/live_agent_recruit_anchor/ExportRecruitRecord',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_10,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentRecruitAnchorExportRecruitRecord',
};

export const liveAgentRecruitAnchorExportRecruitRecord = makeRequest<
  LiveAgentRecruitAnchorExportRecruitRecordRequest,
  LiveAgentRecruitAnchorExportRecruitRecordResponse
>(liveAgentRecruitAnchorExportRecruitRecordRequestConfig);
export const useLiveAgentRecruitAnchorExportRecruitRecord = makeRequestHook<
  LiveAgentRecruitAnchorExportRecruitRecordRequest,
  LiveAgentRecruitAnchorExportRecruitRecordRequestConfig,
  ReturnType<typeof liveAgentRecruitAnchorExportRecruitRecord>
>(liveAgentRecruitAnchorExportRecruitRecord);

export interface LiveAgentRecruitAnchorQryRecruitRecord_1689648777976Request {
  /**
   * 12345
   */
  seq_id: number;
  /**
   * 12345
   */
  operate_uid: number;
  /**
   * 32132
   */
  bigo_id: number;
  /**
   * "Mark"
   */
  recruit_agent: string;
  /**
   * 2
   */
  recruit_status: number;
  /**
   * 5
   */
  qry_size: number;
  /**
   * "13213213534"
   */
  qry_context: string;
}

export interface LiveAgentRecruitAnchorQryRecruitRecord_1689648777976Response {
  _yy_from: string;
  seq_id: number;
  res_code: number;
  records: {
    _yy_from: string;
    recruit_id: number;
    anchor_uid: number;
    recruit_status: number;
    recruit_progress: number;
    begin_time: number;
    ext: {};
  }[];
  qry_context: string;
}
type LiveAgentRecruitAnchorQryRecruitRecord_1689648777976RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_recruit_anchor/QryRecruitRecord_1689648777976',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentRecruitAnchorQryRecruitRecord_1689648777976RequestConfig = {
  mockUrl: mockUrl_0_0_0_10,
  path: '/bigolive/live_agent_recruit_anchor/QryRecruitRecord_1689648777976',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_10,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentRecruitAnchorQryRecruitRecord_1689648777976',
};

export const liveAgentRecruitAnchorQryRecruitRecord_1689648777976 = makeRequest<
  LiveAgentRecruitAnchorQryRecruitRecord_1689648777976Request,
  LiveAgentRecruitAnchorQryRecruitRecord_1689648777976Response
>(liveAgentRecruitAnchorQryRecruitRecord_1689648777976RequestConfig);
export const useLiveAgentRecruitAnchorQryRecruitRecord_1689648777976 = makeRequestHook<
  LiveAgentRecruitAnchorQryRecruitRecord_1689648777976Request,
  LiveAgentRecruitAnchorQryRecruitRecord_1689648777976RequestConfig,
  ReturnType<typeof liveAgentRecruitAnchorQryRecruitRecord_1689648777976>
>(liveAgentRecruitAnchorQryRecruitRecord_1689648777976);

export interface LiveAgentRecruitAnchorQryPolicyInfoRequest {}

export interface LiveAgentRecruitAnchorQryPolicyInfoResponse {}
type LiveAgentRecruitAnchorQryPolicyInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_recruit_anchor/QryPolicyInfo',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentRecruitAnchorQryPolicyInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_10,
  path: '/bigolive/live_agent_recruit_anchor/QryPolicyInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_10,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentRecruitAnchorQryPolicyInfo',
};

export const liveAgentRecruitAnchorQryPolicyInfo = makeRequest<
  LiveAgentRecruitAnchorQryPolicyInfoRequest,
  LiveAgentRecruitAnchorQryPolicyInfoResponse
>(liveAgentRecruitAnchorQryPolicyInfoRequestConfig);
export const useLiveAgentRecruitAnchorQryPolicyInfo = makeRequestHook<
  LiveAgentRecruitAnchorQryPolicyInfoRequest,
  LiveAgentRecruitAnchorQryPolicyInfoRequestConfig,
  ReturnType<typeof liveAgentRecruitAnchorQryPolicyInfo>
>(liveAgentRecruitAnchorQryPolicyInfo);

export interface LiveAgentRecruitAnchorYyyyyyyyyyyyyyyRequest {}

export interface LiveAgentRecruitAnchorYyyyyyyyyyyyyyyResponse {}
type LiveAgentRecruitAnchorYyyyyyyyyyyyyyyRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_recruit_anchor/yyyyyyyyyyyyyyy',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentRecruitAnchorYyyyyyyyyyyyyyyRequestConfig = {
  mockUrl: mockUrl_0_0_0_10,
  path: '/bigolive/live_agent_recruit_anchor/yyyyyyyyyyyyyyy',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_10,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentRecruitAnchorYyyyyyyyyyyyyyy',
};

export const liveAgentRecruitAnchorYyyyyyyyyyyyyyy = makeRequest<
  LiveAgentRecruitAnchorYyyyyyyyyyyyyyyRequest,
  LiveAgentRecruitAnchorYyyyyyyyyyyyyyyResponse
>(liveAgentRecruitAnchorYyyyyyyyyyyyyyyRequestConfig);
export const useLiveAgentRecruitAnchorYyyyyyyyyyyyyyy = makeRequestHook<
  LiveAgentRecruitAnchorYyyyyyyyyyyyyyyRequest,
  LiveAgentRecruitAnchorYyyyyyyyyyyyyyyRequestConfig,
  ReturnType<typeof liveAgentRecruitAnchorYyyyyyyyyyyyyyy>
>(liveAgentRecruitAnchorYyyyyyyyyyyyyyy);

export interface LiveAgentRecruitAnchorQryAnchorProgressForAgentRequest {
  /**
   * "4234234342342333333"
   */
  recruit_id: string;
}

export interface LiveAgentRecruitAnchorQryAnchorProgressForAgentResponse {
  sign_type: number;
  recruit_src: number;
  need_anchor_confirm: number;
  prog_list: {
    prog_desc: string;
    progress: number;
    update_time: number;
    ext: {};
  }[];
}
type LiveAgentRecruitAnchorQryAnchorProgressForAgentRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_recruit_anchor/QryAnchorProgressForAgent',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentRecruitAnchorQryAnchorProgressForAgentRequestConfig = {
  mockUrl: mockUrl_0_0_0_10,
  path: '/bigolive/live_agent_recruit_anchor/QryAnchorProgressForAgent',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_10,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentRecruitAnchorQryAnchorProgressForAgent',
};

export const liveAgentRecruitAnchorQryAnchorProgressForAgent = makeRequest<
  LiveAgentRecruitAnchorQryAnchorProgressForAgentRequest,
  LiveAgentRecruitAnchorQryAnchorProgressForAgentResponse
>(liveAgentRecruitAnchorQryAnchorProgressForAgentRequestConfig);
export const useLiveAgentRecruitAnchorQryAnchorProgressForAgent = makeRequestHook<
  LiveAgentRecruitAnchorQryAnchorProgressForAgentRequest,
  LiveAgentRecruitAnchorQryAnchorProgressForAgentRequestConfig,
  ReturnType<typeof liveAgentRecruitAnchorQryAnchorProgressForAgent>
>(liveAgentRecruitAnchorQryAnchorProgressForAgent);

export interface LiveAgentRecruitAnchorQryUrlWithTokenRequest {
  /**
   * "2343242343"
   */
  recruit_id: string;
  /**
   * "https://sg-test-download.bigo.sg/as/bigo-video/st1/M00/31/BC/a5rHAGVURcqEcTz3AAAAADjO2Gw703.mp4"
   */
  url: string;
}

export interface LiveAgentRecruitAnchorQryUrlWithTokenResponse {
  _yy_from: string;
  new_url: string;
}
type LiveAgentRecruitAnchorQryUrlWithTokenRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_recruit_anchor/QryUrlWithToken',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentRecruitAnchorQryUrlWithTokenRequestConfig = {
  mockUrl: mockUrl_0_0_0_10,
  path: '/bigolive/live_agent_recruit_anchor/QryUrlWithToken',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_10,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentRecruitAnchorQryUrlWithToken',
};

export const liveAgentRecruitAnchorQryUrlWithToken = makeRequest<
  LiveAgentRecruitAnchorQryUrlWithTokenRequest,
  LiveAgentRecruitAnchorQryUrlWithTokenResponse
>(liveAgentRecruitAnchorQryUrlWithTokenRequestConfig);
export const useLiveAgentRecruitAnchorQryUrlWithToken = makeRequestHook<
  LiveAgentRecruitAnchorQryUrlWithTokenRequest,
  LiveAgentRecruitAnchorQryUrlWithTokenRequestConfig,
  ReturnType<typeof liveAgentRecruitAnchorQryUrlWithToken>
>(liveAgentRecruitAnchorQryUrlWithToken);

export interface LiveAgentRecruitAnchorQryCurrentContractInfoRequest {}

export interface LiveAgentRecruitAnchorQryCurrentContractInfoResponse {}
type LiveAgentRecruitAnchorQryCurrentContractInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_recruit_anchor/QryCurrentContractInfo',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentRecruitAnchorQryCurrentContractInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_10,
  path: '/bigolive/live_agent_recruit_anchor/QryCurrentContractInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_10,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentRecruitAnchorQryCurrentContractInfo',
};

export const liveAgentRecruitAnchorQryCurrentContractInfo = makeRequest<
  LiveAgentRecruitAnchorQryCurrentContractInfoRequest,
  LiveAgentRecruitAnchorQryCurrentContractInfoResponse
>(liveAgentRecruitAnchorQryCurrentContractInfoRequestConfig);
export const useLiveAgentRecruitAnchorQryCurrentContractInfo = makeRequestHook<
  LiveAgentRecruitAnchorQryCurrentContractInfoRequest,
  LiveAgentRecruitAnchorQryCurrentContractInfoRequestConfig,
  ReturnType<typeof liveAgentRecruitAnchorQryCurrentContractInfo>
>(liveAgentRecruitAnchorQryCurrentContractInfo);

const mockUrl_0_0_0_11 = 'http://yapi.ppx520.com/mock/8015' as any;
const dataKey_0_0_0_11 = 'data' as any;

export interface BrpcAnchorBrokerFrontQryAnchorListRequest {
  /**
   * 1
   */
  qry_type: number;
  /**
   * "bigoid"
   */
  anchor_bigoid: string;
  /**
   * 123456
   */
  broker_uid: number;
  /**
   * 50
   */
  size: number;
  /**
   * "abcdefg"
   */
  qry_context: string;
  /**
   * 1
   */
  need_total_cnt: number;
  /**
   * 1
   */
  qry_sub_type: number;
  /**
   * 1
   */
  sort_key: number;
  /**
   * 1
   */
  order: number;
  /**
   * "{}"
   */
  qry_sub_type_ctx: string;
}

export interface BrpcAnchorBrokerFrontQryAnchorListResponse {
  total_cnt: number;
  anchor_list: {
    uid: string;
    bigoid: string;
    name: string;
    head: string;
    broker_uid: string;
    broker_bigoid: string;
    broker_name: string;
    this_month_live_stream_duration: number;
    sixty_days_live_stream_duration: number;
    last_live_stream_time: string;
    total_fans_cnt: number;
    contract_start_time: string;
    contract_end_time: string;
    sign_type: number;
    sign_status: number;
    is_contract_renewing: number;
    qry_context: string;
    policy_id: string;
    policy_code: string;
    transfer_status: number;
    cancel_contract_status: number;
    this_month_livedata_bean: string;
    sixty_days_livedata_bean: string;
    next_contract_start_time: string;
    next_contract_end_time: string;
    to_renew: boolean;
    identity: [] | [number];
    star_level: number;
    new_anchor_day: string;
    new_anchor_day_end: string;
    star_eval_status: number;
    star_eval_entry: number;
    open_group_stream_entry: boolean;
  }[];
}
type BrpcAnchorBrokerFrontQryAnchorListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/brpc_anchor_broker_front/QryAnchorList',
    'data',
    string,
    string,
    false
  >
>;

const brpcAnchorBrokerFrontQryAnchorListRequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/brpc_anchor_broker_front/QryAnchorList',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brpcAnchorBrokerFrontQryAnchorList',
};

export const brpcAnchorBrokerFrontQryAnchorList = makeRequest<
  BrpcAnchorBrokerFrontQryAnchorListRequest,
  BrpcAnchorBrokerFrontQryAnchorListResponse
>(brpcAnchorBrokerFrontQryAnchorListRequestConfig);
export const useBrpcAnchorBrokerFrontQryAnchorList = makeRequestHook<
  BrpcAnchorBrokerFrontQryAnchorListRequest,
  BrpcAnchorBrokerFrontQryAnchorListRequestConfig,
  ReturnType<typeof brpcAnchorBrokerFrontQryAnchorList>
>(brpcAnchorBrokerFrontQryAnchorList);

export interface BrpcAnchorBrokerFrontSetBrokerRequest {
  /**
   * ["100000001","100000002","100000003"]
   */
  uids: string[];
  /**
   * "1234556789"
   */
  broker_uid: string;
}

export interface BrpcAnchorBrokerFrontSetBrokerResponse {
  res_list: {
    uid: string;
    res_code: number;
  }[];
}
type BrpcAnchorBrokerFrontSetBrokerRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/brpc_anchor_broker_front/SetBroker',
    'data',
    string,
    string,
    false
  >
>;

const brpcAnchorBrokerFrontSetBrokerRequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/brpc_anchor_broker_front/SetBroker',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brpcAnchorBrokerFrontSetBroker',
};

export const brpcAnchorBrokerFrontSetBroker = makeRequest<
  BrpcAnchorBrokerFrontSetBrokerRequest,
  BrpcAnchorBrokerFrontSetBrokerResponse
>(brpcAnchorBrokerFrontSetBrokerRequestConfig);
export const useBrpcAnchorBrokerFrontSetBroker = makeRequestHook<
  BrpcAnchorBrokerFrontSetBrokerRequest,
  BrpcAnchorBrokerFrontSetBrokerRequestConfig,
  ReturnType<typeof brpcAnchorBrokerFrontSetBroker>
>(brpcAnchorBrokerFrontSetBroker);

export interface BrpcAnchorBrokerFrontQrySetBrokerRecordsRequest {
  /**
   * "bigoid"
   */
  bigoid: string;
  /**
   * 50
   */
  size: number;
  /**
   * "abcdef"
   */
  qry_context: string;
  /**
   * 1
   */
  need_total_cnt: number;
}

export interface BrpcAnchorBrokerFrontQrySetBrokerRecordsResponse {
  total_cnt: number;
  records: {
    uid: string;
    bigoid: string;
    name: string;
    head: string;
    old_broker_uid: string;
    old_broker_name: string;
    new_broker_uid: string;
    new_broker_name: string;
    operator_uid: string;
    operator_name: string;
    operate_time: string;
    qry_context: string;
  }[];
}
type BrpcAnchorBrokerFrontQrySetBrokerRecordsRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/brpc_anchor_broker_front/QrySetBrokerRecords',
    'data',
    string,
    string,
    false
  >
>;

const brpcAnchorBrokerFrontQrySetBrokerRecordsRequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/brpc_anchor_broker_front/QrySetBrokerRecords',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brpcAnchorBrokerFrontQrySetBrokerRecords',
};

export const brpcAnchorBrokerFrontQrySetBrokerRecords = makeRequest<
  BrpcAnchorBrokerFrontQrySetBrokerRecordsRequest,
  BrpcAnchorBrokerFrontQrySetBrokerRecordsResponse
>(brpcAnchorBrokerFrontQrySetBrokerRecordsRequestConfig);
export const useBrpcAnchorBrokerFrontQrySetBrokerRecords = makeRequestHook<
  BrpcAnchorBrokerFrontQrySetBrokerRecordsRequest,
  BrpcAnchorBrokerFrontQrySetBrokerRecordsRequestConfig,
  ReturnType<typeof brpcAnchorBrokerFrontQrySetBrokerRecords>
>(brpcAnchorBrokerFrontQrySetBrokerRecords);

export interface BrpcAnchorBrokerFrontRenewalContractRequest {
  /**
   * ["100000001","100000002","100000003"]
   */
  uids: string[];
  /**
   * 1
   */
  days: number;
}

export interface BrpcAnchorBrokerFrontRenewalContractResponse {
  res_list: {
    uid: string;
    res_code: number;
  }[];
}
type BrpcAnchorBrokerFrontRenewalContractRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/brpc_anchor_broker_front/RenewalContract',
    'data',
    string,
    string,
    false
  >
>;

const brpcAnchorBrokerFrontRenewalContractRequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/brpc_anchor_broker_front/RenewalContract',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brpcAnchorBrokerFrontRenewalContract',
};

export const brpcAnchorBrokerFrontRenewalContract = makeRequest<
  BrpcAnchorBrokerFrontRenewalContractRequest,
  BrpcAnchorBrokerFrontRenewalContractResponse
>(brpcAnchorBrokerFrontRenewalContractRequestConfig);
export const useBrpcAnchorBrokerFrontRenewalContract = makeRequestHook<
  BrpcAnchorBrokerFrontRenewalContractRequest,
  BrpcAnchorBrokerFrontRenewalContractRequestConfig,
  ReturnType<typeof brpcAnchorBrokerFrontRenewalContract>
>(brpcAnchorBrokerFrontRenewalContract);

export interface BrpcAnchorBrokerFrontCancelRenewalContractRequest {
  /**
   * "1234556789"
   */
  uid: string;
}

export interface BrpcAnchorBrokerFrontCancelRenewalContractResponse {
  seq_id: number;
  code: number;
  message: string;
}
type BrpcAnchorBrokerFrontCancelRenewalContractRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/brpc_anchor_broker_front/CancelRenewalContract',
    'data',
    string,
    string,
    false
  >
>;

const brpcAnchorBrokerFrontCancelRenewalContractRequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/brpc_anchor_broker_front/CancelRenewalContract',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brpcAnchorBrokerFrontCancelRenewalContract',
};

export const brpcAnchorBrokerFrontCancelRenewalContract = makeRequest<
  BrpcAnchorBrokerFrontCancelRenewalContractRequest,
  BrpcAnchorBrokerFrontCancelRenewalContractResponse
>(brpcAnchorBrokerFrontCancelRenewalContractRequestConfig);
export const useBrpcAnchorBrokerFrontCancelRenewalContract = makeRequestHook<
  BrpcAnchorBrokerFrontCancelRenewalContractRequest,
  BrpcAnchorBrokerFrontCancelRenewalContractRequestConfig,
  ReturnType<typeof brpcAnchorBrokerFrontCancelRenewalContract>
>(brpcAnchorBrokerFrontCancelRenewalContract);

export interface BrpcAnchorBrokerFrontQryRenewalContractRecordsRequest {
  /**
   * "bigoid"
   */
  bigoid: string;
  /**
   * 50
   */
  size: number;
  /**
   * "abcdef"
   */
  qry_context: string;
  /**
   * 1
   */
  need_total_cnt: number;
}

export interface BrpcAnchorBrokerFrontQryRenewalContractRecordsResponse {
  total_cnt: number;
  res_list: {
    uid: string;
    bigoid: string;
    name: string;
    head: string;
    old_contract_start_time: string;
    old_contract_end_time: string;
    new_contract_days: number;
    operator_name: string;
    operate_start_time: string;
    update_time: string;
    status: number;
    sign_type: number;
    reminded: number;
    qry_context: string;
  }[];
}
type BrpcAnchorBrokerFrontQryRenewalContractRecordsRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/brpc_anchor_broker_front/QryRenewalContractRecords',
    'data',
    string,
    string,
    false
  >
>;

const brpcAnchorBrokerFrontQryRenewalContractRecordsRequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/brpc_anchor_broker_front/QryRenewalContractRecords',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brpcAnchorBrokerFrontQryRenewalContractRecords',
};

export const brpcAnchorBrokerFrontQryRenewalContractRecords = makeRequest<
  BrpcAnchorBrokerFrontQryRenewalContractRecordsRequest,
  BrpcAnchorBrokerFrontQryRenewalContractRecordsResponse
>(brpcAnchorBrokerFrontQryRenewalContractRecordsRequestConfig);
export const useBrpcAnchorBrokerFrontQryRenewalContractRecords = makeRequestHook<
  BrpcAnchorBrokerFrontQryRenewalContractRecordsRequest,
  BrpcAnchorBrokerFrontQryRenewalContractRecordsRequestConfig,
  ReturnType<typeof brpcAnchorBrokerFrontQryRenewalContractRecords>
>(brpcAnchorBrokerFrontQryRenewalContractRecords);

export interface BrpcAnchorBrokerFrontRemindRenewalContractRequest {
  /**
   * "100000001"
   */
  uid: string;
}

export interface BrpcAnchorBrokerFrontRemindRenewalContractResponse {
  seq_id: number;
  code: number;
  message: string;
}
type BrpcAnchorBrokerFrontRemindRenewalContractRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/brpc_anchor_broker_front/RemindRenewalContract',
    'data',
    string,
    string,
    false
  >
>;

const brpcAnchorBrokerFrontRemindRenewalContractRequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/brpc_anchor_broker_front/RemindRenewalContract',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brpcAnchorBrokerFrontRemindRenewalContract',
};

export const brpcAnchorBrokerFrontRemindRenewalContract = makeRequest<
  BrpcAnchorBrokerFrontRemindRenewalContractRequest,
  BrpcAnchorBrokerFrontRemindRenewalContractResponse
>(brpcAnchorBrokerFrontRemindRenewalContractRequestConfig);
export const useBrpcAnchorBrokerFrontRemindRenewalContract = makeRequestHook<
  BrpcAnchorBrokerFrontRemindRenewalContractRequest,
  BrpcAnchorBrokerFrontRemindRenewalContractRequestConfig,
  ReturnType<typeof brpcAnchorBrokerFrontRemindRenewalContract>
>(brpcAnchorBrokerFrontRemindRenewalContract);

export interface BrpcAnchorBrokerFrontSetBrokerNoVerifyRequest {
  /**
   * 123456
   */
  seq_id: number;
  /**
   * [100000001,100000002,100000003]
   */
  uids: number[];
  /**
   * 1234556789
   */
  broker_uid: number;
  /**
   * "name"
   */
  operator_name: string;
}

export interface BrpcAnchorBrokerFrontSetBrokerNoVerifyResponse {
  res_list: {
    uid: number;
    res_code: number;
  }[];
}
type BrpcAnchorBrokerFrontSetBrokerNoVerifyRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/brpc_anchor_broker_front/SetBrokerNoVerify',
    'data',
    string,
    string,
    false
  >
>;

const brpcAnchorBrokerFrontSetBrokerNoVerifyRequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/brpc_anchor_broker_front/SetBrokerNoVerify',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brpcAnchorBrokerFrontSetBrokerNoVerify',
};

export const brpcAnchorBrokerFrontSetBrokerNoVerify = makeRequest<
  BrpcAnchorBrokerFrontSetBrokerNoVerifyRequest,
  BrpcAnchorBrokerFrontSetBrokerNoVerifyResponse
>(brpcAnchorBrokerFrontSetBrokerNoVerifyRequestConfig);
export const useBrpcAnchorBrokerFrontSetBrokerNoVerify = makeRequestHook<
  BrpcAnchorBrokerFrontSetBrokerNoVerifyRequest,
  BrpcAnchorBrokerFrontSetBrokerNoVerifyRequestConfig,
  ReturnType<typeof brpcAnchorBrokerFrontSetBrokerNoVerify>
>(brpcAnchorBrokerFrontSetBrokerNoVerify);

export interface LiveAgentServiceGetBrokerAggrDataRequest {}

export interface LiveAgentServiceGetBrokerAggrDataResponse {
  anchor_count: number;
  this_month_beans: number;
  last_month_beans: number;
}
type LiveAgentServiceGetBrokerAggrDataRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/GetBrokerAggrData',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentServiceGetBrokerAggrDataRequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/live_agent_service/GetBrokerAggrData',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceGetBrokerAggrData',
};

export const liveAgentServiceGetBrokerAggrData = makeRequest<
  LiveAgentServiceGetBrokerAggrDataRequest,
  LiveAgentServiceGetBrokerAggrDataResponse
>(liveAgentServiceGetBrokerAggrDataRequestConfig);
export const useLiveAgentServiceGetBrokerAggrData = makeRequestHook<
  LiveAgentServiceGetBrokerAggrDataRequest,
  LiveAgentServiceGetBrokerAggrDataRequestConfig,
  ReturnType<typeof liveAgentServiceGetBrokerAggrData>
>(liveAgentServiceGetBrokerAggrData);

export interface LiveAgentServiceGetAgentAggrDataRequest {
  /**
   * "52280181"
   */
  query_field: string;
  /**
   * 10
   */
  count: number;
  context: string;
}

export interface LiveAgentServiceGetAgentAggrDataResponse {
  context: string;
  is_end: boolean;
  broker_list: {
    uid: number;
    bigoid: string;
    nickname: string;
    avatar: string;
    anchor_count: number;
    this_month_beans: number;
    last_month_beans: number;
  }[];
}
type LiveAgentServiceGetAgentAggrDataRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/GetAgentAggrData',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServiceGetAgentAggrDataRequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/live_agent_service/GetAgentAggrData',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceGetAgentAggrData',
};

export const liveAgentServiceGetAgentAggrData = makeRequest<
  LiveAgentServiceGetAgentAggrDataRequest,
  LiveAgentServiceGetAgentAggrDataResponse
>(liveAgentServiceGetAgentAggrDataRequestConfig);
export const useLiveAgentServiceGetAgentAggrData = makeRequestHook<
  LiveAgentServiceGetAgentAggrDataRequest,
  LiveAgentServiceGetAgentAggrDataRequestConfig,
  ReturnType<typeof liveAgentServiceGetAgentAggrData>
>(liveAgentServiceGetAgentAggrData);

export interface LiveAgentServiceGetAggrDataEntryRequest {}

export interface LiveAgentServiceGetAggrDataEntryResponse {
  entry: boolean;
}
type LiveAgentServiceGetAggrDataEntryRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/GetAggrDataEntry',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentServiceGetAggrDataEntryRequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/live_agent_service/GetAggrDataEntry',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceGetAggrDataEntry',
};

export const liveAgentServiceGetAggrDataEntry = makeRequest<
  LiveAgentServiceGetAggrDataEntryRequest,
  LiveAgentServiceGetAggrDataEntryResponse
>(liveAgentServiceGetAggrDataEntryRequestConfig);
export const useLiveAgentServiceGetAggrDataEntry = makeRequestHook<
  LiveAgentServiceGetAggrDataEntryRequest,
  LiveAgentServiceGetAggrDataEntryRequestConfig,
  ReturnType<typeof liveAgentServiceGetAggrDataEntry>
>(liveAgentServiceGetAggrDataEntry);

export interface BrpcAnchorBrokerFrontQryAgentListTabRequest {}

export interface BrpcAnchorBrokerFrontQryAgentListTabResponse {
  tab_list: number[]
  hide_star_level: boolean
  hide_star_level_all: boolean
  regrade_cfg: {
    regrade_switch: number;
    start_grade: number;
    end_grade: number;
    live_days: number;
  };
  can_batch_op_group_member: boolean;
  hide_star_level_all: boolean;
}
type BrpcAnchorBrokerFrontQryAgentListTabRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/brpc_anchor_broker_front/QryAgentListTab',
    'data',
    string,
    string,
    true
  >
>;

const brpcAnchorBrokerFrontQryAgentListTabRequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/brpc_anchor_broker_front/QryAgentListTab',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brpcAnchorBrokerFrontQryAgentListTab',
};

export const brpcAnchorBrokerFrontQryAgentListTab = makeRequest<
  BrpcAnchorBrokerFrontQryAgentListTabRequest,
  BrpcAnchorBrokerFrontQryAgentListTabResponse
>(brpcAnchorBrokerFrontQryAgentListTabRequestConfig);
export const useBrpcAnchorBrokerFrontQryAgentListTab = makeRequestHook<
  BrpcAnchorBrokerFrontQryAgentListTabRequest,
  BrpcAnchorBrokerFrontQryAgentListTabRequestConfig,
  ReturnType<typeof brpcAnchorBrokerFrontQryAgentListTab>
>(brpcAnchorBrokerFrontQryAgentListTab);

export interface BrpcAnchorBrokerFrontSendNewAnchorReGradeRequest {
  /**
   * [123,456,789]
   */
  anchor_uid: number[];
}

export interface BrpcAnchorBrokerFrontSendNewAnchorReGradeResponse {
  fail_result: {
    uid: number;
    fail_code: number;
  }[];
}
type BrpcAnchorBrokerFrontSendNewAnchorReGradeRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/brpc_anchor_broker_front/SendNewAnchorReGrade',
    'data',
    string,
    string,
    false
  >
>;

const brpcAnchorBrokerFrontSendNewAnchorReGradeRequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/brpc_anchor_broker_front/SendNewAnchorReGrade',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brpcAnchorBrokerFrontSendNewAnchorReGrade',
};

export const brpcAnchorBrokerFrontSendNewAnchorReGrade = makeRequest<
  BrpcAnchorBrokerFrontSendNewAnchorReGradeRequest,
  BrpcAnchorBrokerFrontSendNewAnchorReGradeResponse
>(brpcAnchorBrokerFrontSendNewAnchorReGradeRequestConfig);
export const useBrpcAnchorBrokerFrontSendNewAnchorReGrade = makeRequestHook<
  BrpcAnchorBrokerFrontSendNewAnchorReGradeRequest,
  BrpcAnchorBrokerFrontSendNewAnchorReGradeRequestConfig,
  ReturnType<typeof brpcAnchorBrokerFrontSendNewAnchorReGrade>
>(brpcAnchorBrokerFrontSendNewAnchorReGrade);

export interface BrpcAnchorBrokerFrontRenewalContractV2Request {
  /**
   * [{"uid":100000001,"days":30},{"uid":100000002,"days":60}]
   */
  renewal_contract_infos: {
    /**
     * 100000001
     */
    uid: number;
    /**
     * 30
     */
    days: number;
  }[];
}

export interface BrpcAnchorBrokerFrontRenewalContractV2Response {}
type BrpcAnchorBrokerFrontRenewalContractV2RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/brpc_anchor_broker_front/RenewalContractV2',
    'data',
    string,
    string,
    false
  >
>;

const brpcAnchorBrokerFrontRenewalContractV2RequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/brpc_anchor_broker_front/RenewalContractV2',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brpcAnchorBrokerFrontRenewalContractV2',
};

export const brpcAnchorBrokerFrontRenewalContractV2 = makeRequest<
  BrpcAnchorBrokerFrontRenewalContractV2Request,
  BrpcAnchorBrokerFrontRenewalContractV2Response
>(brpcAnchorBrokerFrontRenewalContractV2RequestConfig);
export const useBrpcAnchorBrokerFrontRenewalContractV2 = makeRequestHook<
  BrpcAnchorBrokerFrontRenewalContractV2Request,
  BrpcAnchorBrokerFrontRenewalContractV2RequestConfig,
  ReturnType<typeof brpcAnchorBrokerFrontRenewalContractV2>
>(brpcAnchorBrokerFrontRenewalContractV2);

export interface BrpcAnchorBrokerFrontGetGroupStreamMemberListRequest {
  /**
   * 123
   */
  seqid: number;
  /**
   * 123
   */
  group_leader: number;
}

export interface BrpcAnchorBrokerFrontGetGroupStreamMemberListResponse {
  member_list: {
    uid: number;
    avatar: string;
    nick: string;
    bigoid: string;
    join_ts: number;
  }[];
}
type BrpcAnchorBrokerFrontGetGroupStreamMemberListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/brpc_anchor_broker_front/GetGroupStreamMemberList',
    'data',
    string,
    string,
    false
  >
>;

const brpcAnchorBrokerFrontGetGroupStreamMemberListRequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/brpc_anchor_broker_front/GetGroupStreamMemberList',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brpcAnchorBrokerFrontGetGroupStreamMemberList',
};

export const brpcAnchorBrokerFrontGetGroupStreamMemberList = makeRequest<
  BrpcAnchorBrokerFrontGetGroupStreamMemberListRequest,
  BrpcAnchorBrokerFrontGetGroupStreamMemberListResponse
>(brpcAnchorBrokerFrontGetGroupStreamMemberListRequestConfig);
export const useBrpcAnchorBrokerFrontGetGroupStreamMemberList = makeRequestHook<
  BrpcAnchorBrokerFrontGetGroupStreamMemberListRequest,
  BrpcAnchorBrokerFrontGetGroupStreamMemberListRequestConfig,
  ReturnType<typeof brpcAnchorBrokerFrontGetGroupStreamMemberList>
>(brpcAnchorBrokerFrontGetGroupStreamMemberList);

export interface BrpcAnchorBrokerFrontAddGroupStreamMemberRequest {
  /**
   * 123
   */
  seqid: number;
  /**
   * 123
   */
  group_leader: number;
  /**
   * ["abcd"]
   */
  bigoid_list: string[];
}

export interface BrpcAnchorBrokerFrontAddGroupStreamMemberResponse {
  result_list: {
    bigoid: string;
    rescode: number;
  }[];
}
type BrpcAnchorBrokerFrontAddGroupStreamMemberRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/brpc_anchor_broker_front/AddGroupStreamMember',
    'data',
    string,
    string,
    false
  >
>;

const brpcAnchorBrokerFrontAddGroupStreamMemberRequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/brpc_anchor_broker_front/AddGroupStreamMember',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brpcAnchorBrokerFrontAddGroupStreamMember',
};

export const brpcAnchorBrokerFrontAddGroupStreamMember = makeRequest<
  BrpcAnchorBrokerFrontAddGroupStreamMemberRequest,
  BrpcAnchorBrokerFrontAddGroupStreamMemberResponse
>(brpcAnchorBrokerFrontAddGroupStreamMemberRequestConfig);
export const useBrpcAnchorBrokerFrontAddGroupStreamMember = makeRequestHook<
  BrpcAnchorBrokerFrontAddGroupStreamMemberRequest,
  BrpcAnchorBrokerFrontAddGroupStreamMemberRequestConfig,
  ReturnType<typeof brpcAnchorBrokerFrontAddGroupStreamMember>
>(brpcAnchorBrokerFrontAddGroupStreamMember);

export interface BrpcAnchorBrokerFrontDelGroupStreamMemberRequest {
  /**
   * 123
   */
  seqid: number;
  /**
   * 123
   */
  group_leader: number;
  /**
   * ["abcd"]
   */
  bigoid_list: string[];
}

export interface BrpcAnchorBrokerFrontDelGroupStreamMemberResponse {
  result_list: {
    bigoid: string;
    rescode: number;
  }[];
}
type BrpcAnchorBrokerFrontDelGroupStreamMemberRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/brpc_anchor_broker_front/DelGroupStreamMember',
    'data',
    string,
    string,
    false
  >
>;

const brpcAnchorBrokerFrontDelGroupStreamMemberRequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/brpc_anchor_broker_front/DelGroupStreamMember',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brpcAnchorBrokerFrontDelGroupStreamMember',
};

export const brpcAnchorBrokerFrontDelGroupStreamMember = makeRequest<
  BrpcAnchorBrokerFrontDelGroupStreamMemberRequest,
  BrpcAnchorBrokerFrontDelGroupStreamMemberResponse
>(brpcAnchorBrokerFrontDelGroupStreamMemberRequestConfig);
export const useBrpcAnchorBrokerFrontDelGroupStreamMember = makeRequestHook<
  BrpcAnchorBrokerFrontDelGroupStreamMemberRequest,
  BrpcAnchorBrokerFrontDelGroupStreamMemberRequestConfig,
  ReturnType<typeof brpcAnchorBrokerFrontDelGroupStreamMember>
>(brpcAnchorBrokerFrontDelGroupStreamMember);

export interface BrpcAnchorBrokerFrontBatchAddGroupStreamMemberRequest {
  /**
   * 123
   */
  seqid: number;
  /**
   * [{"bigoid_leader":"abcd","bigoid_member":"efgc"}]
   */
  add_info_list: {
    /**
     * "abcd"
     */
    bigoid_leader: string;
    /**
     * "efgc"
     */
    bigoid_member: string;
  }[];
}

export interface BrpcAnchorBrokerFrontBatchAddGroupStreamMemberResponse {
  url: string;
  result_list: {
    rescode: number;
    bigoid_leader: string;
    bigoid_member: string;
  }[];
}
type BrpcAnchorBrokerFrontBatchAddGroupStreamMemberRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/brpc_anchor_broker_front/BatchAddGroupStreamMember',
    'data',
    string,
    string,
    false
  >
>;

const brpcAnchorBrokerFrontBatchAddGroupStreamMemberRequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/brpc_anchor_broker_front/BatchAddGroupStreamMember',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brpcAnchorBrokerFrontBatchAddGroupStreamMember',
};

export const brpcAnchorBrokerFrontBatchAddGroupStreamMember = makeRequest<
  BrpcAnchorBrokerFrontBatchAddGroupStreamMemberRequest,
  BrpcAnchorBrokerFrontBatchAddGroupStreamMemberResponse
>(brpcAnchorBrokerFrontBatchAddGroupStreamMemberRequestConfig);
export const useBrpcAnchorBrokerFrontBatchAddGroupStreamMember = makeRequestHook<
  BrpcAnchorBrokerFrontBatchAddGroupStreamMemberRequest,
  BrpcAnchorBrokerFrontBatchAddGroupStreamMemberRequestConfig,
  ReturnType<typeof brpcAnchorBrokerFrontBatchAddGroupStreamMember>
>(brpcAnchorBrokerFrontBatchAddGroupStreamMember);

export interface BrpcAnchorBrokerFrontBatchDelGroupStreamMemberRequest {
  /**
   * 123
   */
  seqid: number;
  /**
   * [{"bigoid_leader":"abcd","bigoid_member":"efgc"}]
   */
  del_info_list: {
    /**
     * "abcd"
     */
    bigoid_leader: string;
    /**
     * "efgc"
     */
    bigoid_member: string;
  }[];
}

export interface BrpcAnchorBrokerFrontBatchDelGroupStreamMemberResponse {
  url: string;
  result_list: {
    rescode: number;
    bigoid_leader: string;
    bigoid_member: string;
  }[];
}
type BrpcAnchorBrokerFrontBatchDelGroupStreamMemberRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/brpc_anchor_broker_front/BatchDelGroupStreamMember',
    'data',
    string,
    string,
    false
  >
>;

const brpcAnchorBrokerFrontBatchDelGroupStreamMemberRequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/brpc_anchor_broker_front/BatchDelGroupStreamMember',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brpcAnchorBrokerFrontBatchDelGroupStreamMember',
};

export const brpcAnchorBrokerFrontBatchDelGroupStreamMember = makeRequest<
  BrpcAnchorBrokerFrontBatchDelGroupStreamMemberRequest,
  BrpcAnchorBrokerFrontBatchDelGroupStreamMemberResponse
>(brpcAnchorBrokerFrontBatchDelGroupStreamMemberRequestConfig);
export const useBrpcAnchorBrokerFrontBatchDelGroupStreamMember = makeRequestHook<
  BrpcAnchorBrokerFrontBatchDelGroupStreamMemberRequest,
  BrpcAnchorBrokerFrontBatchDelGroupStreamMemberRequestConfig,
  ReturnType<typeof brpcAnchorBrokerFrontBatchDelGroupStreamMember>
>(brpcAnchorBrokerFrontBatchDelGroupStreamMember);

export interface BrpcAnchorBrokerFrontQryAgentInfoRequest {
  /**
   * 123
   */
  seqid: number;
}

export interface BrpcAnchorBrokerFrontQryAgentInfoResponse {
  from_bigoid: string;
  agent_name: string;
}
type BrpcAnchorBrokerFrontQryAgentInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/brpc_anchor_broker_front/QryAgentInfo',
    'data',
    string,
    string,
    false
  >
>;

const brpcAnchorBrokerFrontQryAgentInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_11,
  path: '/bigolive/brpc_anchor_broker_front/QryAgentInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brpcAnchorBrokerFrontQryAgentInfo',
};

export const brpcAnchorBrokerFrontQryAgentInfo = makeRequest<
  BrpcAnchorBrokerFrontQryAgentInfoRequest,
  BrpcAnchorBrokerFrontQryAgentInfoResponse
>(brpcAnchorBrokerFrontQryAgentInfoRequestConfig);
export const useBrpcAnchorBrokerFrontQryAgentInfo = makeRequestHook<
  BrpcAnchorBrokerFrontQryAgentInfoRequest,
  BrpcAnchorBrokerFrontQryAgentInfoRequestConfig,
  ReturnType<typeof brpcAnchorBrokerFrontQryAgentInfo>
>(brpcAnchorBrokerFrontQryAgentInfo);

const mockUrl_0_0_0_12 = 'http://yapi.ppx520.com/mock/8015' as any;
const dataKey_0_0_0_12 = 'data' as any;

export interface LiveAgentServiceGetAnchorListWithPkInfoRequest {
  /**
   * "bigoid"
   */
  anchor_bigoid: string;
  /**
   * 123456
   */
  broker_uid: number;
  /**
   * 10
   */
  count: number;
  context: string;
}

export interface LiveAgentServiceGetAnchorListWithPkInfoResponse {
  is_end: boolean;
  context: string;
  total_cnt: number;
  anchor_list: {
    uid: number;
    bigoid: string;
    name: string;
    head: string;
    total_fans_cnt: number;
    is_on_live: boolean;
    broker_uid: string;
    broker_name: string;
    this_month_bean_income: number;
    this_month_livedata_bean: number;
    sixty_days_bean_income: number;
    sixty_days_livedata_bean: number;
    this_month_live_stream_duration: number;
    sixty_days_live_stream_duration: number;
    this_month_pk_income: number;
    sixty_days_pk_income: number;
    this_month_pk_times: number;
    sixty_days_pk_times: number;
    pk_recom_uncompleted_cnt: number;
    pk_recom_completed_cnt: number;
    pk_recom_to_assign_cnt: number;
    can_pk_recom: boolean;
  }[];
}
type LiveAgentServiceGetAnchorListWithPkInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/GetAnchorListWithPkInfo',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServiceGetAnchorListWithPkInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_12,
  path: '/bigolive/live_agent_service/GetAnchorListWithPkInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_12,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceGetAnchorListWithPkInfo',
};

export const liveAgentServiceGetAnchorListWithPkInfo = makeRequest<
  LiveAgentServiceGetAnchorListWithPkInfoRequest,
  LiveAgentServiceGetAnchorListWithPkInfoResponse
>(liveAgentServiceGetAnchorListWithPkInfoRequestConfig);
export const useLiveAgentServiceGetAnchorListWithPkInfo = makeRequestHook<
  LiveAgentServiceGetAnchorListWithPkInfoRequest,
  LiveAgentServiceGetAnchorListWithPkInfoRequestConfig,
  ReturnType<typeof liveAgentServiceGetAnchorListWithPkInfo>
>(liveAgentServiceGetAnchorListWithPkInfo);

export interface LiveAgentServiceGetPkCandFollowingAnchorListRequest {
  /**
   * 123
   */
  anchor_uid: number;
  /**
   * 50
   */
  count: number;
  context: string;
}

export interface LiveAgentServiceGetPkCandFollowingAnchorListResponse {
  is_end: boolean;
  context: string;
  anchor_list: {
    uid: number;
    bigoid: string;
    name: string;
    head: string;
    pk_status: number;
  }[];
}
type LiveAgentServiceGetPkCandFollowingAnchorListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/GetPkCandFollowingAnchorList',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServiceGetPkCandFollowingAnchorListRequestConfig = {
  mockUrl: mockUrl_0_0_0_12,
  path: '/bigolive/live_agent_service/GetPkCandFollowingAnchorList',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_12,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceGetPkCandFollowingAnchorList',
};

export const liveAgentServiceGetPkCandFollowingAnchorList = makeRequest<
  LiveAgentServiceGetPkCandFollowingAnchorListRequest,
  LiveAgentServiceGetPkCandFollowingAnchorListResponse
>(liveAgentServiceGetPkCandFollowingAnchorListRequestConfig);
export const useLiveAgentServiceGetPkCandFollowingAnchorList = makeRequestHook<
  LiveAgentServiceGetPkCandFollowingAnchorListRequest,
  LiveAgentServiceGetPkCandFollowingAnchorListRequestConfig,
  ReturnType<typeof liveAgentServiceGetPkCandFollowingAnchorList>
>(liveAgentServiceGetPkCandFollowingAnchorList);

export interface LiveAgentServiceGetPkCandAgencyAnchorListRequest {
  /**
   * 12
   */
  anchor_uid: number;
  /**
   * 50
   */
  count: number;
  context: string;
}

export interface LiveAgentServiceGetPkCandAgencyAnchorListResponse {
  is_end: boolean;
  context: string;
  anchor_list: {
    uid: number;
    bigoid: string;
    head: string;
    name: string;
    pk_status: number;
  }[];
}
type LiveAgentServiceGetPkCandAgencyAnchorListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/GetPkCandAgencyAnchorList',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServiceGetPkCandAgencyAnchorListRequestConfig = {
  mockUrl: mockUrl_0_0_0_12,
  path: '/bigolive/live_agent_service/GetPkCandAgencyAnchorList',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_12,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceGetPkCandAgencyAnchorList',
};

export const liveAgentServiceGetPkCandAgencyAnchorList = makeRequest<
  LiveAgentServiceGetPkCandAgencyAnchorListRequest,
  LiveAgentServiceGetPkCandAgencyAnchorListResponse
>(liveAgentServiceGetPkCandAgencyAnchorListRequestConfig);
export const useLiveAgentServiceGetPkCandAgencyAnchorList = makeRequestHook<
  LiveAgentServiceGetPkCandAgencyAnchorListRequest,
  LiveAgentServiceGetPkCandAgencyAnchorListRequestConfig,
  ReturnType<typeof liveAgentServiceGetPkCandAgencyAnchorList>
>(liveAgentServiceGetPkCandAgencyAnchorList);

export interface LiveAgentServiceGetPkRecomEntireAnchorListRequest {
  /**
   * 12
   */
  anchor_uid: number;
  /**
   * 50
   */
  count: number;
  context: string;
}

export interface LiveAgentServiceGetPkRecomEntireAnchorListResponse {
  is_end: boolean;
  context: string;
  anchor_list: {
    uid: number;
    bigoid: string;
    name: string;
    head: string;
    pk_status: number;
    pk_info: {
      pk_result: number;
      my_charm_value: number;
      peer_charm_value: number;
    };
    can_be_pk_recom: boolean;
    recom_id: string;
  }[];
}
type LiveAgentServiceGetPkRecomEntireAnchorListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/GetPkRecomEntireAnchorList',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServiceGetPkRecomEntireAnchorListRequestConfig = {
  mockUrl: mockUrl_0_0_0_12,
  path: '/bigolive/live_agent_service/GetPkRecomEntireAnchorList',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_12,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceGetPkRecomEntireAnchorList',
};

export const liveAgentServiceGetPkRecomEntireAnchorList = makeRequest<
  LiveAgentServiceGetPkRecomEntireAnchorListRequest,
  LiveAgentServiceGetPkRecomEntireAnchorListResponse
>(liveAgentServiceGetPkRecomEntireAnchorListRequestConfig);
export const useLiveAgentServiceGetPkRecomEntireAnchorList = makeRequestHook<
  LiveAgentServiceGetPkRecomEntireAnchorListRequest,
  LiveAgentServiceGetPkRecomEntireAnchorListRequestConfig,
  ReturnType<typeof liveAgentServiceGetPkRecomEntireAnchorList>
>(liveAgentServiceGetPkRecomEntireAnchorList);

export interface LiveAgentServiceAddPkRecomAnchorRequest {
  /**
   * 12
   */
  anchor_uid: number;
  /**
   * [12,23]
   */
  pk_recom_uids: number[];
}

export interface LiveAgentServiceAddPkRecomAnchorResponse {
  pk_recom_to_assign_cnt: number;
  pk_recom_uncompleted_cnt: number;
  fail_uids: number[];
}
type LiveAgentServiceAddPkRecomAnchorRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/AddPkRecomAnchor',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServiceAddPkRecomAnchorRequestConfig = {
  mockUrl: mockUrl_0_0_0_12,
  path: '/bigolive/live_agent_service/AddPkRecomAnchor',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_12,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceAddPkRecomAnchor',
};

export const liveAgentServiceAddPkRecomAnchor = makeRequest<
  LiveAgentServiceAddPkRecomAnchorRequest,
  LiveAgentServiceAddPkRecomAnchorResponse
>(liveAgentServiceAddPkRecomAnchorRequestConfig);
export const useLiveAgentServiceAddPkRecomAnchor = makeRequestHook<
  LiveAgentServiceAddPkRecomAnchorRequest,
  LiveAgentServiceAddPkRecomAnchorRequestConfig,
  ReturnType<typeof liveAgentServiceAddPkRecomAnchor>
>(liveAgentServiceAddPkRecomAnchor);

export interface LiveAgentServiceDelPkRecomAnchorRequest {
  /**
   * 12
   */
  anchor_uid: number;
  /**
   * [12,23]
   */
  pk_recom_uids: number[];
}

export interface LiveAgentServiceDelPkRecomAnchorResponse {
  pk_recom_to_assign_cnt: number;
  pk_recom_uncompleted_cnt: number;
}
type LiveAgentServiceDelPkRecomAnchorRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/DelPkRecomAnchor',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServiceDelPkRecomAnchorRequestConfig = {
  mockUrl: mockUrl_0_0_0_12,
  path: '/bigolive/live_agent_service/DelPkRecomAnchor',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_12,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceDelPkRecomAnchor',
};

export const liveAgentServiceDelPkRecomAnchor = makeRequest<
  LiveAgentServiceDelPkRecomAnchorRequest,
  LiveAgentServiceDelPkRecomAnchorResponse
>(liveAgentServiceDelPkRecomAnchorRequestConfig);
export const useLiveAgentServiceDelPkRecomAnchor = makeRequestHook<
  LiveAgentServiceDelPkRecomAnchorRequest,
  LiveAgentServiceDelPkRecomAnchorRequestConfig,
  ReturnType<typeof liveAgentServiceDelPkRecomAnchor>
>(liveAgentServiceDelPkRecomAnchor);

const mockUrl_0_0_0_13 = 'http://yapi.ppx520.com/mock/8015' as any;
const dataKey_0_0_0_13 = 'data' as any;

export interface LiveAgentManageAnchorQryProxyInfoRequest {
  /**
   * 123
   */
  seq_id: number;
  /**
   * "xx"
   */
  bigo_id: string;
}

export interface LiveAgentManageAnchorQryProxyInfoResponse {
  bigo_id: string;
  agency_name: string;
  proxy_uid: number;
}
type LiveAgentManageAnchorQryProxyInfoRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_manage_anchor/QryProxyInfo',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentManageAnchorQryProxyInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_13,
  path: '/bigolive/live_agent_manage_anchor/QryProxyInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentManageAnchorQryProxyInfo',
};

export const liveAgentManageAnchorQryProxyInfo = makeRequest<
  LiveAgentManageAnchorQryProxyInfoRequest,
  LiveAgentManageAnchorQryProxyInfoResponse
>(liveAgentManageAnchorQryProxyInfoRequestConfig);
export const useLiveAgentManageAnchorQryProxyInfo = makeRequestHook<
  LiveAgentManageAnchorQryProxyInfoRequest,
  LiveAgentManageAnchorQryProxyInfoRequestConfig,
  ReturnType<typeof liveAgentManageAnchorQryProxyInfo>
>(liveAgentManageAnchorQryProxyInfo);

export interface LiveAgentManageAnchorStartCancelContractRequest {
  /**
   * [1,2]
   */
  uids: number[];
}

export interface LiveAgentManageAnchorStartCancelContractResponse {
  remain_num: number;
  fails: {
    uid: number;
    fail_code: number;
  }[];
}
type LiveAgentManageAnchorStartCancelContractRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_manage_anchor/StartCancelContract',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentManageAnchorStartCancelContractRequestConfig = {
  mockUrl: mockUrl_0_0_0_13,
  path: '/bigolive/live_agent_manage_anchor/StartCancelContract',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentManageAnchorStartCancelContract',
};

export const liveAgentManageAnchorStartCancelContract = makeRequest<
  LiveAgentManageAnchorStartCancelContractRequest,
  LiveAgentManageAnchorStartCancelContractResponse
>(liveAgentManageAnchorStartCancelContractRequestConfig);
export const useLiveAgentManageAnchorStartCancelContract = makeRequestHook<
  LiveAgentManageAnchorStartCancelContractRequest,
  LiveAgentManageAnchorStartCancelContractRequestConfig,
  ReturnType<typeof liveAgentManageAnchorStartCancelContract>
>(liveAgentManageAnchorStartCancelContract);

export interface LiveAgentManageAnchorStartApplyTransferRequest {
  /**
   * 1
   */
  to_proxy_uid: number;
  /**
   * [1,2]
   */
  uids: number[];
}

export interface LiveAgentManageAnchorStartApplyTransferResponse {
  remain_num: number;
  fails: {
    uid: number;
    fail_code: number;
  }[];
}
type LiveAgentManageAnchorStartApplyTransferRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_manage_anchor/StartApplyTransfer',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentManageAnchorStartApplyTransferRequestConfig = {
  mockUrl: mockUrl_0_0_0_13,
  path: '/bigolive/live_agent_manage_anchor/StartApplyTransfer',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentManageAnchorStartApplyTransfer',
};

export const liveAgentManageAnchorStartApplyTransfer = makeRequest<
  LiveAgentManageAnchorStartApplyTransferRequest,
  LiveAgentManageAnchorStartApplyTransferResponse
>(liveAgentManageAnchorStartApplyTransferRequestConfig);
export const useLiveAgentManageAnchorStartApplyTransfer = makeRequestHook<
  LiveAgentManageAnchorStartApplyTransferRequest,
  LiveAgentManageAnchorStartApplyTransferRequestConfig,
  ReturnType<typeof liveAgentManageAnchorStartApplyTransfer>
>(liveAgentManageAnchorStartApplyTransfer);

export interface LiveAgentManageAnchorAnchorVerifyCancelRequest {
  /**
   * 1
   */
  seq_id: number;
  /**
   * 1
   */
  event: number;
}

export type LiveAgentManageAnchorAnchorVerifyCancelResponse = string;
type LiveAgentManageAnchorAnchorVerifyCancelRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_manage_anchor/AnchorVerifyCancel',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentManageAnchorAnchorVerifyCancelRequestConfig = {
  mockUrl: mockUrl_0_0_0_13,
  path: '/bigolive/live_agent_manage_anchor/AnchorVerifyCancel',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentManageAnchorAnchorVerifyCancel',
};

export const liveAgentManageAnchorAnchorVerifyCancel = makeRequest<
  LiveAgentManageAnchorAnchorVerifyCancelRequest,
  LiveAgentManageAnchorAnchorVerifyCancelResponse
>(liveAgentManageAnchorAnchorVerifyCancelRequestConfig);
export const useLiveAgentManageAnchorAnchorVerifyCancel = makeRequestHook<
  LiveAgentManageAnchorAnchorVerifyCancelRequest,
  LiveAgentManageAnchorAnchorVerifyCancelRequestConfig,
  ReturnType<typeof liveAgentManageAnchorAnchorVerifyCancel>
>(liveAgentManageAnchorAnchorVerifyCancel);

export interface LiveAgentManageAnchorAgentVerifyTransferRequest {
  /**
   * ["123","124"]
   */
  transfer_ids: string[];
  /**
   * 1
   */
  event: number;
}

export interface LiveAgentManageAnchorAgentVerifyTransferResponse {
  fails: {
    uid: number;
    reason: number;
    desc: string;
    ext: {
      key1: string;
      key2: string;
    };
  }[];
}
type LiveAgentManageAnchorAgentVerifyTransferRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_manage_anchor/AgentVerifyTransfer',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentManageAnchorAgentVerifyTransferRequestConfig = {
  mockUrl: mockUrl_0_0_0_13,
  path: '/bigolive/live_agent_manage_anchor/AgentVerifyTransfer',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentManageAnchorAgentVerifyTransfer',
};

export const liveAgentManageAnchorAgentVerifyTransfer = makeRequest<
  LiveAgentManageAnchorAgentVerifyTransferRequest,
  LiveAgentManageAnchorAgentVerifyTransferResponse
>(liveAgentManageAnchorAgentVerifyTransferRequestConfig);
export const useLiveAgentManageAnchorAgentVerifyTransfer = makeRequestHook<
  LiveAgentManageAnchorAgentVerifyTransferRequest,
  LiveAgentManageAnchorAgentVerifyTransferRequestConfig,
  ReturnType<typeof liveAgentManageAnchorAgentVerifyTransfer>
>(liveAgentManageAnchorAgentVerifyTransfer);

export interface LiveAgentManageAnchorAnchorVerifyTransferRequest {
  /**
   * 1
   */
  seq_id: number;
  /**
   * 1
   */
  event: number;
}

export type LiveAgentManageAnchorAnchorVerifyTransferResponse = string;
type LiveAgentManageAnchorAnchorVerifyTransferRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_manage_anchor/AnchorVerifyTransfer',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentManageAnchorAnchorVerifyTransferRequestConfig = {
  mockUrl: mockUrl_0_0_0_13,
  path: '/bigolive/live_agent_manage_anchor/AnchorVerifyTransfer',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentManageAnchorAnchorVerifyTransfer',
};

export const liveAgentManageAnchorAnchorVerifyTransfer = makeRequest<
  LiveAgentManageAnchorAnchorVerifyTransferRequest,
  LiveAgentManageAnchorAnchorVerifyTransferResponse
>(liveAgentManageAnchorAnchorVerifyTransferRequestConfig);
export const useLiveAgentManageAnchorAnchorVerifyTransfer = makeRequestHook<
  LiveAgentManageAnchorAnchorVerifyTransferRequest,
  LiveAgentManageAnchorAnchorVerifyTransferRequestConfig,
  ReturnType<typeof liveAgentManageAnchorAnchorVerifyTransfer>
>(liveAgentManageAnchorAnchorVerifyTransfer);

export interface LiveAgentManageAnchorQryCancelProgressByAnchorRequest {
  /**
   * 1
   */
  seq_id: number;
}

export interface LiveAgentManageAnchorQryCancelProgressByAnchorResponse {
  records: {
    progress: number;
    update_time: number;
    prog_desc: string;
  }[];
  review_left_time: number;
  anchor_verify: number;
}
type LiveAgentManageAnchorQryCancelProgressByAnchorRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_manage_anchor/QryCancelProgressByAnchor',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentManageAnchorQryCancelProgressByAnchorRequestConfig = {
  mockUrl: mockUrl_0_0_0_13,
  path: '/bigolive/live_agent_manage_anchor/QryCancelProgressByAnchor',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentManageAnchorQryCancelProgressByAnchor',
};

export const liveAgentManageAnchorQryCancelProgressByAnchor = makeRequest<
  LiveAgentManageAnchorQryCancelProgressByAnchorRequest,
  LiveAgentManageAnchorQryCancelProgressByAnchorResponse
>(liveAgentManageAnchorQryCancelProgressByAnchorRequestConfig);
export const useLiveAgentManageAnchorQryCancelProgressByAnchor = makeRequestHook<
  LiveAgentManageAnchorQryCancelProgressByAnchorRequest,
  LiveAgentManageAnchorQryCancelProgressByAnchorRequestConfig,
  ReturnType<typeof liveAgentManageAnchorQryCancelProgressByAnchor>
>(liveAgentManageAnchorQryCancelProgressByAnchor);

export interface LiveAgentManageAnchorQryTransferListRequest {
  /**
   * 1
   */
  seq_id: number;
  /**
   * 1
   */
  type: number;
  /**
   * "xx"
   */
  bigo_id: string;
  /**
   * 1
   */
  status: number;
  /**
   * 1
   */
  qry_size: number;
  /**
   * "xx"
   */
  qry_context: string;
  /**
   * 1
   */
  need_total_size: number;
}

export interface LiveAgentManageAnchorQryTransferListResponse {
  seq_id: number;
  records: {
    transfer_id: string;
    anchor_uid: number;
    bigoid: string;
    name: string;
    head: string;
    agency_name: string;
    pre_progress: number;
    progress: number;
    begin_time: number;
    contract_begin_time: number;
    contract_end_time: number;
    operate_bigo_id: string;
    expire_time: number;
    is_anchor_signed: number;
  }[];
  qry_context: string;
  total_size: number;
}
type LiveAgentManageAnchorQryTransferListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_manage_anchor/QryTransferList',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentManageAnchorQryTransferListRequestConfig = {
  mockUrl: mockUrl_0_0_0_13,
  path: '/bigolive/live_agent_manage_anchor/QryTransferList',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentManageAnchorQryTransferList',
};

export const liveAgentManageAnchorQryTransferList = makeRequest<
  LiveAgentManageAnchorQryTransferListRequest,
  LiveAgentManageAnchorQryTransferListResponse
>(liveAgentManageAnchorQryTransferListRequestConfig);
export const useLiveAgentManageAnchorQryTransferList = makeRequestHook<
  LiveAgentManageAnchorQryTransferListRequest,
  LiveAgentManageAnchorQryTransferListRequestConfig,
  ReturnType<typeof liveAgentManageAnchorQryTransferList>
>(liveAgentManageAnchorQryTransferList);

export interface LiveAgentManageAnchorQryCancelContractListRequest {
  /**
   * "xx"
   */
  bigo_id: string;
  /**
   * 1
   */
  status: number;
  /**
   * 1
   */
  qry_size: number;
  /**
   * "xx"
   */
  qry_context: string;
  /**
   * 1
   */
  need_total_size: number;
}

export interface LiveAgentManageAnchorQryCancelContractListResponse {
  seq_id: number;
  records: {
    cancel_id: string;
    anchor_uid: number;
    bigoid: string;
    name: string;
    head: string;
    pre_progress: number;
    progress: number;
    begin_time: number;
    expire_time: number;
  }[];
  qry_context: string;
  total_size: number;
}
type LiveAgentManageAnchorQryCancelContractListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_manage_anchor/QryCancelContractList',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentManageAnchorQryCancelContractListRequestConfig = {
  mockUrl: mockUrl_0_0_0_13,
  path: '/bigolive/live_agent_manage_anchor/QryCancelContractList',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentManageAnchorQryCancelContractList',
};

export const liveAgentManageAnchorQryCancelContractList = makeRequest<
  LiveAgentManageAnchorQryCancelContractListRequest,
  LiveAgentManageAnchorQryCancelContractListResponse
>(liveAgentManageAnchorQryCancelContractListRequestConfig);
export const useLiveAgentManageAnchorQryCancelContractList = makeRequestHook<
  LiveAgentManageAnchorQryCancelContractListRequest,
  LiveAgentManageAnchorQryCancelContractListRequestConfig,
  ReturnType<typeof liveAgentManageAnchorQryCancelContractList>
>(liveAgentManageAnchorQryCancelContractList);

export interface LiveAgentManageAnchorQryTransferProgressForAgentRequest {
  /**
   * "xx"
   */
  transfer_id: string;
}

export interface LiveAgentManageAnchorQryTransferProgressForAgentResponse {
  records: {
    progress: number;
    update_time: number;
    prog_event: number;
    prog_desc: string;
  }[];
}
type LiveAgentManageAnchorQryTransferProgressForAgentRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_manage_anchor/QryTransferProgressForAgent',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentManageAnchorQryTransferProgressForAgentRequestConfig = {
  mockUrl: mockUrl_0_0_0_13,
  path: '/bigolive/live_agent_manage_anchor/QryTransferProgressForAgent',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentManageAnchorQryTransferProgressForAgent',
};

export const liveAgentManageAnchorQryTransferProgressForAgent = makeRequest<
  LiveAgentManageAnchorQryTransferProgressForAgentRequest,
  LiveAgentManageAnchorQryTransferProgressForAgentResponse
>(liveAgentManageAnchorQryTransferProgressForAgentRequestConfig);
export const useLiveAgentManageAnchorQryTransferProgressForAgent = makeRequestHook<
  LiveAgentManageAnchorQryTransferProgressForAgentRequest,
  LiveAgentManageAnchorQryTransferProgressForAgentRequestConfig,
  ReturnType<typeof liveAgentManageAnchorQryTransferProgressForAgent>
>(liveAgentManageAnchorQryTransferProgressForAgent);

export interface LiveAgentManageAnchorQryCancelProgressForAgentRequest {
  /**
   * "xx"
   */
  cancel_id: string;
}

export interface LiveAgentManageAnchorQryCancelProgressForAgentResponse {
  records: {
    progress: number;
    update_time: number;
    prog_event: number;
    prog_desc: string;
  }[];
  anchor_verify: number;
}
type LiveAgentManageAnchorQryCancelProgressForAgentRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_manage_anchor/QryCancelProgressForAgent',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentManageAnchorQryCancelProgressForAgentRequestConfig = {
  mockUrl: mockUrl_0_0_0_13,
  path: '/bigolive/live_agent_manage_anchor/QryCancelProgressForAgent',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentManageAnchorQryCancelProgressForAgent',
};

export const liveAgentManageAnchorQryCancelProgressForAgent = makeRequest<
  LiveAgentManageAnchorQryCancelProgressForAgentRequest,
  LiveAgentManageAnchorQryCancelProgressForAgentResponse
>(liveAgentManageAnchorQryCancelProgressForAgentRequestConfig);
export const useLiveAgentManageAnchorQryCancelProgressForAgent = makeRequestHook<
  LiveAgentManageAnchorQryCancelProgressForAgentRequest,
  LiveAgentManageAnchorQryCancelProgressForAgentRequestConfig,
  ReturnType<typeof liveAgentManageAnchorQryCancelProgressForAgent>
>(liveAgentManageAnchorQryCancelProgressForAgent);

export interface LiveAgentManageAnchorQryAnchorRelationChangeProgRequest {}

export interface LiveAgentManageAnchorQryAnchorRelationChangeProgResponse {
  transfer_progress: number;
  cancel_progress: number;
  review_left_time: number;
}
type LiveAgentManageAnchorQryAnchorRelationChangeProgRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_manage_anchor/QryAnchorRelationChangeProg',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentManageAnchorQryAnchorRelationChangeProgRequestConfig = {
  mockUrl: mockUrl_0_0_0_13,
  path: '/bigolive/live_agent_manage_anchor/QryAnchorRelationChangeProg',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentManageAnchorQryAnchorRelationChangeProg',
};

export const liveAgentManageAnchorQryAnchorRelationChangeProg = makeRequest<
  LiveAgentManageAnchorQryAnchorRelationChangeProgRequest,
  LiveAgentManageAnchorQryAnchorRelationChangeProgResponse
>(liveAgentManageAnchorQryAnchorRelationChangeProgRequestConfig);
export const useLiveAgentManageAnchorQryAnchorRelationChangeProg = makeRequestHook<
  LiveAgentManageAnchorQryAnchorRelationChangeProgRequest,
  LiveAgentManageAnchorQryAnchorRelationChangeProgRequestConfig,
  ReturnType<typeof liveAgentManageAnchorQryAnchorRelationChangeProg>
>(liveAgentManageAnchorQryAnchorRelationChangeProg);

export interface LiveAgentManageAnchorQryTransferProgressByAnchorRequest {
  /**
   * 1
   */
  seq_id: number;
}

export interface LiveAgentManageAnchorQryTransferProgressByAnchorResponse {
  records: {
    progress: number;
    update_time: number;
    prog_desc: string;
  }[];
  review_left_time: number;
  to_proxy_bigoid: string;
}
type LiveAgentManageAnchorQryTransferProgressByAnchorRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_manage_anchor/QryTransferProgressByAnchor',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentManageAnchorQryTransferProgressByAnchorRequestConfig = {
  mockUrl: mockUrl_0_0_0_13,
  path: '/bigolive/live_agent_manage_anchor/QryTransferProgressByAnchor',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentManageAnchorQryTransferProgressByAnchor',
};

export const liveAgentManageAnchorQryTransferProgressByAnchor = makeRequest<
  LiveAgentManageAnchorQryTransferProgressByAnchorRequest,
  LiveAgentManageAnchorQryTransferProgressByAnchorResponse
>(liveAgentManageAnchorQryTransferProgressByAnchorRequestConfig);
export const useLiveAgentManageAnchorQryTransferProgressByAnchor = makeRequestHook<
  LiveAgentManageAnchorQryTransferProgressByAnchorRequest,
  LiveAgentManageAnchorQryTransferProgressByAnchorRequestConfig,
  ReturnType<typeof liveAgentManageAnchorQryTransferProgressByAnchor>
>(liveAgentManageAnchorQryTransferProgressByAnchor);

export interface LiveAgentManageAnchorQryAnchorRelationChgTabVisibleRequest {}

export interface LiveAgentManageAnchorQryAnchorRelationChgTabVisibleResponse {
  transfer: number;
  cancel: number;
}
type LiveAgentManageAnchorQryAnchorRelationChgTabVisibleRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_manage_anchor/QryAnchorRelationChgTabVisible',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentManageAnchorQryAnchorRelationChgTabVisibleRequestConfig = {
  mockUrl: mockUrl_0_0_0_13,
  path: '/bigolive/live_agent_manage_anchor/QryAnchorRelationChgTabVisible',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentManageAnchorQryAnchorRelationChgTabVisible',
};

export const liveAgentManageAnchorQryAnchorRelationChgTabVisible = makeRequest<
  LiveAgentManageAnchorQryAnchorRelationChgTabVisibleRequest,
  LiveAgentManageAnchorQryAnchorRelationChgTabVisibleResponse
>(liveAgentManageAnchorQryAnchorRelationChgTabVisibleRequestConfig);
export const useLiveAgentManageAnchorQryAnchorRelationChgTabVisible = makeRequestHook<
  LiveAgentManageAnchorQryAnchorRelationChgTabVisibleRequest,
  LiveAgentManageAnchorQryAnchorRelationChgTabVisibleRequestConfig,
  ReturnType<typeof liveAgentManageAnchorQryAnchorRelationChgTabVisible>
>(liveAgentManageAnchorQryAnchorRelationChgTabVisible);

const mockUrl_0_0_0_14 = 'http://yapi.ppx520.com/mock/8015' as any;
const dataKey_0_0_0_14 = 'data' as any;

export interface LiveAgentPortalGetAuthorizationStatusRequest {
  /**
   * 123
   */
  seq_id: number;
  /**
   * "456"
   */
  bigoId: string;
  /**
   * "789"
   */
  id: string;
}

export interface LiveAgentPortalGetAuthorizationStatusResponse {
  id: number;
  title: string;
  content: string;
  status: number;
  start_time: string;
  end_time: string;
  send_app: number;
  sms_code_switch: number;
  telephone_code: string;
  telephone: string;
  telephone_show: string;
  signed_status: number;
  kyc_status: number;
}
type LiveAgentPortalGetAuthorizationStatusRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_portal/GetAuthorizationStatus',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentPortalGetAuthorizationStatusRequestConfig = {
  mockUrl: mockUrl_0_0_0_14,
  path: '/bigolive/live_agent_portal/GetAuthorizationStatus',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentPortalGetAuthorizationStatus',
};

export const liveAgentPortalGetAuthorizationStatus = makeRequest<
  LiveAgentPortalGetAuthorizationStatusRequest,
  LiveAgentPortalGetAuthorizationStatusResponse
>(liveAgentPortalGetAuthorizationStatusRequestConfig);
export const useLiveAgentPortalGetAuthorizationStatus = makeRequestHook<
  LiveAgentPortalGetAuthorizationStatusRequest,
  LiveAgentPortalGetAuthorizationStatusRequestConfig,
  ReturnType<typeof liveAgentPortalGetAuthorizationStatus>
>(liveAgentPortalGetAuthorizationStatus);

export interface LiveAgentPortalSetAuthorizationStatusRequest {
  /**
   * 123
   */
  seq_id: number;
  /**
   * "456"
   */
  bigoId: string;
  /**
   * "789"
   */
  id: string;
  /**
   * 3
   */
  status: number;
}

export interface LiveAgentPortalSetAuthorizationStatusResponse {
  id: number;
}
type LiveAgentPortalSetAuthorizationStatusRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_portal/SetAuthorizationStatus',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentPortalSetAuthorizationStatusRequestConfig = {
  mockUrl: mockUrl_0_0_0_14,
  path: '/bigolive/live_agent_portal/SetAuthorizationStatus',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentPortalSetAuthorizationStatus',
};

export const liveAgentPortalSetAuthorizationStatus = makeRequest<
  LiveAgentPortalSetAuthorizationStatusRequest,
  LiveAgentPortalSetAuthorizationStatusResponse
>(liveAgentPortalSetAuthorizationStatusRequestConfig);
export const useLiveAgentPortalSetAuthorizationStatus = makeRequestHook<
  LiveAgentPortalSetAuthorizationStatusRequest,
  LiveAgentPortalSetAuthorizationStatusRequestConfig,
  ReturnType<typeof liveAgentPortalSetAuthorizationStatus>
>(liveAgentPortalSetAuthorizationStatus);

const mockUrl_0_0_0_15 = 'http://yapi.ppx520.com/mock/8015' as any;
const dataKey_0_0_0_15 = 'data' as any;

export interface LiveAgentServiceGetPaymentCfgRequest {
  /**
   * [1,2,3]
   */
  submit_types: number[];
}

export interface LiveAgentServiceGetPaymentCfgResponse {
  payemnt_cfgs: {
    '1': {
      active: boolean;
      window_open: boolean;
      begin_date: string;
      end_date: string;
      payment_types: number[];
      notice: boolean;
    };
    '2': {
      active: boolean;
      window_open: boolean;
      begin_date: string;
      end_date: string;
      payment_types: number[];
      notice: boolean;
    };
    '3': {
      active: boolean;
    };
  };
}
type LiveAgentServiceGetPaymentCfgRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/GetPaymentCfg',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServiceGetPaymentCfgRequestConfig = {
  mockUrl: mockUrl_0_0_0_15,
  path: '/bigolive/live_agent_service/GetPaymentCfg',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceGetPaymentCfg',
};

export const liveAgentServiceGetPaymentCfg = makeRequest<
  LiveAgentServiceGetPaymentCfgRequest,
  LiveAgentServiceGetPaymentCfgResponse
>(liveAgentServiceGetPaymentCfgRequestConfig);
export const useLiveAgentServiceGetPaymentCfg = makeRequestHook<
  LiveAgentServiceGetPaymentCfgRequest,
  LiveAgentServiceGetPaymentCfgRequestConfig,
  ReturnType<typeof liveAgentServiceGetPaymentCfg>
>(liveAgentServiceGetPaymentCfg);

export interface LiveAgentServiceAnchorSubmitAnchorPaymentRequest {
  /**
   * 1
   */
  payment_type: number;
  bank_info: {
    /**
     * "xx"
     */
    bank_name: string;
    /**
     * "xx"
     */
    bank_address: string;
    /**
     * "xx"
     */
    swift_code: string;
    /**
     * "xx"
     */
    account_name: string;
    /**
     * "xx"
     */
    account_number: string;
    /**
     * "xx"
     */
    account_address: string;
  };
}

export interface LiveAgentServiceAnchorSubmitAnchorPaymentResponse {}
type LiveAgentServiceAnchorSubmitAnchorPaymentRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/AnchorSubmitAnchorPayment',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServiceAnchorSubmitAnchorPaymentRequestConfig = {
  mockUrl: mockUrl_0_0_0_15,
  path: '/bigolive/live_agent_service/AnchorSubmitAnchorPayment',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceAnchorSubmitAnchorPayment',
};

export const liveAgentServiceAnchorSubmitAnchorPayment = makeRequest<
  LiveAgentServiceAnchorSubmitAnchorPaymentRequest,
  LiveAgentServiceAnchorSubmitAnchorPaymentResponse
>(liveAgentServiceAnchorSubmitAnchorPaymentRequestConfig);
export const useLiveAgentServiceAnchorSubmitAnchorPayment = makeRequestHook<
  LiveAgentServiceAnchorSubmitAnchorPaymentRequest,
  LiveAgentServiceAnchorSubmitAnchorPaymentRequestConfig,
  ReturnType<typeof liveAgentServiceAnchorSubmitAnchorPayment>
>(liveAgentServiceAnchorSubmitAnchorPayment);

export interface LiveAgentServiceGetAnchorSubmittedAnchorPaymentRequest {}

export interface LiveAgentServiceGetAnchorSubmittedAnchorPaymentResponse {
  submit_status: number;
  payment_type: number;
  receiver_uid: number;
  bank_info: {
    bank_name: string;
    bank_address: string;
    swift_code: string;
    account_name: string;
    account_number: string;
    account_address: string;
  };
}
type LiveAgentServiceGetAnchorSubmittedAnchorPaymentRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/GetAnchorSubmittedAnchorPayment',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentServiceGetAnchorSubmittedAnchorPaymentRequestConfig = {
  mockUrl: mockUrl_0_0_0_15,
  path: '/bigolive/live_agent_service/GetAnchorSubmittedAnchorPayment',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceGetAnchorSubmittedAnchorPayment',
};

export const liveAgentServiceGetAnchorSubmittedAnchorPayment = makeRequest<
  LiveAgentServiceGetAnchorSubmittedAnchorPaymentRequest,
  LiveAgentServiceGetAnchorSubmittedAnchorPaymentResponse
>(liveAgentServiceGetAnchorSubmittedAnchorPaymentRequestConfig);
export const useLiveAgentServiceGetAnchorSubmittedAnchorPayment = makeRequestHook<
  LiveAgentServiceGetAnchorSubmittedAnchorPaymentRequest,
  LiveAgentServiceGetAnchorSubmittedAnchorPaymentRequestConfig,
  ReturnType<typeof liveAgentServiceGetAnchorSubmittedAnchorPayment>
>(liveAgentServiceGetAnchorSubmittedAnchorPayment);

export interface LiveAgentServiceAgentSubmitAgentPaymentRequest {
  /**
   * 1
   */
  payment_type: number;
  /**
   * "xxx"
   */
  receiver_bigoid: string;
  bank_info: {
    /**
     * "xx"
     */
    bank_name: string;
    /**
     * "xx"
     */
    bank_address: string;
    /**
     * "xx"
     */
    swift_code: string;
    /**
     * "xx"
     */
    account_name: string;
    /**
     * "xx"
     */
    account_number: string;
    /**
     * "xx"
     */
    account_address: string;
  };
}

export interface LiveAgentServiceAgentSubmitAgentPaymentResponse {}
type LiveAgentServiceAgentSubmitAgentPaymentRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/AgentSubmitAgentPayment',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServiceAgentSubmitAgentPaymentRequestConfig = {
  mockUrl: mockUrl_0_0_0_15,
  path: '/bigolive/live_agent_service/AgentSubmitAgentPayment',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceAgentSubmitAgentPayment',
};

export const liveAgentServiceAgentSubmitAgentPayment = makeRequest<
  LiveAgentServiceAgentSubmitAgentPaymentRequest,
  LiveAgentServiceAgentSubmitAgentPaymentResponse
>(liveAgentServiceAgentSubmitAgentPaymentRequestConfig);
export const useLiveAgentServiceAgentSubmitAgentPayment = makeRequestHook<
  LiveAgentServiceAgentSubmitAgentPaymentRequest,
  LiveAgentServiceAgentSubmitAgentPaymentRequestConfig,
  ReturnType<typeof liveAgentServiceAgentSubmitAgentPayment>
>(liveAgentServiceAgentSubmitAgentPayment);

export interface LiveAgentServiceGetAgentSubmittedAgentPaymentRequest {}

export interface LiveAgentServiceGetAgentSubmittedAgentPaymentResponse {
  submit_status: number;
  payment_type: number;
  receiver_bigoid: string;
  bank_info: {
    bank_name: string;
    bank_address: string;
    swift_code: string;
    account_name: string;
    account_number: string;
    account_address: string;
  };
}
type LiveAgentServiceGetAgentSubmittedAgentPaymentRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/GetAgentSubmittedAgentPayment',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentServiceGetAgentSubmittedAgentPaymentRequestConfig = {
  mockUrl: mockUrl_0_0_0_15,
  path: '/bigolive/live_agent_service/GetAgentSubmittedAgentPayment',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServiceGetAgentSubmittedAgentPayment',
};

export const liveAgentServiceGetAgentSubmittedAgentPayment = makeRequest<
  LiveAgentServiceGetAgentSubmittedAgentPaymentRequest,
  LiveAgentServiceGetAgentSubmittedAgentPaymentResponse
>(liveAgentServiceGetAgentSubmittedAgentPaymentRequestConfig);
export const useLiveAgentServiceGetAgentSubmittedAgentPayment = makeRequestHook<
  LiveAgentServiceGetAgentSubmittedAgentPaymentRequest,
  LiveAgentServiceGetAgentSubmittedAgentPaymentRequestConfig,
  ReturnType<typeof liveAgentServiceGetAgentSubmittedAgentPayment>
>(liveAgentServiceGetAgentSubmittedAgentPayment);

export interface LiveAgentServicePaymentAgencyBroadcastListRequest {
  /**
   * "xxx"
   */
  bigo_id: string;
}

export interface LiveAgentServicePaymentAgencyBroadcastListResponse {
  list: {
    uid: number;
    bigo_id: string;
    nickname: string;
  }[];
}
type LiveAgentServicePaymentAgencyBroadcastListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/PaymentAgencyBroadcastList',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServicePaymentAgencyBroadcastListRequestConfig = {
  mockUrl: mockUrl_0_0_0_15,
  path: '/bigolive/live_agent_service/PaymentAgencyBroadcastList',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServicePaymentAgencyBroadcastList',
};

export const liveAgentServicePaymentAgencyBroadcastList = makeRequest<
  LiveAgentServicePaymentAgencyBroadcastListRequest,
  LiveAgentServicePaymentAgencyBroadcastListResponse
>(liveAgentServicePaymentAgencyBroadcastListRequestConfig);
export const useLiveAgentServicePaymentAgencyBroadcastList = makeRequestHook<
  LiveAgentServicePaymentAgencyBroadcastListRequest,
  LiveAgentServicePaymentAgencyBroadcastListRequestConfig,
  ReturnType<typeof liveAgentServicePaymentAgencyBroadcastList>
>(liveAgentServicePaymentAgencyBroadcastList);

export interface LiveAgentServicePaymentAgencyByBeansMethodListRequest {
  /**
   * "xxx"
   */
  bigo_id: string;
  /**
   * 1
   */
  type: number;
  /**
   * 1234
   */
  uid: number;
  /**
   * 1233
   */
  page_num: number;
  /**
   * 20
   */
  page_size: number;
  is_export: number;
}

export interface LiveAgentServicePaymentAgencyByBeansMethodListResponse {
  list: {
    uid: number;
    bigo_id: string;
    nickname: string;
    agent_uid: number;
    agent: string;
    type: number;
    receiving_bigo_id: string;
    update_time: string;
    create_time: string;
    id: string;
  }[];
}
type LiveAgentServicePaymentAgencyByBeansMethodListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/PaymentAgencyByBeansMethodList',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServicePaymentAgencyByBeansMethodListRequestConfig = {
  mockUrl: mockUrl_0_0_0_15,
  path: '/bigolive/live_agent_service/PaymentAgencyByBeansMethodList',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServicePaymentAgencyByBeansMethodList',
};

export const liveAgentServicePaymentAgencyByBeansMethodList = makeRequest<
  LiveAgentServicePaymentAgencyByBeansMethodListRequest,
  LiveAgentServicePaymentAgencyByBeansMethodListResponse
>(liveAgentServicePaymentAgencyByBeansMethodListRequestConfig);
export const useLiveAgentServicePaymentAgencyByBeansMethodList = makeRequestHook<
  LiveAgentServicePaymentAgencyByBeansMethodListRequest,
  LiveAgentServicePaymentAgencyByBeansMethodListRequestConfig,
  ReturnType<typeof liveAgentServicePaymentAgencyByBeansMethodList>
>(liveAgentServicePaymentAgencyByBeansMethodList);

export interface LiveAgentServicePaymentAgencyByBeansMethodAddRequest {
  /**
   * 1
   */
  type: number;
  /**
   * [100,200]
   */
  uids: number[];
}

export interface LiveAgentServicePaymentAgencyByBeansMethodAddResponse {}
type LiveAgentServicePaymentAgencyByBeansMethodAddRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/PaymentAgencyByBeansMethodAdd',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServicePaymentAgencyByBeansMethodAddRequestConfig = {
  mockUrl: mockUrl_0_0_0_15,
  path: '/bigolive/live_agent_service/PaymentAgencyByBeansMethodAdd',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServicePaymentAgencyByBeansMethodAdd',
};

export const liveAgentServicePaymentAgencyByBeansMethodAdd = makeRequest<
  LiveAgentServicePaymentAgencyByBeansMethodAddRequest,
  LiveAgentServicePaymentAgencyByBeansMethodAddResponse
>(liveAgentServicePaymentAgencyByBeansMethodAddRequestConfig);
export const useLiveAgentServicePaymentAgencyByBeansMethodAdd = makeRequestHook<
  LiveAgentServicePaymentAgencyByBeansMethodAddRequest,
  LiveAgentServicePaymentAgencyByBeansMethodAddRequestConfig,
  ReturnType<typeof liveAgentServicePaymentAgencyByBeansMethodAdd>
>(liveAgentServicePaymentAgencyByBeansMethodAdd);

export interface LiveAgentServicePaymentAgencyByBeansMethodEditRequest {
  /**
   * 1
   */
  type: number;
  /**
   * ["123","234"]
   */
  ids: string[];
}

export interface LiveAgentServicePaymentAgencyByBeansMethodEditResponse {}
type LiveAgentServicePaymentAgencyByBeansMethodEditRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/PaymentAgencyByBeansMethodEdit',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServicePaymentAgencyByBeansMethodEditRequestConfig = {
  mockUrl: mockUrl_0_0_0_15,
  path: '/bigolive/live_agent_service/PaymentAgencyByBeansMethodEdit',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServicePaymentAgencyByBeansMethodEdit',
};

export const liveAgentServicePaymentAgencyByBeansMethodEdit = makeRequest<
  LiveAgentServicePaymentAgencyByBeansMethodEditRequest,
  LiveAgentServicePaymentAgencyByBeansMethodEditResponse
>(liveAgentServicePaymentAgencyByBeansMethodEditRequestConfig);
export const useLiveAgentServicePaymentAgencyByBeansMethodEdit = makeRequestHook<
  LiveAgentServicePaymentAgencyByBeansMethodEditRequest,
  LiveAgentServicePaymentAgencyByBeansMethodEditRequestConfig,
  ReturnType<typeof liveAgentServicePaymentAgencyByBeansMethodEdit>
>(liveAgentServicePaymentAgencyByBeansMethodEdit);

export interface LiveAgentServicePaymentAgencyByBeansMethodDeleteRequest {
  /**
   * "123"
   */
  id: string;
}

export interface LiveAgentServicePaymentAgencyByBeansMethodDeleteResponse {}
type LiveAgentServicePaymentAgencyByBeansMethodDeleteRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_service/PaymentAgencyByBeansMethodDelete',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentServicePaymentAgencyByBeansMethodDeleteRequestConfig = {
  mockUrl: mockUrl_0_0_0_15,
  path: '/bigolive/live_agent_service/PaymentAgencyByBeansMethodDelete',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentServicePaymentAgencyByBeansMethodDelete',
};

export const liveAgentServicePaymentAgencyByBeansMethodDelete = makeRequest<
  LiveAgentServicePaymentAgencyByBeansMethodDeleteRequest,
  LiveAgentServicePaymentAgencyByBeansMethodDeleteResponse
>(liveAgentServicePaymentAgencyByBeansMethodDeleteRequestConfig);
export const useLiveAgentServicePaymentAgencyByBeansMethodDelete = makeRequestHook<
  LiveAgentServicePaymentAgencyByBeansMethodDeleteRequest,
  LiveAgentServicePaymentAgencyByBeansMethodDeleteRequestConfig,
  ReturnType<typeof liveAgentServicePaymentAgencyByBeansMethodDelete>
>(liveAgentServicePaymentAgencyByBeansMethodDelete);

export interface XxxxxxxRequest {}

export interface XxxxxxxResponse {}
type XxxxxxxRequestConfig = Readonly<
  RequestConfig<'http://yapi.ppx520.com/mock/8015', '/xxxxxxx', 'data', string, string, true>
>;

const xxxxxxxRequestConfig = {
  mockUrl: mockUrl_0_0_0_15,
  path: '/xxxxxxx',
  isYapi: true,
  isC: true,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'xxxxxxx',
};

export const xxxxxxx = makeRequest<XxxxxxxRequest, XxxxxxxResponse>(xxxxxxxRequestConfig);
export const useXxxxxxx = makeRequestHook<
  XxxxxxxRequest,
  XxxxxxxRequestConfig,
  ReturnType<typeof xxxxxxx>
>(xxxxxxx);

const mockUrl_0_0_0_16 = 'http://yapi.ppx520.com/mock/8015' as any;
const dataKey_0_0_0_16 = 'data' as any;

export interface LiveAgentPortalSendVerifyCodeRequest {
  /**
   * 123
   */
  send_app: number;
  /**
   * "456"
   */
  phone: string;
}

export interface LiveAgentPortalSendVerifyCodeResponse {
  success: boolean;
}
type LiveAgentPortalSendVerifyCodeRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_portal/sendVerifyCode',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentPortalSendVerifyCodeRequestConfig = {
  mockUrl: mockUrl_0_0_0_16,
  path: '/bigolive/live_agent_portal/sendVerifyCode',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_16,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentPortalSendVerifyCode',
};

export const liveAgentPortalSendVerifyCode = makeRequest<
  LiveAgentPortalSendVerifyCodeRequest,
  LiveAgentPortalSendVerifyCodeResponse
>(liveAgentPortalSendVerifyCodeRequestConfig);
export const useLiveAgentPortalSendVerifyCode = makeRequestHook<
  LiveAgentPortalSendVerifyCodeRequest,
  LiveAgentPortalSendVerifyCodeRequestConfig,
  ReturnType<typeof liveAgentPortalSendVerifyCode>
>(liveAgentPortalSendVerifyCode);

export interface LiveAgentPortalCheckVerifyCodeRequest {
  /**
   * 123
   */
  send_app: number;
  /**
   * "456"
   */
  phone: string;
  code: string;
}

export interface LiveAgentPortalCheckVerifyCodeResponse {
  success: boolean;
}
type LiveAgentPortalCheckVerifyCodeRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_portal/checkVerifyCode',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentPortalCheckVerifyCodeRequestConfig = {
  mockUrl: mockUrl_0_0_0_16,
  path: '/bigolive/live_agent_portal/checkVerifyCode',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_16,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentPortalCheckVerifyCode',
};

export const liveAgentPortalCheckVerifyCode = makeRequest<
  LiveAgentPortalCheckVerifyCodeRequest,
  LiveAgentPortalCheckVerifyCodeResponse
>(liveAgentPortalCheckVerifyCodeRequestConfig);
export const useLiveAgentPortalCheckVerifyCode = makeRequestHook<
  LiveAgentPortalCheckVerifyCodeRequest,
  LiveAgentPortalCheckVerifyCodeRequestConfig,
  ReturnType<typeof liveAgentPortalCheckVerifyCode>
>(liveAgentPortalCheckVerifyCode);

const mockUrl_0_0_0_17 = 'http://yapi.ppx520.com/mock/8015' as any;
const dataKey_0_0_0_17 = 'data' as any;

export interface LiveAgentPortalAct85157getTabListRequest {
  /**
   * "zh"
   */
  lang: string;
  /**
   * 1
   */
  entry_type: number;
}

export interface LiveAgentPortalAct85157getTabListResponse {
  list: {
    id: number;
    name: string;
  }[];
}
type LiveAgentPortalAct85157getTabListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_portal/act85157getTabList',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentPortalAct85157getTabListRequestConfig = {
  mockUrl: mockUrl_0_0_0_17,
  path: '/bigolive/live_agent_portal/act85157getTabList',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_17,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentPortalAct85157getTabList',
};

export const liveAgentPortalAct85157getTabList = makeRequest<
  LiveAgentPortalAct85157getTabListRequest,
  LiveAgentPortalAct85157getTabListResponse
>(liveAgentPortalAct85157getTabListRequestConfig);
export const useLiveAgentPortalAct85157getTabList = makeRequestHook<
  LiveAgentPortalAct85157getTabListRequest,
  LiveAgentPortalAct85157getTabListRequestConfig,
  ReturnType<typeof liveAgentPortalAct85157getTabList>
>(liveAgentPortalAct85157getTabList);

export interface LiveAgentPortalAct85157searchTutorialRequest {
  /**
   * "xxx"
   */
  name: string;
  /**
   * "zh"
   */
  lang: string;
  /**
   * 1
   */
  entry_type: number;
  /**
   * 1
   */
  tab_id: number;
}

export interface LiveAgentPortalAct85157searchTutorialResponse {
  list: {
    id: number;
    img_url: string;
    name: string;
    content_type: string;
    content_url: string;
  }[];
}
type LiveAgentPortalAct85157searchTutorialRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_portal/act85157searchTutorial',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentPortalAct85157searchTutorialRequestConfig = {
  mockUrl: mockUrl_0_0_0_17,
  path: '/bigolive/live_agent_portal/act85157searchTutorial',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_17,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentPortalAct85157searchTutorial',
};

export const liveAgentPortalAct85157searchTutorial = makeRequest<
  LiveAgentPortalAct85157searchTutorialRequest,
  LiveAgentPortalAct85157searchTutorialResponse
>(liveAgentPortalAct85157searchTutorialRequestConfig);
export const useLiveAgentPortalAct85157searchTutorial = makeRequestHook<
  LiveAgentPortalAct85157searchTutorialRequest,
  LiveAgentPortalAct85157searchTutorialRequestConfig,
  ReturnType<typeof liveAgentPortalAct85157searchTutorial>
>(liveAgentPortalAct85157searchTutorial);

export interface LiveAgentPortalAct85157getTutorialByIdRequest {
  /**
   * 123
   */
  id: number;
  /**
   * "xxx"
   */
  lang: string;
  /**
   * 1
   */
  entry_type: number;
}

export interface LiveAgentPortalAct85157getTutorialByIdResponse {
  id: string;
  content_type: number;
  content_url: string;
  name: string;
}
type LiveAgentPortalAct85157getTutorialByIdRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_portal/act85157getTutorialById',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentPortalAct85157getTutorialByIdRequestConfig = {
  mockUrl: mockUrl_0_0_0_17,
  path: '/bigolive/live_agent_portal/act85157getTutorialById',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_17,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentPortalAct85157getTutorialById',
};

export const liveAgentPortalAct85157getTutorialById = makeRequest<
  LiveAgentPortalAct85157getTutorialByIdRequest,
  LiveAgentPortalAct85157getTutorialByIdResponse
>(liveAgentPortalAct85157getTutorialByIdRequestConfig);
export const useLiveAgentPortalAct85157getTutorialById = makeRequestHook<
  LiveAgentPortalAct85157getTutorialByIdRequest,
  LiveAgentPortalAct85157getTutorialByIdRequestConfig,
  ReturnType<typeof liveAgentPortalAct85157getTutorialById>
>(liveAgentPortalAct85157getTutorialById);

export interface LiveAgentPortalAct85157getTutorialListRequest {
  /**
   * "zh"
   */
  lang: string;
  /**
   * 1
   */
  entry_type: number;
  /**
   * "0"
   */
  cursor: string;
  /**
   * 1
   */
  tab_id: number;
  /**
   * 10
   */
  size: number;
}

export interface LiveAgentPortalAct85157getTutorialListResponse {
  list: {
    id: number;
    img_url: string;
    name: string;
    content_type: string;
    content_url: string;
  }[];
  cursor: string;
  total: number;
}
type LiveAgentPortalAct85157getTutorialListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_portal/act85157getTutorialList',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentPortalAct85157getTutorialListRequestConfig = {
  mockUrl: mockUrl_0_0_0_17,
  path: '/bigolive/live_agent_portal/act85157getTutorialList',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_17,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentPortalAct85157getTutorialList',
};

export const liveAgentPortalAct85157getTutorialList = makeRequest<
  LiveAgentPortalAct85157getTutorialListRequest,
  LiveAgentPortalAct85157getTutorialListResponse
>(liveAgentPortalAct85157getTutorialListRequestConfig);
export const useLiveAgentPortalAct85157getTutorialList = makeRequestHook<
  LiveAgentPortalAct85157getTutorialListRequest,
  LiveAgentPortalAct85157getTutorialListRequestConfig,
  ReturnType<typeof liveAgentPortalAct85157getTutorialList>
>(liveAgentPortalAct85157getTutorialList);

const mockUrl_0_0_0_18 = 'http://yapi.ppx520.com/mock/8015' as any;
const dataKey_0_0_0_18 = 'data' as any;

export interface LiveAgentFrontSendDownloadFileMessageRequest {
  /**
   * 1234
   */
  id: number;
}

export interface LiveAgentFrontSendDownloadFileMessageResponse {}
type LiveAgentFrontSendDownloadFileMessageRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/SendDownloadFileMessage',
    'data',
    string,
    string,
    false
  >
>;

const liveAgentFrontSendDownloadFileMessageRequestConfig = {
  mockUrl: mockUrl_0_0_0_18,
  path: '/bigolive/live_agent_front/SendDownloadFileMessage',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_18,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontSendDownloadFileMessage',
};

export const liveAgentFrontSendDownloadFileMessage = makeRequest<
  LiveAgentFrontSendDownloadFileMessageRequest,
  LiveAgentFrontSendDownloadFileMessageResponse
>(liveAgentFrontSendDownloadFileMessageRequestConfig);
export const useLiveAgentFrontSendDownloadFileMessage = makeRequestHook<
  LiveAgentFrontSendDownloadFileMessageRequest,
  LiveAgentFrontSendDownloadFileMessageRequestConfig,
  ReturnType<typeof liveAgentFrontSendDownloadFileMessage>
>(liveAgentFrontSendDownloadFileMessage);

export interface LiveAgentFrontQueryRegionAgentConfigRequest {}

export interface LiveAgentFrontQueryRegionAgentConfigResponse {
  sign_time_open: number;
  month_options: number[];
}
type LiveAgentFrontQueryRegionAgentConfigRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/8015',
    '/bigolive/live_agent_front/QueryRegionAgentConfig',
    'data',
    string,
    string,
    true
  >
>;

const liveAgentFrontQueryRegionAgentConfigRequestConfig = {
  mockUrl: mockUrl_0_0_0_18,
  path: '/bigolive/live_agent_front/QueryRegionAgentConfig',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_18,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveAgentFrontQueryRegionAgentConfig',
};

export const liveAgentFrontQueryRegionAgentConfig = makeRequest<
  LiveAgentFrontQueryRegionAgentConfigRequest,
  LiveAgentFrontQueryRegionAgentConfigResponse
>(liveAgentFrontQueryRegionAgentConfigRequestConfig);
export const useLiveAgentFrontQueryRegionAgentConfig = makeRequestHook<
  LiveAgentFrontQueryRegionAgentConfigRequest,
  LiveAgentFrontQueryRegionAgentConfigRequestConfig,
  ReturnType<typeof liveAgentFrontQueryRegionAgentConfig>
>(liveAgentFrontQueryRegionAgentConfig);

/* prettier-ignore-end */
